! function(t) {
    function e(n) {
        if (r[n]) return r[n].exports;
        var o = r[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports
    }
    var n = window.webpackJsonp;
    window.webpackJsonp = function(r, i, a) {
        for (var s, c, u, l = 0, f = []; l < r.length; l++) c = r[l], o[c] && f.push(o[c][0]), o[c] = 0;
        for (s in i) Object.prototype.hasOwnProperty.call(i, s) && (t[s] = i[s]);
        for (n && n(r, i, a); f.length;) f.shift()();
        if (a)
            for (l = 0; l < a.length; l++) u = e(e.s = a[l]);
        return u
    };
    var r = {},
        o = {
            1: 0
        };
    e.e = function(t) {
        function n() {
            s.onerror = s.onload = null, clearTimeout(c);
            var e = o[t];
            0 !== e && (e && e[1](new Error("Loading chunk " + t + " failed.")), o[t] = void 0)
        }
        var r = o[t];
        if (0 === r) return new Promise(function(t) {
            t()
        });
        if (r) return r[2];
        var i = new Promise(function(e, n) {
            r = o[t] = [e, n]
        });
        r[2] = i;
        var a = document.getElementsByTagName("head")[0],
            s = document.createElement("script");
        s.type = "text/javascript", s.charset = "utf-8", s.async = !0, s.timeout = 12e4, e.nc && s.setAttribute("nonce", e.nc), s.src = e.p + "assets/js/" + t + ".js";
        var c = setTimeout(n, 12e4);
        return s.onerror = s.onload = n, a.appendChild(s), i
    }, e.m = t, e.c = r, e.d = function(t, n, r) {
        e.o(t, n) || Object.defineProperty(t, n, {
            configurable: !1,
            enumerable: !0,
            get: r
        })
    }, e.n = function(t) {
        var n = t && t.__esModule ? function() {
            return t.default
        } : function() {
            return t
        };
        return e.d(n, "a", n), n
    }, e.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, e.p = "/", e.oe = function(t) {
        throw console.error(t), t
    }, e(e.s = 13)
}({
    0: function(t, e, n) {
        "use strict";
        Object.defineProperty(e, "__esModule", {
                value: !0
            }),
            function(t) {
                /*!
                 * Vue.js v2.4.2
                 * (c) 2014-2017 Evan You
                 * Released under the MIT License.
                 */
                function n(t) {
                    return void 0 === t || null === t
                }

                function r(t) {
                    return void 0 !== t && null !== t
                }

                function o(t) {
                    return !0 === t
                }

                function i(t) {
                    return !1 === t
                }

                function a(t) {
                    return "string" == typeof t || "number" == typeof t || "boolean" == typeof t
                }

                function s(t) {
                    return null !== t && "object" == typeof t
                }

                function c(t) {
                    return "[object Object]" === er.call(t)
                }

                function u(t) {
                    return "[object RegExp]" === er.call(t)
                }

                function l(t) {
                    var e = parseFloat(t);
                    return e >= 0 && Math.floor(e) === e && isFinite(t)
                }

                function f(t) {
                    return null == t ? "" : "object" == typeof t ? JSON.stringify(t, null, 2) : String(t)
                }

                function p(t) {
                    var e = parseFloat(t);
                    return isNaN(e) ? t : e
                }

                function d(t, e) {
                    for (var n = Object.create(null), r = t.split(","), o = 0; o < r.length; o++) n[r[o]] = !0;
                    return e ? function(t) {
                        return n[t.toLowerCase()]
                    } : function(t) {
                        return n[t]
                    }
                }

                function v(t, e) {
                    if (t.length) {
                        var n = t.indexOf(e);
                        if (n > -1) return t.splice(n, 1)
                    }
                }

                function h(t, e) {
                    return rr.call(t, e)
                }

                function m(t) {
                    var e = Object.create(null);
                    return function(n) {
                        return e[n] || (e[n] = t(n))
                    }
                }

                function y(t, e) {
                    function n(n) {
                        var r = arguments.length;
                        return r ? r > 1 ? t.apply(e, arguments) : t.call(e, n) : t.call(e)
                    }
                    return n._length = t.length, n
                }

                function _(t, e) {
                    e = e || 0;
                    for (var n = t.length - e, r = new Array(n); n--;) r[n] = t[n + e];
                    return r
                }

                function g(t, e) {
                    for (var n in e) t[n] = e[n];
                    return t
                }

                function b(t) {
                    for (var e = {}, n = 0; n < t.length; n++) t[n] && g(e, t[n]);
                    return e
                }

                function C(t, e, n) {}

                function w(t, e) {
                    if (t === e) return !0;
                    var n = s(t),
                        r = s(e);
                    if (!n || !r) return !n && !r && String(t) === String(e);
                    try {
                        var o = Array.isArray(t),
                            i = Array.isArray(e);
                        if (o && i) return t.length === e.length && t.every(function(t, n) {
                            return w(t, e[n])
                        });
                        if (o || i) return !1;
                        var a = Object.keys(t),
                            c = Object.keys(e);
                        return a.length === c.length && a.every(function(n) {
                            return w(t[n], e[n])
                        })
                    } catch (t) {
                        return !1
                    }
                }

                function A(t, e) {
                    for (var n = 0; n < t.length; n++)
                        if (w(t[n], e)) return n;
                    return -1
                }

                function $(t) {
                    var e = !1;
                    return function() {
                        e || (e = !0, t.apply(this, arguments))
                    }
                }

                function x(t) {
                    var e = (t + "").charCodeAt(0);
                    return 36 === e || 95 === e
                }

                function k(t, e, n, r) {
                    Object.defineProperty(t, e, {
                        value: n,
                        enumerable: !!r,
                        writable: !0,
                        configurable: !0
                    })
                }

                function O(t) {
                    if (!mr.test(t)) {
                        var e = t.split(".");
                        return function(t) {
                            for (var n = 0; n < e.length; n++) {
                                if (!t) return;
                                t = t[e[n]]
                            }
                            return t
                        }
                    }
                }

                function S(t, e, n) {
                    if (vr.errorHandler) vr.errorHandler.call(null, t, e, n);
                    else {
                        if (!gr || "undefined" == typeof console) throw t;
                        console.error(t)
                    }
                }

                function j(t) {
                    return "function" == typeof t && /native code/.test(t.toString())
                }

                function E(t) {
                    Mr.target && Fr.push(Mr.target), Mr.target = t
                }

                function T() {
                    Mr.target = Fr.pop()
                }

                function I(t, e, n) {
                    t.__proto__ = e
                }

                function D(t, e, n) {
                    for (var r = 0, o = n.length; r < o; r++) {
                        var i = n[r];
                        k(t, i, e[i])
                    }
                }

                function P(t, e) {
                    if (s(t)) {
                        var n;
                        return h(t, "__ob__") && t.__ob__ instanceof Hr ? n = t.__ob__ : Vr.shouldConvert && !Ir() && (Array.isArray(t) || c(t)) && Object.isExtensible(t) && !t._isVue && (n = new Hr(t)), e && n && n.vmCount++, n
                    }
                }

                function L(t, e, n, r, o) {
                    var i = new Mr,
                        a = Object.getOwnPropertyDescriptor(t, e);
                    if (!a || !1 !== a.configurable) {
                        var s = a && a.get,
                            c = a && a.set,
                            u = !o && P(n);
                        Object.defineProperty(t, e, {
                            enumerable: !0,
                            configurable: !0,
                            get: function() {
                                var e = s ? s.call(t) : n;
                                return Mr.target && (i.depend(), u && u.dep.depend(), Array.isArray(e) && F(e)), e
                            },
                            set: function(e) {
                                var r = s ? s.call(t) : n;
                                e === r || e !== e && r !== r || (c ? c.call(t, e) : n = e, u = !o && P(e), i.notify())
                            }
                        })
                    }
                }

                function N(t, e, n) {
                    if (Array.isArray(t) && l(e)) return t.length = Math.max(t.length, e), t.splice(e, 1, n), n;
                    if (h(t, e)) return t[e] = n, n;
                    var r = t.__ob__;
                    return t._isVue || r && r.vmCount ? n : r ? (L(r.value, e, n), r.dep.notify(), n) : (t[e] = n, n)
                }

                function M(t, e) {
                    if (Array.isArray(t) && l(e)) return void t.splice(e, 1);
                    var n = t.__ob__;
                    t._isVue || n && n.vmCount || h(t, e) && (delete t[e], n && n.dep.notify())
                }

                function F(t) {
                    for (var e = void 0, n = 0, r = t.length; n < r; n++) e = t[n], e && e.__ob__ && e.__ob__.dep.depend(), Array.isArray(e) && F(e)
                }

                function R(t, e) {
                    if (!e) return t;
                    for (var n, r, o, i = Object.keys(e), a = 0; a < i.length; a++) n = i[a], r = t[n], o = e[n], h(t, n) ? c(r) && c(o) && R(r, o) : N(t, n, o);
                    return t
                }

                function U(t, e, n) {
                    return n ? t || e ? function() {
                        var r = "function" == typeof e ? e.call(n) : e,
                            o = "function" == typeof t ? t.call(n) : void 0;
                        return r ? R(r, o) : o
                    } : void 0 : e ? t ? function() {
                        return R("function" == typeof e ? e.call(this) : e, "function" == typeof t ? t.call(this) : t)
                    } : e : t
                }

                function B(t, e) {
                    return e ? t ? t.concat(e) : Array.isArray(e) ? e : [e] : t
                }

                function V(t, e) {
                    var n = Object.create(t || null);
                    return e ? g(n, e) : n
                }

                function H(t) {
                    var e = t.props;
                    if (e) {
                        var n, r, o, i = {};
                        if (Array.isArray(e))
                            for (n = e.length; n--;) "string" == typeof(r = e[n]) && (o = ir(r), i[o] = {
                                type: null
                            });
                        else if (c(e))
                            for (var a in e) r = e[a], o = ir(a), i[o] = c(r) ? r : {
                                type: r
                            };
                        t.props = i
                    }
                }

                function z(t) {
                    var e = t.inject;
                    if (Array.isArray(e))
                        for (var n = t.inject = {}, r = 0; r < e.length; r++) n[e[r]] = e[r]
                }

                function W(t) {
                    var e = t.directives;
                    if (e)
                        for (var n in e) {
                            var r = e[n];
                            "function" == typeof r && (e[n] = {
                                bind: r,
                                update: r
                            })
                        }
                }

                function q(t, e, n) {
                    function r(r) {
                        var o = zr[r] || Wr;
                        c[r] = o(t[r], e[r], n, r)
                    }
                    "function" == typeof e && (e = e.options), H(e), z(e), W(e);
                    var o = e.extends;
                    if (o && (t = q(t, o, n)), e.mixins)
                        for (var i = 0, a = e.mixins.length; i < a; i++) t = q(t, e.mixins[i], n);
                    var s, c = {};
                    for (s in t) r(s);
                    for (s in e) h(t, s) || r(s);
                    return c
                }

                function K(t, e, n, r) {
                    if ("string" == typeof n) {
                        var o = t[e];
                        if (h(o, n)) return o[n];
                        var i = ir(n);
                        if (h(o, i)) return o[i];
                        var a = ar(i);
                        if (h(o, a)) return o[a];
                        return o[n] || o[i] || o[a]
                    }
                }

                function J(t, e, n, r) {
                    var o = e[t],
                        i = !h(n, t),
                        a = n[t];
                    if (Q(Boolean, o.type) && (i && !h(o, "default") ? a = !1 : Q(String, o.type) || "" !== a && a !== cr(t) || (a = !0)), void 0 === a) {
                        a = G(r, o, t);
                        var s = Vr.shouldConvert;
                        Vr.shouldConvert = !0, P(a), Vr.shouldConvert = s
                    }
                    return a
                }

                function G(t, e, n) {
                    if (h(e, "default")) {
                        var r = e.default;
                        return t && t.$options.propsData && void 0 === t.$options.propsData[n] && void 0 !== t._props[n] ? t._props[n] : "function" == typeof r && "Function" !== Z(e.type) ? r.call(t) : r
                    }
                }

                function Z(t) {
                    var e = t && t.toString().match(/^\s*function (\w+)/);
                    return e ? e[1] : ""
                }

                function Q(t, e) {
                    if (!Array.isArray(e)) return Z(e) === Z(t);
                    for (var n = 0, r = e.length; n < r; n++)
                        if (Z(e[n]) === Z(t)) return !0;
                    return !1
                }

                function X(t) {
                    return new qr(void 0, void 0, void 0, String(t))
                }

                function Y(t) {
                    var e = new qr(t.tag, t.data, t.children, t.text, t.elm, t.context, t.componentOptions, t.asyncFactory);
                    return e.ns = t.ns, e.isStatic = t.isStatic, e.key = t.key, e.isComment = t.isComment, e.isCloned = !0, e
                }

                function tt(t) {
                    for (var e = t.length, n = new Array(e), r = 0; r < e; r++) n[r] = Y(t[r]);
                    return n
                }

                function et(t) {
                    function e() {
                        var t = arguments,
                            n = e.fns;
                        if (!Array.isArray(n)) return n.apply(null, arguments);
                        for (var r = n.slice(), o = 0; o < r.length; o++) r[o].apply(null, t)
                    }
                    return e.fns = t, e
                }

                function nt(t, e, r, o, i) {
                    var a, s, c, u;
                    for (a in t) s = t[a], c = e[a], u = Zr(a), n(s) || (n(c) ? (n(s.fns) && (s = t[a] = et(s)), r(u.name, s, u.once, u.capture, u.passive)) : s !== c && (c.fns = s, t[a] = c));
                    for (a in e) n(t[a]) && (u = Zr(a), o(u.name, e[a], u.capture))
                }

                function rt(t, e, i) {
                    function a() {
                        i.apply(this, arguments), v(s.fns, a)
                    }
                    var s, c = t[e];
                    n(c) ? s = et([a]) : r(c.fns) && o(c.merged) ? (s = c, s.fns.push(a)) : s = et([c, a]), s.merged = !0, t[e] = s
                }

                function ot(t, e, o) {
                    var i = e.options.props;
                    if (!n(i)) {
                        var a = {},
                            s = t.attrs,
                            c = t.props;
                        if (r(s) || r(c))
                            for (var u in i) {
                                var l = cr(u);
                                it(a, c, u, l, !0) || it(a, s, u, l, !1)
                            }
                        return a
                    }
                }

                function it(t, e, n, o, i) {
                    if (r(e)) {
                        if (h(e, n)) return t[n] = e[n], i || delete e[n], !0;
                        if (h(e, o)) return t[n] = e[o], i || delete e[o], !0
                    }
                    return !1
                }

                function at(t) {
                    for (var e = 0; e < t.length; e++)
                        if (Array.isArray(t[e])) return Array.prototype.concat.apply([], t);
                    return t
                }

                function st(t) {
                    return a(t) ? [X(t)] : Array.isArray(t) ? ut(t) : void 0
                }

                function ct(t) {
                    return r(t) && r(t.text) && i(t.isComment)
                }

                function ut(t, e) {
                    var i, s, c, u = [];
                    for (i = 0; i < t.length; i++) s = t[i], n(s) || "boolean" == typeof s || (c = u[u.length - 1], Array.isArray(s) ? u.push.apply(u, ut(s, (e || "") + "_" + i)) : a(s) ? ct(c) ? c.text += String(s) : "" !== s && u.push(X(s)) : ct(s) && ct(c) ? u[u.length - 1] = X(c.text + s.text) : (o(t._isVList) && r(s.tag) && n(s.key) && r(e) && (s.key = "__vlist" + e + "_" + i + "__"), u.push(s)));
                    return u
                }

                function lt(t, e) {
                    return t.__esModule && t.default && (t = t.default), s(t) ? e.extend(t) : t
                }

                function ft(t, e, n, r, o) {
                    var i = Gr();
                    return i.asyncFactory = t, i.asyncMeta = {
                        data: e,
                        context: n,
                        children: r,
                        tag: o
                    }, i
                }

                function pt(t, e, i) {
                    if (o(t.error) && r(t.errorComp)) return t.errorComp;
                    if (r(t.resolved)) return t.resolved;
                    if (o(t.loading) && r(t.loadingComp)) return t.loadingComp;
                    if (!r(t.contexts)) {
                        var a = t.contexts = [i],
                            c = !0,
                            u = function() {
                                for (var t = 0, e = a.length; t < e; t++) a[t].$forceUpdate()
                            },
                            l = $(function(n) {
                                t.resolved = lt(n, e), c || u()
                            }),
                            f = $(function(e) {
                                r(t.errorComp) && (t.error = !0, u())
                            }),
                            p = t(l, f);
                        return s(p) && ("function" == typeof p.then ? n(t.resolved) && p.then(l, f) : r(p.component) && "function" == typeof p.component.then && (p.component.then(l, f), r(p.error) && (t.errorComp = lt(p.error, e)), r(p.loading) && (t.loadingComp = lt(p.loading, e), 0 === p.delay ? t.loading = !0 : setTimeout(function() {
                            n(t.resolved) && n(t.error) && (t.loading = !0, u())
                        }, p.delay || 200)), r(p.timeout) && setTimeout(function() {
                            n(t.resolved) && f(null)
                        }, p.timeout))), c = !1, t.loading ? t.loadingComp : t.resolved
                    }
                    t.contexts.push(i)
                }

                function dt(t) {
                    if (Array.isArray(t))
                        for (var e = 0; e < t.length; e++) {
                            var n = t[e];
                            if (r(n) && r(n.componentOptions)) return n
                        }
                }

                function vt(t) {
                    t._events = Object.create(null), t._hasHookEvent = !1;
                    var e = t.$options._parentListeners;
                    e && yt(t, e)
                }

                function ht(t, e, n) {
                    n ? Jr.$once(t, e) : Jr.$on(t, e)
                }

                function mt(t, e) {
                    Jr.$off(t, e)
                }

                function yt(t, e, n) {
                    Jr = t, nt(e, n || {}, ht, mt, t)
                }

                function _t(t, e) {
                    var n = {};
                    if (!t) return n;
                    for (var r = [], o = 0, i = t.length; o < i; o++) {
                        var a = t[o];
                        if (a.context !== e && a.functionalContext !== e || !a.data || null == a.data.slot) r.push(a);
                        else {
                            var s = a.data.slot,
                                c = n[s] || (n[s] = []);
                            "template" === a.tag ? c.push.apply(c, a.children) : c.push(a)
                        }
                    }
                    return r.every(gt) || (n.default = r), n
                }

                function gt(t) {
                    return t.isComment || " " === t.text
                }

                function bt(t, e) {
                    e = e || {};
                    for (var n = 0; n < t.length; n++) Array.isArray(t[n]) ? bt(t[n], e) : e[t[n].key] = t[n].fn;
                    return e
                }

                function Ct(t) {
                    var e = t.$options,
                        n = e.parent;
                    if (n && !e.abstract) {
                        for (; n.$options.abstract && n.$parent;) n = n.$parent;
                        n.$children.push(t)
                    }
                    t.$parent = n, t.$root = n ? n.$root : t, t.$children = [], t.$refs = {}, t._watcher = null, t._inactive = null, t._directInactive = !1, t._isMounted = !1, t._isDestroyed = !1, t._isBeingDestroyed = !1
                }

                function wt(t, e, n) {
                    t.$el = e, t.$options.render || (t.$options.render = Gr), Ot(t, "beforeMount");
                    var r;
                    return r = function() {
                        t._update(t._render(), n)
                    }, t._watcher = new io(t, r, C), n = !1, null == t.$vnode && (t._isMounted = !0, Ot(t, "mounted")), t
                }

                function At(t, e, n, r, o) {
                    var i = !!(o || t.$options._renderChildren || r.data.scopedSlots || t.$scopedSlots !== hr);
                    if (t.$options._parentVnode = r, t.$vnode = r, t._vnode && (t._vnode.parent = r), t.$options._renderChildren = o, t.$attrs = r.data && r.data.attrs, t.$listeners = n, e && t.$options.props) {
                        Vr.shouldConvert = !1;
                        for (var a = t._props, s = t.$options._propKeys || [], c = 0; c < s.length; c++) {
                            var u = s[c];
                            a[u] = J(u, t.$options.props, e, t)
                        }
                        Vr.shouldConvert = !0, t.$options.propsData = e
                    }
                    if (n) {
                        var l = t.$options._parentListeners;
                        t.$options._parentListeners = n, yt(t, n, l)
                    }
                    i && (t.$slots = _t(o, r.context), t.$forceUpdate())
                }

                function $t(t) {
                    for (; t && (t = t.$parent);)
                        if (t._inactive) return !0;
                    return !1
                }

                function xt(t, e) {
                    if (e) {
                        if (t._directInactive = !1, $t(t)) return
                    } else if (t._directInactive) return;
                    if (t._inactive || null === t._inactive) {
                        t._inactive = !1;
                        for (var n = 0; n < t.$children.length; n++) xt(t.$children[n]);
                        Ot(t, "activated")
                    }
                }

                function kt(t, e) {
                    if (!(e && (t._directInactive = !0, $t(t)) || t._inactive)) {
                        t._inactive = !0;
                        for (var n = 0; n < t.$children.length; n++) kt(t.$children[n]);
                        Ot(t, "deactivated")
                    }
                }

                function Ot(t, e) {
                    var n = t.$options[e];
                    if (n)
                        for (var r = 0, o = n.length; r < o; r++) try {
                            n[r].call(t)
                        } catch (n) {
                            S(n, t, e + " hook")
                        }
                    t._hasHookEvent && t.$emit("hook:" + e)
                }

                function St() {
                    ro = Xr.length = Yr.length = 0, to = {}, eo = no = !1
                }

                function jt() {
                    no = !0;
                    var t, e;
                    for (Xr.sort(function(t, e) {
                            return t.id - e.id
                        }), ro = 0; ro < Xr.length; ro++) t = Xr[ro], e = t.id, to[e] = null, t.run();
                    var n = Yr.slice(),
                        r = Xr.slice();
                    St(), It(n), Et(r), Dr && vr.devtools && Dr.emit("flush")
                }

                function Et(t) {
                    for (var e = t.length; e--;) {
                        var n = t[e],
                            r = n.vm;
                        r._watcher === n && r._isMounted && Ot(r, "updated")
                    }
                }

                function Tt(t) {
                    t._inactive = !1, Yr.push(t)
                }

                function It(t) {
                    for (var e = 0; e < t.length; e++) t[e]._inactive = !0, xt(t[e], !0)
                }

                function Dt(t) {
                    var e = t.id;
                    if (null == to[e]) {
                        if (to[e] = !0, no) {
                            for (var n = Xr.length - 1; n > ro && Xr[n].id > t.id;) n--;
                            Xr.splice(n + 1, 0, t)
                        } else Xr.push(t);
                        eo || (eo = !0, Lr(jt))
                    }
                }

                function Pt(t) {
                    ao.clear(), Lt(t, ao)
                }

                function Lt(t, e) {
                    var n, r, o = Array.isArray(t);
                    if ((o || s(t)) && Object.isExtensible(t)) {
                        if (t.__ob__) {
                            var i = t.__ob__.dep.id;
                            if (e.has(i)) return;
                            e.add(i)
                        }
                        if (o)
                            for (n = t.length; n--;) Lt(t[n], e);
                        else
                            for (r = Object.keys(t), n = r.length; n--;) Lt(t[r[n]], e)
                    }
                }

                function Nt(t, e, n) {
                    so.get = function() {
                        return this[e][n]
                    }, so.set = function(t) {
                        this[e][n] = t
                    }, Object.defineProperty(t, n, so)
                }

                function Mt(t) {
                    t._watchers = [];
                    var e = t.$options;
                    e.props && Ft(t, e.props), e.methods && zt(t, e.methods), e.data ? Rt(t) : P(t._data = {}, !0), e.computed && Bt(t, e.computed), e.watch && e.watch !== Or && Wt(t, e.watch)
                }

                function Ft(t, e) {
                    var n = t.$options.propsData || {},
                        r = t._props = {},
                        o = t.$options._propKeys = [],
                        i = !t.$parent;
                    Vr.shouldConvert = i;
                    for (var a in e) ! function(i) {
                        o.push(i);
                        var a = J(i, e, n, t);
                        L(r, i, a), i in t || Nt(t, "_props", i)
                    }(a);
                    Vr.shouldConvert = !0
                }

                function Rt(t) {
                    var e = t.$options.data;
                    e = t._data = "function" == typeof e ? Ut(e, t) : e || {}, c(e) || (e = {});
                    for (var n = Object.keys(e), r = t.$options.props, o = (t.$options.methods, n.length); o--;) {
                        var i = n[o];
                        r && h(r, i) || x(i) || Nt(t, "_data", i)
                    }
                    P(e, !0)
                }

                function Ut(t, e) {
                    try {
                        return t.call(e)
                    } catch (t) {
                        return S(t, e, "data()"), {}
                    }
                }

                function Bt(t, e) {
                    var n = t._computedWatchers = Object.create(null);
                    for (var r in e) {
                        var o = e[r],
                            i = "function" == typeof o ? o : o.get;
                        n[r] = new io(t, i || C, C, co), r in t || Vt(t, r, o)
                    }
                }

                function Vt(t, e, n) {
                    "function" == typeof n ? (so.get = Ht(e), so.set = C) : (so.get = n.get ? !1 !== n.cache ? Ht(e) : n.get : C, so.set = n.set ? n.set : C), Object.defineProperty(t, e, so)
                }

                function Ht(t) {
                    return function() {
                        var e = this._computedWatchers && this._computedWatchers[t];
                        if (e) return e.dirty && e.evaluate(), Mr.target && e.depend(), e.value
                    }
                }

                function zt(t, e) {
                    t.$options.props;
                    for (var n in e) t[n] = null == e[n] ? C : y(e[n], t)
                }

                function Wt(t, e) {
                    for (var n in e) {
                        var r = e[n];
                        if (Array.isArray(r))
                            for (var o = 0; o < r.length; o++) qt(t, n, r[o]);
                        else qt(t, n, r)
                    }
                }

                function qt(t, e, n, r) {
                    return c(n) && (r = n, n = n.handler), "string" == typeof n && (n = t[n]), t.$watch(e, n, r)
                }

                function Kt(t) {
                    var e = t.$options.provide;
                    e && (t._provided = "function" == typeof e ? e.call(t) : e)
                }

                function Jt(t) {
                    var e = Gt(t.$options.inject, t);
                    e && (Vr.shouldConvert = !1, Object.keys(e).forEach(function(n) {
                        L(t, n, e[n])
                    }), Vr.shouldConvert = !0)
                }

                function Gt(t, e) {
                    if (t) {
                        for (var n = Object.create(null), r = Pr ? Reflect.ownKeys(t) : Object.keys(t), o = 0; o < r.length; o++)
                            for (var i = r[o], a = t[i], s = e; s;) {
                                if (s._provided && a in s._provided) {
                                    n[i] = s._provided[a];
                                    break
                                }
                                s = s.$parent
                            }
                        return n
                    }
                }

                function Zt(t, e, n, o, i) {
                    var a = {},
                        s = t.options.props;
                    if (r(s))
                        for (var c in s) a[c] = J(c, s, e || {});
                    else r(n.attrs) && Qt(a, n.attrs), r(n.props) && Qt(a, n.props);
                    var u = Object.create(o),
                        l = function(t, e, n, r) {
                            return re(u, t, e, n, r, !0)
                        },
                        f = t.options.render.call(null, l, {
                            data: n,
                            props: a,
                            children: i,
                            parent: o,
                            listeners: n.on || {},
                            injections: Gt(t.options.inject, o),
                            slots: function() {
                                return _t(i, o)
                            }
                        });
                    return f instanceof qr && (f.functionalContext = o, f.functionalOptions = t.options, n.slot && ((f.data || (f.data = {})).slot = n.slot)), f
                }

                function Qt(t, e) {
                    for (var n in e) t[ir(n)] = e[n]
                }

                function Xt(t, e, i, a, c) {
                    if (!n(t)) {
                        var u = i.$options._base;
                        if (s(t) && (t = u.extend(t)), "function" == typeof t) {
                            var l;
                            if (n(t.cid) && (l = t, void 0 === (t = pt(l, u, i)))) return ft(l, e, i, a, c);
                            e = e || {}, _e(t), r(e.model) && ne(t.options, e);
                            var f = ot(e, t, c);
                            if (o(t.options.functional)) return Zt(t, f, e, i, a);
                            var p = e.on;
                            if (e.on = e.nativeOn, o(t.options.abstract)) {
                                var d = e.slot;
                                e = {}, d && (e.slot = d)
                            }
                            te(e);
                            var v = t.options.name || c;
                            return new qr("vue-component-" + t.cid + (v ? "-" + v : ""), e, void 0, void 0, void 0, i, {
                                Ctor: t,
                                propsData: f,
                                listeners: p,
                                tag: c,
                                children: a
                            }, l)
                        }
                    }
                }

                function Yt(t, e, n, o) {
                    var i = t.componentOptions,
                        a = {
                            _isComponent: !0,
                            parent: e,
                            propsData: i.propsData,
                            _componentTag: i.tag,
                            _parentVnode: t,
                            _parentListeners: i.listeners,
                            _renderChildren: i.children,
                            _parentElm: n || null,
                            _refElm: o || null
                        },
                        s = t.data.inlineTemplate;
                    return r(s) && (a.render = s.render, a.staticRenderFns = s.staticRenderFns), new i.Ctor(a)
                }

                function te(t) {
                    t.hook || (t.hook = {});
                    for (var e = 0; e < lo.length; e++) {
                        var n = lo[e],
                            r = t.hook[n],
                            o = uo[n];
                        t.hook[n] = r ? ee(o, r) : o
                    }
                }

                function ee(t, e) {
                    return function(n, r, o, i) {
                        t(n, r, o, i), e(n, r, o, i)
                    }
                }

                function ne(t, e) {
                    var n = t.model && t.model.prop || "value",
                        o = t.model && t.model.event || "input";
                    (e.props || (e.props = {}))[n] = e.model.value;
                    var i = e.on || (e.on = {});
                    r(i[o]) ? i[o] = [e.model.callback].concat(i[o]) : i[o] = e.model.callback
                }

                function re(t, e, n, r, i, s) {
                    return (Array.isArray(n) || a(n)) && (i = r, r = n, n = void 0), o(s) && (i = po), oe(t, e, n, r, i)
                }

                function oe(t, e, n, o, i) {
                    if (r(n) && r(n.__ob__)) return Gr();
                    if (r(n) && r(n.is) && (e = n.is), !e) return Gr();
                    Array.isArray(o) && "function" == typeof o[0] && (n = n || {}, n.scopedSlots = {
                        default: o[0]
                    }, o.length = 0), i === po ? o = st(o) : i === fo && (o = at(o));
                    var a, s;
                    if ("string" == typeof e) {
                        var c;
                        s = vr.getTagNamespace(e), a = vr.isReservedTag(e) ? new qr(vr.parsePlatformTagName(e), n, o, void 0, void 0, t) : r(c = K(t.$options, "components", e)) ? Xt(c, n, t, o, e) : new qr(e, n, o, void 0, void 0, t)
                    } else a = Xt(e, n, t, o);
                    return r(a) ? (s && ie(a, s), a) : Gr()
                }

                function ie(t, e) {
                    if (t.ns = e, "foreignObject" !== t.tag && r(t.children))
                        for (var o = 0, i = t.children.length; o < i; o++) {
                            var a = t.children[o];
                            r(a.tag) && n(a.ns) && ie(a, e)
                        }
                }

                function ae(t, e) {
                    var n, o, i, a, c;
                    if (Array.isArray(t) || "string" == typeof t)
                        for (n = new Array(t.length), o = 0, i = t.length; o < i; o++) n[o] = e(t[o], o);
                    else if ("number" == typeof t)
                        for (n = new Array(t), o = 0; o < t; o++) n[o] = e(o + 1, o);
                    else if (s(t))
                        for (a = Object.keys(t), n = new Array(a.length), o = 0, i = a.length; o < i; o++) c = a[o], n[o] = e(t[c], c, o);
                    return r(n) && (n._isVList = !0), n
                }

                function se(t, e, n, r) {
                    var o = this.$scopedSlots[t];
                    if (o) return n = n || {}, r && (n = g(g({}, r), n)), o(n) || e;
                    var i = this.$slots[t];
                    return i || e
                }

                function ce(t) {
                    return K(this.$options, "filters", t, !0) || lr
                }

                function ue(t, e, n) {
                    var r = vr.keyCodes[e] || n;
                    return Array.isArray(r) ? -1 === r.indexOf(t) : r !== t
                }

                function le(t, e, n, r, o) {
                    if (n)
                        if (s(n)) {
                            Array.isArray(n) && (n = b(n));
                            var i;
                            for (var a in n) ! function(a) {
                                if ("class" === a || "style" === a || nr(a)) i = t;
                                else {
                                    var s = t.attrs && t.attrs.type;
                                    i = r || vr.mustUseProp(e, s, a) ? t.domProps || (t.domProps = {}) : t.attrs || (t.attrs = {})
                                }
                                if (!(a in i) && (i[a] = n[a], o)) {
                                    (t.on || (t.on = {}))["update:" + a] = function(t) {
                                        n[a] = t
                                    }
                                }
                            }(a)
                        } else;
                    return t
                }

                function fe(t, e) {
                    var n = this._staticTrees[t];
                    return n && !e ? Array.isArray(n) ? tt(n) : Y(n) : (n = this._staticTrees[t] = this.$options.staticRenderFns[t].call(this._renderProxy), de(n, "__static__" + t, !1), n)
                }

                function pe(t, e, n) {
                    return de(t, "__once__" + e + (n ? "_" + n : ""), !0), t
                }

                function de(t, e, n) {
                    if (Array.isArray(t))
                        for (var r = 0; r < t.length; r++) t[r] && "string" != typeof t[r] && ve(t[r], e + "_" + r, n);
                    else ve(t, e, n)
                }

                function ve(t, e, n) {
                    t.isStatic = !0, t.key = e, t.isOnce = n
                }

                function he(t, e) {
                    if (e)
                        if (c(e)) {
                            var n = t.on = t.on ? g({}, t.on) : {};
                            for (var r in e) {
                                var o = n[r],
                                    i = e[r];
                                n[r] = o ? [].concat(i, o) : i
                            }
                        } else;
                    return t
                }

                function me(t) {
                    t._vnode = null, t._staticTrees = null;
                    var e = t.$vnode = t.$options._parentVnode,
                        n = e && e.context;
                    t.$slots = _t(t.$options._renderChildren, n), t.$scopedSlots = hr, t._c = function(e, n, r, o) {
                        return re(t, e, n, r, o, !1)
                    }, t.$createElement = function(e, n, r, o) {
                        return re(t, e, n, r, o, !0)
                    };
                    var r = e && e.data;
                    L(t, "$attrs", r && r.attrs, null, !0), L(t, "$listeners", t.$options._parentListeners, null, !0)
                }

                function ye(t, e) {
                    var n = t.$options = Object.create(t.constructor.options);
                    n.parent = e.parent, n.propsData = e.propsData, n._parentVnode = e._parentVnode, n._parentListeners = e._parentListeners, n._renderChildren = e._renderChildren, n._componentTag = e._componentTag, n._parentElm = e._parentElm, n._refElm = e._refElm, e.render && (n.render = e.render, n.staticRenderFns = e.staticRenderFns)
                }

                function _e(t) {
                    var e = t.options;
                    if (t.super) {
                        var n = _e(t.super);
                        if (n !== t.superOptions) {
                            t.superOptions = n;
                            var r = ge(t);
                            r && g(t.extendOptions, r), e = t.options = q(n, t.extendOptions), e.name && (e.components[e.name] = t)
                        }
                    }
                    return e
                }

                function ge(t) {
                    var e, n = t.options,
                        r = t.extendOptions,
                        o = t.sealedOptions;
                    for (var i in n) n[i] !== o[i] && (e || (e = {}), e[i] = be(n[i], r[i], o[i]));
                    return e
                }

                function be(t, e, n) {
                    if (Array.isArray(t)) {
                        var r = [];
                        n = Array.isArray(n) ? n : [n], e = Array.isArray(e) ? e : [e];
                        for (var o = 0; o < t.length; o++)(e.indexOf(t[o]) >= 0 || n.indexOf(t[o]) < 0) && r.push(t[o]);
                        return r
                    }
                    return t
                }

                function Ce(t) {
                    this._init(t)
                }

                function we(t) {
                    t.use = function(t) {
                        var e = this._installedPlugins || (this._installedPlugins = []);
                        if (e.indexOf(t) > -1) return this;
                        var n = _(arguments, 1);
                        return n.unshift(this), "function" == typeof t.install ? t.install.apply(t, n) : "function" == typeof t && t.apply(null, n), e.push(t), this
                    }
                }

                function Ae(t) {
                    t.mixin = function(t) {
                        return this.options = q(this.options, t), this
                    }
                }

                function $e(t) {
                    t.cid = 0;
                    var e = 1;
                    t.extend = function(t) {
                        t = t || {};
                        var n = this,
                            r = n.cid,
                            o = t._Ctor || (t._Ctor = {});
                        if (o[r]) return o[r];
                        var i = t.name || n.options.name,
                            a = function(t) {
                                this._init(t)
                            };
                        return a.prototype = Object.create(n.prototype), a.prototype.constructor = a, a.cid = e++, a.options = q(n.options, t), a.super = n, a.options.props && xe(a), a.options.computed && ke(a), a.extend = n.extend, a.mixin = n.mixin, a.use = n.use, pr.forEach(function(t) {
                            a[t] = n[t]
                        }), i && (a.options.components[i] = a), a.superOptions = n.options, a.extendOptions = t, a.sealedOptions = g({}, a.options), o[r] = a, a
                    }
                }

                function xe(t) {
                    var e = t.options.props;
                    for (var n in e) Nt(t.prototype, "_props", n)
                }

                function ke(t) {
                    var e = t.options.computed;
                    for (var n in e) Vt(t.prototype, n, e[n])
                }

                function Oe(t) {
                    pr.forEach(function(e) {
                        t[e] = function(t, n) {
                            return n ? ("component" === e && c(n) && (n.name = n.name || t, n = this.options._base.extend(n)), "directive" === e && "function" == typeof n && (n = {
                                bind: n,
                                update: n
                            }), this.options[e + "s"][t] = n, n) : this.options[e + "s"][t]
                        }
                    })
                }

                function Se(t) {
                    return t && (t.Ctor.options.name || t.tag)
                }

                function je(t, e) {
                    return Array.isArray(t) ? t.indexOf(e) > -1 : "string" == typeof t ? t.split(",").indexOf(e) > -1 : !!u(t) && t.test(e)
                }

                function Ee(t, e, n) {
                    for (var r in t) {
                        var o = t[r];
                        if (o) {
                            var i = Se(o.componentOptions);
                            i && !n(i) && (o !== e && Te(o), t[r] = null)
                        }
                    }
                }

                function Te(t) {
                    t && t.componentInstance.$destroy()
                }

                function Ie(t) {
                    for (var e = t.data, n = t, o = t; r(o.componentInstance);) o = o.componentInstance._vnode, o.data && (e = De(o.data, e));
                    for (; r(n = n.parent);) n.data && (e = De(e, n.data));
                    return Pe(e.staticClass, e.class)
                }

                function De(t, e) {
                    return {
                        staticClass: Le(t.staticClass, e.staticClass),
                        class: r(t.class) ? [t.class, e.class] : e.class
                    }
                }

                function Pe(t, e) {
                    return r(t) || r(e) ? Le(t, Ne(e)) : ""
                }

                function Le(t, e) {
                    return t ? e ? t + " " + e : t : e || ""
                }

                function Ne(t) {
                    return Array.isArray(t) ? Me(t) : s(t) ? Fe(t) : "string" == typeof t ? t : ""
                }

                function Me(t) {
                    for (var e, n = "", o = 0, i = t.length; o < i; o++) r(e = Ne(t[o])) && "" !== e && (n && (n += " "), n += e);
                    return n
                }

                function Fe(t) {
                    var e = "";
                    for (var n in t) t[n] && (e && (e += " "), e += n);
                    return e
                }

                function Re(t) {
                    return To(t) ? "svg" : "math" === t ? "math" : void 0
                }

                function Ue(t) {
                    if (!gr) return !0;
                    if (Io(t)) return !1;
                    if (t = t.toLowerCase(), null != Do[t]) return Do[t];
                    var e = document.createElement(t);
                    return t.indexOf("-") > -1 ? Do[t] = e.constructor === window.HTMLUnknownElement || e.constructor === window.HTMLElement : Do[t] = /HTMLUnknownElement/.test(e.toString())
                }

                function Be(t) {
                    if ("string" == typeof t) {
                        var e = document.querySelector(t);
                        return e || document.createElement("div")
                    }
                    return t
                }

                function Ve(t, e) {
                    var n = document.createElement(t);
                    return "select" !== t ? n : (e.data && e.data.attrs && void 0 !== e.data.attrs.multiple && n.setAttribute("multiple", "multiple"), n)
                }

                function He(t, e) {
                    return document.createElementNS(jo[t], e)
                }

                function ze(t) {
                    return document.createTextNode(t)
                }

                function We(t) {
                    return document.createComment(t)
                }

                function qe(t, e, n) {
                    t.insertBefore(e, n)
                }

                function Ke(t, e) {
                    t.removeChild(e)
                }

                function Je(t, e) {
                    t.appendChild(e)
                }

                function Ge(t) {
                    return t.parentNode
                }

                function Ze(t) {
                    return t.nextSibling
                }

                function Qe(t) {
                    return t.tagName
                }

                function Xe(t, e) {
                    t.textContent = e
                }

                function Ye(t, e, n) {
                    t.setAttribute(e, n)
                }

                function tn(t, e) {
                    var n = t.data.ref;
                    if (n) {
                        var r = t.context,
                            o = t.componentInstance || t.elm,
                            i = r.$refs;
                        e ? Array.isArray(i[n]) ? v(i[n], o) : i[n] === o && (i[n] = void 0) : t.data.refInFor ? Array.isArray(i[n]) ? i[n].indexOf(o) < 0 && i[n].push(o) : i[n] = [o] : i[n] = o
                    }
                }

                function en(t, e) {
                    return t.key === e.key && (t.tag === e.tag && t.isComment === e.isComment && r(t.data) === r(e.data) && nn(t, e) || o(t.isAsyncPlaceholder) && t.asyncFactory === e.asyncFactory && n(e.asyncFactory.error))
                }

                function nn(t, e) {
                    if ("input" !== t.tag) return !0;
                    var n;
                    return (r(n = t.data) && r(n = n.attrs) && n.type) === (r(n = e.data) && r(n = n.attrs) && n.type)
                }

                function rn(t, e, n) {
                    var o, i, a = {};
                    for (o = e; o <= n; ++o) i = t[o].key, r(i) && (a[i] = o);
                    return a
                }

                function on(t, e) {
                    (t.data.directives || e.data.directives) && an(t, e)
                }

                function an(t, e) {
                    var n, r, o, i = t === No,
                        a = e === No,
                        s = sn(t.data.directives, t.context),
                        c = sn(e.data.directives, e.context),
                        u = [],
                        l = [];
                    for (n in c) r = s[n], o = c[n], r ? (o.oldValue = r.value, un(o, "update", e, t), o.def && o.def.componentUpdated && l.push(o)) : (un(o, "bind", e, t), o.def && o.def.inserted && u.push(o));
                    if (u.length) {
                        var f = function() {
                            for (var n = 0; n < u.length; n++) un(u[n], "inserted", e, t)
                        };
                        i ? rt(e.data.hook || (e.data.hook = {}), "insert", f) : f()
                    }
                    if (l.length && rt(e.data.hook || (e.data.hook = {}), "postpatch", function() {
                            for (var n = 0; n < l.length; n++) un(l[n], "componentUpdated", e, t)
                        }), !i)
                        for (n in s) c[n] || un(s[n], "unbind", t, t, a)
                }

                function sn(t, e) {
                    var n = Object.create(null);
                    if (!t) return n;
                    var r, o;
                    for (r = 0; r < t.length; r++) o = t[r], o.modifiers || (o.modifiers = Ro), n[cn(o)] = o, o.def = K(e.$options, "directives", o.name, !0);
                    return n
                }

                function cn(t) {
                    return t.rawName || t.name + "." + Object.keys(t.modifiers || {}).join(".")
                }

                function un(t, e, n, r, o) {
                    var i = t.def && t.def[e];
                    if (i) try {
                        i(n.elm, t, n, r, o)
                    } catch (r) {
                        S(r, n.context, "directive " + t.name + " " + e + " hook")
                    }
                }

                function ln(t, e) {
                    var o = e.componentOptions;
                    if (!(r(o) && !1 === o.Ctor.options.inheritAttrs || n(t.data.attrs) && n(e.data.attrs))) {
                        var i, a, s = e.elm,
                            c = t.data.attrs || {},
                            u = e.data.attrs || {};
                        r(u.__ob__) && (u = e.data.attrs = g({}, u));
                        for (i in u) a = u[i], c[i] !== a && fn(s, i, a);
                        wr && u.value !== c.value && fn(s, "value", u.value);
                        for (i in c) n(u[i]) && (ko(i) ? s.removeAttributeNS(xo, Oo(i)) : Ao(i) || s.removeAttribute(i))
                    }
                }

                function fn(t, e, n) {
                    $o(e) ? So(n) ? t.removeAttribute(e) : t.setAttribute(e, e) : Ao(e) ? t.setAttribute(e, So(n) || "false" === n ? "false" : "true") : ko(e) ? So(n) ? t.removeAttributeNS(xo, Oo(e)) : t.setAttributeNS(xo, e, n) : So(n) ? t.removeAttribute(e) : t.setAttribute(e, n)
                }

                function pn(t, e) {
                    var o = e.elm,
                        i = e.data,
                        a = t.data;
                    if (!(n(i.staticClass) && n(i.class) && (n(a) || n(a.staticClass) && n(a.class)))) {
                        var s = Ie(e),
                            c = o._transitionClasses;
                        r(c) && (s = Le(s, Ne(c))), s !== o._prevClass && (o.setAttribute("class", s), o._prevClass = s)
                    }
                }

                function dn(t) {
                    var e;
                    r(t[Ho]) && (e = Cr ? "change" : "input", t[e] = [].concat(t[Ho], t[e] || []), delete t[Ho]), r(t[zo]) && (e = kr ? "click" : "change", t[e] = [].concat(t[zo], t[e] || []), delete t[zo])
                }

                function vn(t, e, n, r, o) {
                    if (n) {
                        var i = e,
                            a = _o;
                        e = function(n) {
                            null !== (1 === arguments.length ? i(n) : i.apply(null, arguments)) && hn(t, e, r, a)
                        }
                    }
                    _o.addEventListener(t, e, Sr ? {
                        capture: r,
                        passive: o
                    } : r)
                }

                function hn(t, e, n, r) {
                    (r || _o).removeEventListener(t, e, n)
                }

                function mn(t, e) {
                    if (!n(t.data.on) || !n(e.data.on)) {
                        var r = e.data.on || {},
                            o = t.data.on || {};
                        _o = e.elm, dn(r), nt(r, o, vn, hn, e.context)
                    }
                }

                function yn(t, e) {
                    if (!n(t.data.domProps) || !n(e.data.domProps)) {
                        var o, i, a = e.elm,
                            s = t.data.domProps || {},
                            c = e.data.domProps || {};
                        r(c.__ob__) && (c = e.data.domProps = g({}, c));
                        for (o in s) n(c[o]) && (a[o] = "");
                        for (o in c)
                            if (i = c[o], "textContent" !== o && "innerHTML" !== o || (e.children && (e.children.length = 0), i !== s[o]))
                                if ("value" === o) {
                                    a._value = i;
                                    var u = n(i) ? "" : String(i);
                                    _n(a, e, u) && (a.value = u)
                                } else a[o] = i
                    }
                }

                function _n(t, e, n) {
                    return !t.composing && ("option" === e.tag || gn(t, n) || bn(t, n))
                }

                function gn(t, e) {
                    var n = !0;
                    try {
                        n = document.activeElement !== t
                    } catch (t) {}
                    return n && t.value !== e
                }

                function bn(t, e) {
                    var n = t.value,
                        o = t._vModifiers;
                    return r(o) && o.number ? p(n) !== p(e) : r(o) && o.trim ? n.trim() !== e.trim() : n !== e
                }

                function Cn(t) {
                    var e = wn(t.style);
                    return t.staticStyle ? g(t.staticStyle, e) : e
                }

                function wn(t) {
                    return Array.isArray(t) ? b(t) : "string" == typeof t ? Ko(t) : t
                }

                function An(t, e) {
                    var n, r = {};
                    if (e)
                        for (var o = t; o.componentInstance;) o = o.componentInstance._vnode, o.data && (n = Cn(o.data)) && g(r, n);
                    (n = Cn(t.data)) && g(r, n);
                    for (var i = t; i = i.parent;) i.data && (n = Cn(i.data)) && g(r, n);
                    return r
                }

                function $n(t, e) {
                    var o = e.data,
                        i = t.data;
                    if (!(n(o.staticStyle) && n(o.style) && n(i.staticStyle) && n(i.style))) {
                        var a, s, c = e.elm,
                            u = i.staticStyle,
                            l = i.normalizedStyle || i.style || {},
                            f = u || l,
                            p = wn(e.data.style) || {};
                        e.data.normalizedStyle = r(p.__ob__) ? g({}, p) : p;
                        var d = An(e, !0);
                        for (s in f) n(d[s]) && Zo(c, s, "");
                        for (s in d)(a = d[s]) !== f[s] && Zo(c, s, null == a ? "" : a)
                    }
                }

                function xn(t, e) {
                    if (e && (e = e.trim()))
                        if (t.classList) e.indexOf(" ") > -1 ? e.split(/\s+/).forEach(function(e) {
                            return t.classList.add(e)
                        }) : t.classList.add(e);
                        else {
                            var n = " " + (t.getAttribute("class") || "") + " ";
                            n.indexOf(" " + e + " ") < 0 && t.setAttribute("class", (n + e).trim())
                        }
                }

                function kn(t, e) {
                    if (e && (e = e.trim()))
                        if (t.classList) e.indexOf(" ") > -1 ? e.split(/\s+/).forEach(function(e) {
                            return t.classList.remove(e)
                        }) : t.classList.remove(e), t.classList.length || t.removeAttribute("class");
                        else {
                            for (var n = " " + (t.getAttribute("class") || "") + " ", r = " " + e + " "; n.indexOf(r) >= 0;) n = n.replace(r, " ");
                            n = n.trim(), n ? t.setAttribute("class", n) : t.removeAttribute("class")
                        }
                }

                function On(t) {
                    if (t) {
                        if ("object" == typeof t) {
                            var e = {};
                            return !1 !== t.css && g(e, ti(t.name || "v")), g(e, t), e
                        }
                        return "string" == typeof t ? ti(t) : void 0
                    }
                }

                function Sn(t) {
                    ci(function() {
                        ci(t)
                    })
                }

                function jn(t, e) {
                    var n = t._transitionClasses || (t._transitionClasses = []);
                    n.indexOf(e) < 0 && (n.push(e), xn(t, e))
                }

                function En(t, e) {
                    t._transitionClasses && v(t._transitionClasses, e), kn(t, e)
                }

                function Tn(t, e, n) {
                    var r = In(t, e),
                        o = r.type,
                        i = r.timeout,
                        a = r.propCount;
                    if (!o) return n();
                    var s = o === ni ? ii : si,
                        c = 0,
                        u = function() {
                            t.removeEventListener(s, l), n()
                        },
                        l = function(e) {
                            e.target === t && ++c >= a && u()
                        };
                    setTimeout(function() {
                        c < a && u()
                    }, i + 1), t.addEventListener(s, l)
                }

                function In(t, e) {
                    var n, r = window.getComputedStyle(t),
                        o = r[oi + "Delay"].split(", "),
                        i = r[oi + "Duration"].split(", "),
                        a = Dn(o, i),
                        s = r[ai + "Delay"].split(", "),
                        c = r[ai + "Duration"].split(", "),
                        u = Dn(s, c),
                        l = 0,
                        f = 0;
                    return e === ni ? a > 0 && (n = ni, l = a, f = i.length) : e === ri ? u > 0 && (n = ri, l = u, f = c.length) : (l = Math.max(a, u), n = l > 0 ? a > u ? ni : ri : null, f = n ? n === ni ? i.length : c.length : 0), {
                        type: n,
                        timeout: l,
                        propCount: f,
                        hasTransform: n === ni && ui.test(r[oi + "Property"])
                    }
                }

                function Dn(t, e) {
                    for (; t.length < e.length;) t = t.concat(t);
                    return Math.max.apply(null, e.map(function(e, n) {
                        return Pn(e) + Pn(t[n])
                    }))
                }

                function Pn(t) {
                    return 1e3 * Number(t.slice(0, -1))
                }

                function Ln(t, e) {
                    var o = t.elm;
                    r(o._leaveCb) && (o._leaveCb.cancelled = !0, o._leaveCb());
                    var i = On(t.data.transition);
                    if (!n(i) && !r(o._enterCb) && 1 === o.nodeType) {
                        for (var a = i.css, c = i.type, u = i.enterClass, l = i.enterToClass, f = i.enterActiveClass, d = i.appearClass, v = i.appearToClass, h = i.appearActiveClass, m = i.beforeEnter, y = i.enter, _ = i.afterEnter, g = i.enterCancelled, b = i.beforeAppear, C = i.appear, w = i.afterAppear, A = i.appearCancelled, x = i.duration, k = Qr, O = Qr.$vnode; O && O.parent;) O = O.parent, k = O.context;
                        var S = !k._isMounted || !t.isRootInsert;
                        if (!S || C || "" === C) {
                            var j = S && d ? d : u,
                                E = S && h ? h : f,
                                T = S && v ? v : l,
                                I = S ? b || m : m,
                                D = S && "function" == typeof C ? C : y,
                                P = S ? w || _ : _,
                                L = S ? A || g : g,
                                N = p(s(x) ? x.enter : x),
                                M = !1 !== a && !wr,
                                F = Fn(D),
                                R = o._enterCb = $(function() {
                                    M && (En(o, T), En(o, E)), R.cancelled ? (M && En(o, j), L && L(o)) : P && P(o), o._enterCb = null
                                });
                            t.data.show || rt(t.data.hook || (t.data.hook = {}), "insert", function() {
                                var e = o.parentNode,
                                    n = e && e._pending && e._pending[t.key];
                                n && n.tag === t.tag && n.elm._leaveCb && n.elm._leaveCb(), D && D(o, R)
                            }), I && I(o), M && (jn(o, j), jn(o, E), Sn(function() {
                                jn(o, T), En(o, j), R.cancelled || F || (Mn(N) ? setTimeout(R, N) : Tn(o, c, R))
                            })), t.data.show && (e && e(), D && D(o, R)), M || F || R()
                        }
                    }
                }

                function Nn(t, e) {
                    function o() {
                        A.cancelled || (t.data.show || ((i.parentNode._pending || (i.parentNode._pending = {}))[t.key] = t), v && v(i), b && (jn(i, l), jn(i, d), Sn(function() {
                            jn(i, f), En(i, l), A.cancelled || C || (Mn(w) ? setTimeout(A, w) : Tn(i, u, A))
                        })), h && h(i, A), b || C || A())
                    }
                    var i = t.elm;
                    r(i._enterCb) && (i._enterCb.cancelled = !0, i._enterCb());
                    var a = On(t.data.transition);
                    if (n(a)) return e();
                    if (!r(i._leaveCb) && 1 === i.nodeType) {
                        var c = a.css,
                            u = a.type,
                            l = a.leaveClass,
                            f = a.leaveToClass,
                            d = a.leaveActiveClass,
                            v = a.beforeLeave,
                            h = a.leave,
                            m = a.afterLeave,
                            y = a.leaveCancelled,
                            _ = a.delayLeave,
                            g = a.duration,
                            b = !1 !== c && !wr,
                            C = Fn(h),
                            w = p(s(g) ? g.leave : g),
                            A = i._leaveCb = $(function() {
                                i.parentNode && i.parentNode._pending && (i.parentNode._pending[t.key] = null), b && (En(i, f), En(i, d)), A.cancelled ? (b && En(i, l), y && y(i)) : (e(), m && m(i)), i._leaveCb = null
                            });
                        _ ? _(o) : o()
                    }
                }

                function Mn(t) {
                    return "number" == typeof t && !isNaN(t)
                }

                function Fn(t) {
                    if (n(t)) return !1;
                    var e = t.fns;
                    return r(e) ? Fn(Array.isArray(e) ? e[0] : e) : (t._length || t.length) > 1
                }

                function Rn(t, e) {
                    !0 !== e.data.show && Ln(e)
                }

                function Un(t, e, n) {
                    var r = e.value,
                        o = t.multiple;
                    if (!o || Array.isArray(r)) {
                        for (var i, a, s = 0, c = t.options.length; s < c; s++)
                            if (a = t.options[s], o) i = A(r, Bn(a)) > -1, a.selected !== i && (a.selected = i);
                            else if (w(Bn(a), r)) return void(t.selectedIndex !== s && (t.selectedIndex = s));
                        o || (t.selectedIndex = -1)
                    }
                }

                function Bn(t) {
                    return "_value" in t ? t._value : t.value
                }

                function Vn(t) {
                    t.target.composing = !0
                }

                function Hn(t) {
                    t.target.composing && (t.target.composing = !1, zn(t.target, "input"))
                }

                function zn(t, e) {
                    var n = document.createEvent("HTMLEvents");
                    n.initEvent(e, !0, !0), t.dispatchEvent(n)
                }

                function Wn(t) {
                    return !t.componentInstance || t.data && t.data.transition ? t : Wn(t.componentInstance._vnode)
                }

                function qn(t) {
                    var e = t && t.componentOptions;
                    return e && e.Ctor.options.abstract ? qn(dt(e.children)) : t
                }

                function Kn(t) {
                    var e = {},
                        n = t.$options;
                    for (var r in n.propsData) e[r] = t[r];
                    var o = n._parentListeners;
                    for (var i in o) e[ir(i)] = o[i];
                    return e
                }

                function Jn(t, e) {
                    if (/\d-keep-alive$/.test(e.tag)) return t("keep-alive", {
                        props: e.componentOptions.propsData
                    })
                }

                function Gn(t) {
                    for (; t = t.parent;)
                        if (t.data.transition) return !0
                }

                function Zn(t, e) {
                    return e.key === t.key && e.tag === t.tag
                }

                function Qn(t) {
                    return t.isComment && t.asyncFactory
                }

                function Xn(t) {
                    t.elm._moveCb && t.elm._moveCb(), t.elm._enterCb && t.elm._enterCb()
                }

                function Yn(t) {
                    t.data.newPos = t.elm.getBoundingClientRect()
                }

                function tr(t) {
                    var e = t.data.pos,
                        n = t.data.newPos,
                        r = e.left - n.left,
                        o = e.top - n.top;
                    if (r || o) {
                        t.data.moved = !0;
                        var i = t.elm.style;
                        i.transform = i.WebkitTransform = "translate(" + r + "px," + o + "px)", i.transitionDuration = "0s"
                    }
                }
                var er = Object.prototype.toString,
                    nr = (d("slot,component", !0), d("key,ref,slot,is")),
                    rr = Object.prototype.hasOwnProperty,
                    or = /-(\w)/g,
                    ir = m(function(t) {
                        return t.replace(or, function(t, e) {
                            return e ? e.toUpperCase() : ""
                        })
                    }),
                    ar = m(function(t) {
                        return t.charAt(0).toUpperCase() + t.slice(1)
                    }),
                    sr = /([^-])([A-Z])/g,
                    cr = m(function(t) {
                        return t.replace(sr, "$1-$2").replace(sr, "$1-$2").toLowerCase()
                    }),
                    ur = function(t, e, n) {
                        return !1
                    },
                    lr = function(t) {
                        return t
                    },
                    fr = "data-server-rendered",
                    pr = ["component", "directive", "filter"],
                    dr = ["beforeCreate", "created", "beforeMount", "mounted", "beforeUpdate", "updated", "beforeDestroy", "destroyed", "activated", "deactivated"],
                    vr = {
                        optionMergeStrategies: Object.create(null),
                        silent: !1,
                        productionTip: !1,
                        devtools: !1,
                        performance: !1,
                        errorHandler: null,
                        warnHandler: null,
                        ignoredElements: [],
                        keyCodes: Object.create(null),
                        isReservedTag: ur,
                        isReservedAttr: ur,
                        isUnknownElement: ur,
                        getTagNamespace: C,
                        parsePlatformTagName: lr,
                        mustUseProp: ur,
                        _lifecycleHooks: dr
                    },
                    hr = Object.freeze({}),
                    mr = /[^\w.$]/,
                    yr = C,
                    _r = "__proto__" in {},
                    gr = "undefined" != typeof window,
                    br = gr && window.navigator.userAgent.toLowerCase(),
                    Cr = br && /msie|trident/.test(br),
                    wr = br && br.indexOf("msie 9.0") > 0,
                    Ar = br && br.indexOf("edge/") > 0,
                    $r = br && br.indexOf("android") > 0,
                    xr = br && /iphone|ipad|ipod|ios/.test(br),
                    kr = br && /chrome\/\d+/.test(br) && !Ar,
                    Or = {}.watch,
                    Sr = !1;
                if (gr) try {
                    var jr = {};
                    Object.defineProperty(jr, "passive", {
                        get: function() {
                            Sr = !0
                        }
                    }), window.addEventListener("test-passive", null, jr)
                } catch (t) {}
                var Er, Tr, Ir = function() {
                        return void 0 === Er && (Er = !gr && void 0 !== t && "server" === t.process.env.VUE_ENV), Er
                    },
                    Dr = gr && window.__VUE_DEVTOOLS_GLOBAL_HOOK__,
                    Pr = "undefined" != typeof Symbol && j(Symbol) && "undefined" != typeof Reflect && j(Reflect.ownKeys),
                    Lr = function() {
                        function t() {
                            r = !1;
                            var t = n.slice(0);
                            n.length = 0;
                            for (var e = 0; e < t.length; e++) t[e]()
                        }
                        var e, n = [],
                            r = !1;
                        if ("undefined" != typeof Promise && j(Promise)) {
                            var o = Promise.resolve(),
                                i = function(t) {
                                    console.error(t)
                                };
                            e = function() {
                                o.then(t).catch(i), xr && setTimeout(C)
                            }
                        } else if ("undefined" == typeof MutationObserver || !j(MutationObserver) && "[object MutationObserverConstructor]" !== MutationObserver.toString()) e = function() {
                            setTimeout(t, 0)
                        };
                        else {
                            var a = 1,
                                s = new MutationObserver(t),
                                c = document.createTextNode(String(a));
                            s.observe(c, {
                                characterData: !0
                            }), e = function() {
                                a = (a + 1) % 2, c.data = String(a)
                            }
                        }
                        return function(t, o) {
                            var i;
                            if (n.push(function() {
                                    if (t) try {
                                        t.call(o)
                                    } catch (t) {
                                        S(t, o, "nextTick")
                                    } else i && i(o)
                                }), r || (r = !0, e()), !t && "undefined" != typeof Promise) return new Promise(function(t, e) {
                                i = t
                            })
                        }
                    }();
                Tr = "undefined" != typeof Set && j(Set) ? Set : function() {
                    function t() {
                        this.set = Object.create(null)
                    }
                    return t.prototype.has = function(t) {
                        return !0 === this.set[t]
                    }, t.prototype.add = function(t) {
                        this.set[t] = !0
                    }, t.prototype.clear = function() {
                        this.set = Object.create(null)
                    }, t
                }();
                var Nr = 0,
                    Mr = function() {
                        this.id = Nr++, this.subs = []
                    };
                Mr.prototype.addSub = function(t) {
                    this.subs.push(t)
                }, Mr.prototype.removeSub = function(t) {
                    v(this.subs, t)
                }, Mr.prototype.depend = function() {
                    Mr.target && Mr.target.addDep(this)
                }, Mr.prototype.notify = function() {
                    for (var t = this.subs.slice(), e = 0, n = t.length; e < n; e++) t[e].update()
                }, Mr.target = null;
                var Fr = [],
                    Rr = Array.prototype,
                    Ur = Object.create(Rr);
                ["push", "pop", "shift", "unshift", "splice", "sort", "reverse"].forEach(function(t) {
                    var e = Rr[t];
                    k(Ur, t, function() {
                        for (var n = [], r = arguments.length; r--;) n[r] = arguments[r];
                        var o, i = e.apply(this, n),
                            a = this.__ob__;
                        switch (t) {
                            case "push":
                            case "unshift":
                                o = n;
                                break;
                            case "splice":
                                o = n.slice(2)
                        }
                        return o && a.observeArray(o), a.dep.notify(), i
                    })
                });
                var Br = Object.getOwnPropertyNames(Ur),
                    Vr = {
                        shouldConvert: !0
                    },
                    Hr = function(t) {
                        if (this.value = t, this.dep = new Mr, this.vmCount = 0, k(t, "__ob__", this), Array.isArray(t)) {
                            (_r ? I : D)(t, Ur, Br), this.observeArray(t)
                        } else this.walk(t)
                    };
                Hr.prototype.walk = function(t) {
                    for (var e = Object.keys(t), n = 0; n < e.length; n++) L(t, e[n], t[e[n]])
                }, Hr.prototype.observeArray = function(t) {
                    for (var e = 0, n = t.length; e < n; e++) P(t[e])
                };
                var zr = vr.optionMergeStrategies;
                zr.data = function(t, e, n) {
                    return n ? U(t, e, n) : e && "function" != typeof e ? t : U.call(this, t, e)
                }, dr.forEach(function(t) {
                    zr[t] = B
                }), pr.forEach(function(t) {
                    zr[t + "s"] = V
                }), zr.watch = function(t, e) {
                    if (t === Or && (t = void 0), e === Or && (e = void 0), !e) return Object.create(t || null);
                    if (!t) return e;
                    var n = {};
                    g(n, t);
                    for (var r in e) {
                        var o = n[r],
                            i = e[r];
                        o && !Array.isArray(o) && (o = [o]), n[r] = o ? o.concat(i) : Array.isArray(i) ? i : [i]
                    }
                    return n
                }, zr.props = zr.methods = zr.inject = zr.computed = function(t, e) {
                    if (!t) return e;
                    var n = Object.create(null);
                    return g(n, t), e && g(n, e), n
                }, zr.provide = U;
                var Wr = function(t, e) {
                        return void 0 === e ? t : e
                    },
                    qr = function(t, e, n, r, o, i, a, s) {
                        this.tag = t, this.data = e, this.children = n, this.text = r, this.elm = o, this.ns = void 0, this.context = i, this.functionalContext = void 0, this.key = e && e.key, this.componentOptions = a, this.componentInstance = void 0, this.parent = void 0, this.raw = !1, this.isStatic = !1, this.isRootInsert = !0, this.isComment = !1, this.isCloned = !1, this.isOnce = !1, this.asyncFactory = s, this.asyncMeta = void 0, this.isAsyncPlaceholder = !1
                    },
                    Kr = {
                        child: {}
                    };
                Kr.child.get = function() {
                    return this.componentInstance
                }, Object.defineProperties(qr.prototype, Kr);
                var Jr, Gr = function(t) {
                        void 0 === t && (t = "");
                        var e = new qr;
                        return e.text = t, e.isComment = !0, e
                    },
                    Zr = m(function(t) {
                        var e = "&" === t.charAt(0);
                        t = e ? t.slice(1) : t;
                        var n = "~" === t.charAt(0);
                        t = n ? t.slice(1) : t;
                        var r = "!" === t.charAt(0);
                        return t = r ? t.slice(1) : t, {
                            name: t,
                            once: n,
                            capture: r,
                            passive: e
                        }
                    }),
                    Qr = null,
                    Xr = [],
                    Yr = [],
                    to = {},
                    eo = !1,
                    no = !1,
                    ro = 0,
                    oo = 0,
                    io = function(t, e, n, r) {
                        this.vm = t, t._watchers.push(this), r ? (this.deep = !!r.deep, this.user = !!r.user, this.lazy = !!r.lazy, this.sync = !!r.sync) : this.deep = this.user = this.lazy = this.sync = !1, this.cb = n, this.id = ++oo, this.active = !0, this.dirty = this.lazy, this.deps = [], this.newDeps = [], this.depIds = new Tr, this.newDepIds = new Tr, this.expression = "", "function" == typeof e ? this.getter = e : (this.getter = O(e), this.getter || (this.getter = function() {})), this.value = this.lazy ? void 0 : this.get()
                    };
                io.prototype.get = function() {
                    E(this);
                    var t, e = this.vm;
                    try {
                        t = this.getter.call(e, e)
                    } catch (t) {
                        if (!this.user) throw t;
                        S(t, e, 'getter for watcher "' + this.expression + '"')
                    } finally {
                        this.deep && Pt(t), T(), this.cleanupDeps()
                    }
                    return t
                }, io.prototype.addDep = function(t) {
                    var e = t.id;
                    this.newDepIds.has(e) || (this.newDepIds.add(e), this.newDeps.push(t), this.depIds.has(e) || t.addSub(this))
                }, io.prototype.cleanupDeps = function() {
                    for (var t = this, e = this.deps.length; e--;) {
                        var n = t.deps[e];
                        t.newDepIds.has(n.id) || n.removeSub(t)
                    }
                    var r = this.depIds;
                    this.depIds = this.newDepIds, this.newDepIds = r, this.newDepIds.clear(), r = this.deps, this.deps = this.newDeps, this.newDeps = r, this.newDeps.length = 0
                }, io.prototype.update = function() {
                    this.lazy ? this.dirty = !0 : this.sync ? this.run() : Dt(this)
                }, io.prototype.run = function() {
                    if (this.active) {
                        var t = this.get();
                        if (t !== this.value || s(t) || this.deep) {
                            var e = this.value;
                            if (this.value = t, this.user) try {
                                this.cb.call(this.vm, t, e)
                            } catch (t) {
                                S(t, this.vm, 'callback for watcher "' + this.expression + '"')
                            } else this.cb.call(this.vm, t, e)
                        }
                    }
                }, io.prototype.evaluate = function() {
                    this.value = this.get(), this.dirty = !1
                }, io.prototype.depend = function() {
                    for (var t = this, e = this.deps.length; e--;) t.deps[e].depend()
                }, io.prototype.teardown = function() {
                    var t = this;
                    if (this.active) {
                        this.vm._isBeingDestroyed || v(this.vm._watchers, this);
                        for (var e = this.deps.length; e--;) t.deps[e].removeSub(t);
                        this.active = !1
                    }
                };
                var ao = new Tr,
                    so = {
                        enumerable: !0,
                        configurable: !0,
                        get: C,
                        set: C
                    },
                    co = {
                        lazy: !0
                    },
                    uo = {
                        init: function(t, e, n, r) {
                            if (!t.componentInstance || t.componentInstance._isDestroyed) {
                                (t.componentInstance = Yt(t, Qr, n, r)).$mount(e ? t.elm : void 0, e)
                            } else if (t.data.keepAlive) {
                                var o = t;
                                uo.prepatch(o, o)
                            }
                        },
                        prepatch: function(t, e) {
                            var n = e.componentOptions;
                            At(e.componentInstance = t.componentInstance, n.propsData, n.listeners, e, n.children)
                        },
                        insert: function(t) {
                            var e = t.context,
                                n = t.componentInstance;
                            n._isMounted || (n._isMounted = !0, Ot(n, "mounted")), t.data.keepAlive && (e._isMounted ? Tt(n) : xt(n, !0))
                        },
                        destroy: function(t) {
                            var e = t.componentInstance;
                            e._isDestroyed || (t.data.keepAlive ? kt(e, !0) : e.$destroy())
                        }
                    },
                    lo = Object.keys(uo),
                    fo = 1,
                    po = 2,
                    vo = 0;
                ! function(t) {
                    t.prototype._init = function(t) {
                        var e = this;
                        e._uid = vo++, e._isVue = !0, t && t._isComponent ? ye(e, t) : e.$options = q(_e(e.constructor), t || {}, e), e._renderProxy = e, e._self = e, Ct(e), vt(e), me(e), Ot(e, "beforeCreate"), Jt(e), Mt(e), Kt(e), Ot(e, "created"), e.$options.el && e.$mount(e.$options.el)
                    }
                }(Ce),
                function(t) {
                    var e = {};
                    e.get = function() {
                        return this._data
                    };
                    var n = {};
                    n.get = function() {
                        return this._props
                    }, Object.defineProperty(t.prototype, "$data", e), Object.defineProperty(t.prototype, "$props", n), t.prototype.$set = N, t.prototype.$delete = M, t.prototype.$watch = function(t, e, n) {
                        var r = this;
                        if (c(e)) return qt(r, t, e, n);
                        n = n || {}, n.user = !0;
                        var o = new io(r, t, e, n);
                        return n.immediate && e.call(r, o.value),
                            function() {
                                o.teardown()
                            }
                    }
                }(Ce),
                function(t) {
                    var e = /^hook:/;
                    t.prototype.$on = function(t, n) {
                        var r = this,
                            o = this;
                        if (Array.isArray(t))
                            for (var i = 0, a = t.length; i < a; i++) r.$on(t[i], n);
                        else(o._events[t] || (o._events[t] = [])).push(n), e.test(t) && (o._hasHookEvent = !0);
                        return o
                    }, t.prototype.$once = function(t, e) {
                        function n() {
                            r.$off(t, n), e.apply(r, arguments)
                        }
                        var r = this;
                        return n.fn = e, r.$on(t, n), r
                    }, t.prototype.$off = function(t, e) {
                        var n = this,
                            r = this;
                        if (!arguments.length) return r._events = Object.create(null), r;
                        if (Array.isArray(t)) {
                            for (var o = 0, i = t.length; o < i; o++) n.$off(t[o], e);
                            return r
                        }
                        var a = r._events[t];
                        if (!a) return r;
                        if (1 === arguments.length) return r._events[t] = null, r;
                        for (var s, c = a.length; c--;)
                            if ((s = a[c]) === e || s.fn === e) {
                                a.splice(c, 1);
                                break
                            } return r
                    }, t.prototype.$emit = function(t) {
                        var e = this,
                            n = e._events[t];
                        if (n) {
                            n = n.length > 1 ? _(n) : n;
                            for (var r = _(arguments, 1), o = 0, i = n.length; o < i; o++) try {
                                n[o].apply(e, r)
                            } catch (n) {
                                S(n, e, 'event handler for "' + t + '"')
                            }
                        }
                        return e
                    }
                }(Ce),
                function(t) {
                    t.prototype._update = function(t, e) {
                        var n = this;
                        n._isMounted && Ot(n, "beforeUpdate");
                        var r = n.$el,
                            o = n._vnode,
                            i = Qr;
                        Qr = n, n._vnode = t, o ? n.$el = n.__patch__(o, t) : (n.$el = n.__patch__(n.$el, t, e, !1, n.$options._parentElm, n.$options._refElm), n.$options._parentElm = n.$options._refElm = null), Qr = i, r && (r.__vue__ = null), n.$el && (n.$el.__vue__ = n), n.$vnode && n.$parent && n.$vnode === n.$parent._vnode && (n.$parent.$el = n.$el)
                    }, t.prototype.$forceUpdate = function() {
                        var t = this;
                        t._watcher && t._watcher.update()
                    }, t.prototype.$destroy = function() {
                        var t = this;
                        if (!t._isBeingDestroyed) {
                            Ot(t, "beforeDestroy"), t._isBeingDestroyed = !0;
                            var e = t.$parent;
                            !e || e._isBeingDestroyed || t.$options.abstract || v(e.$children, t), t._watcher && t._watcher.teardown();
                            for (var n = t._watchers.length; n--;) t._watchers[n].teardown();
                            t._data.__ob__ && t._data.__ob__.vmCount--, t._isDestroyed = !0, t.__patch__(t._vnode, null), Ot(t, "destroyed"), t.$off(), t.$el && (t.$el.__vue__ = null)
                        }
                    }
                }(Ce),
                function(t) {
                    t.prototype.$nextTick = function(t) {
                        return Lr(t, this)
                    }, t.prototype._render = function() {
                        var t = this,
                            e = t.$options,
                            n = e.render,
                            r = e.staticRenderFns,
                            o = e._parentVnode;
                        if (t._isMounted)
                            for (var i in t.$slots) t.$slots[i] = tt(t.$slots[i]);
                        t.$scopedSlots = o && o.data.scopedSlots || hr, r && !t._staticTrees && (t._staticTrees = []), t.$vnode = o;
                        var a;
                        try {
                            a = n.call(t._renderProxy, t.$createElement)
                        } catch (e) {
                            S(e, t, "render function"), a = t._vnode
                        }
                        return a instanceof qr || (a = Gr()), a.parent = o, a
                    }, t.prototype._o = pe, t.prototype._n = p, t.prototype._s = f, t.prototype._l = ae, t.prototype._t = se, t.prototype._q = w, t.prototype._i = A, t.prototype._m = fe, t.prototype._f = ce, t.prototype._k = ue, t.prototype._b = le, t.prototype._v = X, t.prototype._e = Gr, t.prototype._u = bt, t.prototype._g = he
                }(Ce);
                var ho = [String, RegExp, Array],
                    mo = {
                        name: "keep-alive",
                        abstract: !0,
                        props: {
                            include: ho,
                            exclude: ho
                        },
                        created: function() {
                            this.cache = Object.create(null)
                        },
                        destroyed: function() {
                            var t = this;
                            for (var e in t.cache) Te(t.cache[e])
                        },
                        watch: {
                            include: function(t) {
                                Ee(this.cache, this._vnode, function(e) {
                                    return je(t, e)
                                })
                            },
                            exclude: function(t) {
                                Ee(this.cache, this._vnode, function(e) {
                                    return !je(t, e)
                                })
                            }
                        },
                        render: function() {
                            var t = dt(this.$slots.default),
                                e = t && t.componentOptions;
                            if (e) {
                                var n = Se(e);
                                if (n && (this.include && !je(this.include, n) || this.exclude && je(this.exclude, n))) return t;
                                var r = null == t.key ? e.Ctor.cid + (e.tag ? "::" + e.tag : "") : t.key;
                                this.cache[r] ? t.componentInstance = this.cache[r].componentInstance : this.cache[r] = t, t.data.keepAlive = !0
                            }
                            return t
                        }
                    },
                    yo = {
                        KeepAlive: mo
                    };
                ! function(t) {
                    var e = {};
                    e.get = function() {
                        return vr
                    }, Object.defineProperty(t, "config", e), t.util = {
                        warn: yr,
                        extend: g,
                        mergeOptions: q,
                        defineReactive: L
                    }, t.set = N, t.delete = M, t.nextTick = Lr, t.options = Object.create(null), pr.forEach(function(e) {
                        t.options[e + "s"] = Object.create(null)
                    }), t.options._base = t, g(t.options.components, yo), we(t), Ae(t), $e(t), Oe(t)
                }(Ce), Object.defineProperty(Ce.prototype, "$isServer", {
                    get: Ir
                }), Object.defineProperty(Ce.prototype, "$ssrContext", {
                    get: function() {
                        return this.$vnode && this.$vnode.ssrContext
                    }
                }), Ce.version = "2.4.2";
                var _o, go, bo = d("style,class"),
                    Co = d("input,textarea,option,select"),
                    wo = function(t, e, n) {
                        return "value" === n && Co(t) && "button" !== e || "selected" === n && "option" === t || "checked" === n && "input" === t || "muted" === n && "video" === t
                    },
                    Ao = d("contenteditable,draggable,spellcheck"),
                    $o = d("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"),
                    xo = "http://www.w3.org/1999/xlink",
                    ko = function(t) {
                        return ":" === t.charAt(5) && "xlink" === t.slice(0, 5)
                    },
                    Oo = function(t) {
                        return ko(t) ? t.slice(6, t.length) : ""
                    },
                    So = function(t) {
                        return null == t || !1 === t
                    },
                    jo = {
                        svg: "http://www.w3.org/2000/svg",
                        math: "http://www.w3.org/1998/Math/MathML"
                    },
                    Eo = d("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),
                    To = d("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view", !0),
                    Io = function(t) {
                        return Eo(t) || To(t)
                    },
                    Do = Object.create(null),
                    Po = Object.freeze({
                        createElement: Ve,
                        createElementNS: He,
                        createTextNode: ze,
                        createComment: We,
                        insertBefore: qe,
                        removeChild: Ke,
                        appendChild: Je,
                        parentNode: Ge,
                        nextSibling: Ze,
                        tagName: Qe,
                        setTextContent: Xe,
                        setAttribute: Ye
                    }),
                    Lo = {
                        create: function(t, e) {
                            tn(e)
                        },
                        update: function(t, e) {
                            t.data.ref !== e.data.ref && (tn(t, !0), tn(e))
                        },
                        destroy: function(t) {
                            tn(t, !0)
                        }
                    },
                    No = new qr("", {}, []),
                    Mo = ["create", "activate", "update", "remove", "destroy"],
                    Fo = {
                        create: on,
                        update: on,
                        destroy: function(t) {
                            on(t, No)
                        }
                    },
                    Ro = Object.create(null),
                    Uo = [Lo, Fo],
                    Bo = {
                        create: ln,
                        update: ln
                    },
                    Vo = {
                        create: pn,
                        update: pn
                    },
                    Ho = "__r",
                    zo = "__c",
                    Wo = {
                        create: mn,
                        update: mn
                    },
                    qo = {
                        create: yn,
                        update: yn
                    },
                    Ko = m(function(t) {
                        var e = {},
                            n = /;(?![^(]*\))/g,
                            r = /:(.+)/;
                        return t.split(n).forEach(function(t) {
                            if (t) {
                                var n = t.split(r);
                                n.length > 1 && (e[n[0].trim()] = n[1].trim())
                            }
                        }), e
                    }),
                    Jo = /^--/,
                    Go = /\s*!important$/,
                    Zo = function(t, e, n) {
                        if (Jo.test(e)) t.style.setProperty(e, n);
                        else if (Go.test(n)) t.style.setProperty(e, n.replace(Go, ""), "important");
                        else {
                            var r = Xo(e);
                            if (Array.isArray(n))
                                for (var o = 0, i = n.length; o < i; o++) t.style[r] = n[o];
                            else t.style[r] = n
                        }
                    },
                    Qo = ["Webkit", "Moz", "ms"],
                    Xo = m(function(t) {
                        if (go = go || document.createElement("div").style, "filter" !== (t = ir(t)) && t in go) return t;
                        for (var e = t.charAt(0).toUpperCase() + t.slice(1), n = 0; n < Qo.length; n++) {
                            var r = Qo[n] + e;
                            if (r in go) return r
                        }
                    }),
                    Yo = {
                        create: $n,
                        update: $n
                    },
                    ti = m(function(t) {
                        return {
                            enterClass: t + "-enter",
                            enterToClass: t + "-enter-to",
                            enterActiveClass: t + "-enter-active",
                            leaveClass: t + "-leave",
                            leaveToClass: t + "-leave-to",
                            leaveActiveClass: t + "-leave-active"
                        }
                    }),
                    ei = gr && !wr,
                    ni = "transition",
                    ri = "animation",
                    oi = "transition",
                    ii = "transitionend",
                    ai = "animation",
                    si = "animationend";
                ei && (void 0 === window.ontransitionend && void 0 !== window.onwebkittransitionend && (oi = "WebkitTransition", ii = "webkitTransitionEnd"), void 0 === window.onanimationend && void 0 !== window.onwebkitanimationend && (ai = "WebkitAnimation", si = "webkitAnimationEnd"));
                var ci = gr && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout,
                    ui = /\b(transform|all)(,|$)/,
                    li = gr ? {
                        create: Rn,
                        activate: Rn,
                        remove: function(t, e) {
                            !0 !== t.data.show ? Nn(t, e) : e()
                        }
                    } : {},
                    fi = [Bo, Vo, Wo, qo, Yo, li],
                    pi = fi.concat(Uo),
                    di = function(t) {
                        function e(t) {
                            return new qr(E.tagName(t).toLowerCase(), {}, [], void 0, t)
                        }

                        function i(t, e) {
                            function n() {
                                0 == --n.listeners && s(t)
                            }
                            return n.listeners = e, n
                        }

                        function s(t) {
                            var e = E.parentNode(t);
                            r(e) && E.removeChild(e, t)
                        }

                        function c(t, e, n, i, a) {
                            if (t.isRootInsert = !a, !u(t, e, n, i)) {
                                var s = t.data,
                                    c = t.children,
                                    l = t.tag;
                                r(l) ? (t.elm = t.ns ? E.createElementNS(t.ns, l) : E.createElement(l, t), y(t), v(t, c, e), r(s) && m(t, e), p(n, t.elm, i)) : o(t.isComment) ? (t.elm = E.createComment(t.text), p(n, t.elm, i)) : (t.elm = E.createTextNode(t.text), p(n, t.elm, i))
                            }
                        }

                        function u(t, e, n, i) {
                            var a = t.data;
                            if (r(a)) {
                                var s = r(t.componentInstance) && a.keepAlive;
                                if (r(a = a.hook) && r(a = a.init) && a(t, !1, n, i), r(t.componentInstance)) return l(t, e), o(s) && f(t, e, n, i), !0
                            }
                        }

                        function l(t, e) {
                            r(t.data.pendingInsert) && (e.push.apply(e, t.data.pendingInsert), t.data.pendingInsert = null), t.elm = t.componentInstance.$el, h(t) ? (m(t, e), y(t)) : (tn(t), e.push(t))
                        }

                        function f(t, e, n, o) {
                            for (var i, a = t; a.componentInstance;)
                                if (a = a.componentInstance._vnode, r(i = a.data) && r(i = i.transition)) {
                                    for (i = 0; i < S.activate.length; ++i) S.activate[i](No, a);
                                    e.push(a);
                                    break
                                } p(n, t.elm, o)
                        }

                        function p(t, e, n) {
                            r(t) && (r(n) ? n.parentNode === t && E.insertBefore(t, e, n) : E.appendChild(t, e))
                        }

                        function v(t, e, n) {
                            if (Array.isArray(e))
                                for (var r = 0; r < e.length; ++r) c(e[r], n, t.elm, null, !0);
                            else a(t.text) && E.appendChild(t.elm, E.createTextNode(t.text))
                        }

                        function h(t) {
                            for (; t.componentInstance;) t = t.componentInstance._vnode;
                            return r(t.tag)
                        }

                        function m(t, e) {
                            for (var n = 0; n < S.create.length; ++n) S.create[n](No, t);
                            k = t.data.hook, r(k) && (r(k.create) && k.create(No, t), r(k.insert) && e.push(t))
                        }

                        function y(t) {
                            for (var e, n = t; n;) r(e = n.context) && r(e = e.$options._scopeId) && E.setAttribute(t.elm, e, ""), n = n.parent;
                            r(e = Qr) && e !== t.context && r(e = e.$options._scopeId) && E.setAttribute(t.elm, e, "")
                        }

                        function _(t, e, n, r, o, i) {
                            for (; r <= o; ++r) c(n[r], i, t, e)
                        }

                        function g(t) {
                            var e, n, o = t.data;
                            if (r(o))
                                for (r(e = o.hook) && r(e = e.destroy) && e(t), e = 0; e < S.destroy.length; ++e) S.destroy[e](t);
                            if (r(e = t.children))
                                for (n = 0; n < t.children.length; ++n) g(t.children[n])
                        }

                        function b(t, e, n, o) {
                            for (; n <= o; ++n) {
                                var i = e[n];
                                r(i) && (r(i.tag) ? (C(i), g(i)) : s(i.elm))
                            }
                        }

                        function C(t, e) {
                            if (r(e) || r(t.data)) {
                                var n, o = S.remove.length + 1;
                                for (r(e) ? e.listeners += o : e = i(t.elm, o), r(n = t.componentInstance) && r(n = n._vnode) && r(n.data) && C(n, e), n = 0; n < S.remove.length; ++n) S.remove[n](t, e);
                                r(n = t.data.hook) && r(n = n.remove) ? n(t, e) : e()
                            } else s(t.elm)
                        }

                        function w(t, e, o, i, a) {
                            for (var s, u, l, f, p = 0, d = 0, v = e.length - 1, h = e[0], m = e[v], y = o.length - 1, g = o[0], C = o[y], w = !a; p <= v && d <= y;) n(h) ? h = e[++p] : n(m) ? m = e[--v] : en(h, g) ? (A(h, g, i), h = e[++p], g = o[++d]) : en(m, C) ? (A(m, C, i), m = e[--v], C = o[--y]) : en(h, C) ? (A(h, C, i), w && E.insertBefore(t, h.elm, E.nextSibling(m.elm)), h = e[++p], C = o[--y]) : en(m, g) ? (A(m, g, i), w && E.insertBefore(t, m.elm, h.elm), m = e[--v], g = o[++d]) : (n(s) && (s = rn(e, p, v)), u = r(g.key) ? s[g.key] : null, n(u) ? (c(g, i, t, h.elm), g = o[++d]) : (l = e[u], en(l, g) ? (A(l, g, i), e[u] = void 0, w && E.insertBefore(t, l.elm, h.elm), g = o[++d]) : (c(g, i, t, h.elm), g = o[++d])));
                            p > v ? (f = n(o[y + 1]) ? null : o[y + 1].elm, _(t, f, o, d, y, i)) : d > y && b(t, e, p, v)
                        }

                        function A(t, e, i, a) {
                            if (t !== e) {
                                var s = e.elm = t.elm;
                                if (o(t.isAsyncPlaceholder)) return void(r(e.asyncFactory.resolved) ? x(t.elm, e, i) : e.isAsyncPlaceholder = !0);
                                if (o(e.isStatic) && o(t.isStatic) && e.key === t.key && (o(e.isCloned) || o(e.isOnce))) return void(e.componentInstance = t.componentInstance);
                                var c, u = e.data;
                                r(u) && r(c = u.hook) && r(c = c.prepatch) && c(t, e);
                                var l = t.children,
                                    f = e.children;
                                if (r(u) && h(e)) {
                                    for (c = 0; c < S.update.length; ++c) S.update[c](t, e);
                                    r(c = u.hook) && r(c = c.update) && c(t, e)
                                }
                                n(e.text) ? r(l) && r(f) ? l !== f && w(s, l, f, i, a) : r(f) ? (r(t.text) && E.setTextContent(s, ""), _(s, null, f, 0, f.length - 1, i)) : r(l) ? b(s, l, 0, l.length - 1) : r(t.text) && E.setTextContent(s, "") : t.text !== e.text && E.setTextContent(s, e.text), r(u) && r(c = u.hook) && r(c = c.postpatch) && c(t, e)
                            }
                        }

                        function $(t, e, n) {
                            if (o(n) && r(t.parent)) t.parent.data.pendingInsert = e;
                            else
                                for (var i = 0; i < e.length; ++i) e[i].data.hook.insert(e[i])
                        }

                        function x(t, e, n) {
                            if (o(e.isComment) && r(e.asyncFactory)) return e.elm = t, e.isAsyncPlaceholder = !0, !0;
                            e.elm = t;
                            var i = e.tag,
                                a = e.data,
                                s = e.children;
                            if (r(a) && (r(k = a.hook) && r(k = k.init) && k(e, !0), r(k = e.componentInstance))) return l(e, n), !0;
                            if (r(i)) {
                                if (r(s))
                                    if (t.hasChildNodes()) {
                                        for (var c = !0, u = t.firstChild, f = 0; f < s.length; f++) {
                                            if (!u || !x(u, s[f], n)) {
                                                c = !1;
                                                break
                                            }
                                            u = u.nextSibling
                                        }
                                        if (!c || u) return !1
                                    } else v(e, s, n);
                                if (r(a))
                                    for (var p in a)
                                        if (!T(p)) {
                                            m(e, n);
                                            break
                                        }
                            } else t.data !== e.text && (t.data = e.text);
                            return !0
                        }
                        var k, O, S = {},
                            j = t.modules,
                            E = t.nodeOps;
                        for (k = 0; k < Mo.length; ++k)
                            for (S[Mo[k]] = [], O = 0; O < j.length; ++O) r(j[O][Mo[k]]) && S[Mo[k]].push(j[O][Mo[k]]);
                        var T = d("attrs,style,class,staticClass,staticStyle,key");
                        return function(t, i, a, s, u, l) {
                            if (n(i)) return void(r(t) && g(t));
                            var f = !1,
                                p = [];
                            if (n(t)) f = !0, c(i, p, u, l);
                            else {
                                var d = r(t.nodeType);
                                if (!d && en(t, i)) A(t, i, p, s);
                                else {
                                    if (d) {
                                        if (1 === t.nodeType && t.hasAttribute(fr) && (t.removeAttribute(fr), a = !0), o(a) && x(t, i, p)) return $(i, p, !0), t;
                                        t = e(t)
                                    }
                                    var v = t.elm,
                                        m = E.parentNode(v);
                                    if (c(i, p, v._leaveCb ? null : m, E.nextSibling(v)), r(i.parent)) {
                                        for (var y = i.parent; y;) y.elm = i.elm, y = y.parent;
                                        if (h(i))
                                            for (var _ = 0; _ < S.create.length; ++_) S.create[_](No, i.parent)
                                    }
                                    r(m) ? b(m, [t], 0, 0) : r(t.tag) && g(t)
                                }
                            }
                            return $(i, p, f), i.elm
                        }
                    }({
                        nodeOps: Po,
                        modules: pi
                    }),
                    vi = d("text,number,password,search,email,tel,url");
                wr && document.addEventListener("selectionchange", function() {
                    var t = document.activeElement;
                    t && t.vmodel && zn(t, "input")
                });
                var hi = {
                        inserted: function(t, e, n) {
                            if ("select" === n.tag) {
                                var r = function() {
                                    Un(t, e, n.context)
                                };
                                r(), (Cr || Ar) && setTimeout(r, 0), t._vOptions = [].map.call(t.options, Bn)
                            } else("textarea" === n.tag || vi(t.type)) && (t._vModifiers = e.modifiers, e.modifiers.lazy || (t.addEventListener("change", Hn), $r || (t.addEventListener("compositionstart", Vn), t.addEventListener("compositionend", Hn)), wr && (t.vmodel = !0)))
                        },
                        componentUpdated: function(t, e, n) {
                            if ("select" === n.tag) {
                                Un(t, e, n.context);
                                var r = t._vOptions;
                                (t._vOptions = [].map.call(t.options, Bn)).some(function(t, e) {
                                    return !w(t, r[e])
                                }) && zn(t, "change")
                            }
                        }
                    },
                    mi = {
                        bind: function(t, e, n) {
                            var r = e.value;
                            n = Wn(n);
                            var o = n.data && n.data.transition,
                                i = t.__vOriginalDisplay = "none" === t.style.display ? "" : t.style.display;
                            r && o ? (n.data.show = !0, Ln(n, function() {
                                t.style.display = i
                            })) : t.style.display = r ? i : "none"
                        },
                        update: function(t, e, n) {
                            var r = e.value;
                            r !== e.oldValue && (n = Wn(n), n.data && n.data.transition ? (n.data.show = !0, r ? Ln(n, function() {
                                t.style.display = t.__vOriginalDisplay
                            }) : Nn(n, function() {
                                t.style.display = "none"
                            })) : t.style.display = r ? t.__vOriginalDisplay : "none")
                        },
                        unbind: function(t, e, n, r, o) {
                            o || (t.style.display = t.__vOriginalDisplay)
                        }
                    },
                    yi = {
                        model: hi,
                        show: mi
                    },
                    _i = {
                        name: String,
                        appear: Boolean,
                        css: Boolean,
                        mode: String,
                        type: String,
                        enterClass: String,
                        leaveClass: String,
                        enterToClass: String,
                        leaveToClass: String,
                        enterActiveClass: String,
                        leaveActiveClass: String,
                        appearClass: String,
                        appearActiveClass: String,
                        appearToClass: String,
                        duration: [Number, String, Object]
                    },
                    gi = {
                        name: "transition",
                        props: _i,
                        abstract: !0,
                        render: function(t) {
                            var e = this,
                                n = this.$options._renderChildren;
                            if (n && (n = n.filter(function(t) {
                                    return t.tag || Qn(t)
                                }), n.length)) {
                                var r = this.mode,
                                    o = n[0];
                                if (Gn(this.$vnode)) return o;
                                var i = qn(o);
                                if (!i) return o;
                                if (this._leaving) return Jn(t, o);
                                var s = "__transition-" + this._uid + "-";
                                i.key = null == i.key ? i.isComment ? s + "comment" : s + i.tag : a(i.key) ? 0 === String(i.key).indexOf(s) ? i.key : s + i.key : i.key;
                                var c = (i.data || (i.data = {})).transition = Kn(this),
                                    u = this._vnode,
                                    l = qn(u);
                                if (i.data.directives && i.data.directives.some(function(t) {
                                        return "show" === t.name
                                    }) && (i.data.show = !0), l && l.data && !Zn(i, l) && !Qn(l)) {
                                    var f = l && (l.data.transition = g({}, c));
                                    if ("out-in" === r) return this._leaving = !0, rt(f, "afterLeave", function() {
                                        e._leaving = !1, e.$forceUpdate()
                                    }), Jn(t, o);
                                    if ("in-out" === r) {
                                        if (Qn(i)) return u;
                                        var p, d = function() {
                                            p()
                                        };
                                        rt(c, "afterEnter", d), rt(c, "enterCancelled", d), rt(f, "delayLeave", function(t) {
                                            p = t
                                        })
                                    }
                                }
                                return o
                            }
                        }
                    },
                    bi = g({
                        tag: String,
                        moveClass: String
                    }, _i);
                delete bi.mode;
                var Ci = {
                        props: bi,
                        render: function(t) {
                            for (var e = this.tag || this.$vnode.data.tag || "span", n = Object.create(null), r = this.prevChildren = this.children, o = this.$slots.default || [], i = this.children = [], a = Kn(this), s = 0; s < o.length; s++) {
                                var c = o[s];
                                if (c.tag)
                                    if (null != c.key && 0 !== String(c.key).indexOf("__vlist")) i.push(c), n[c.key] = c, (c.data || (c.data = {})).transition = a;
                                    else;
                            }
                            if (r) {
                                for (var u = [], l = [], f = 0; f < r.length; f++) {
                                    var p = r[f];
                                    p.data.transition = a, p.data.pos = p.elm.getBoundingClientRect(), n[p.key] ? u.push(p) : l.push(p)
                                }
                                this.kept = t(e, null, u), this.removed = l
                            }
                            return t(e, null, i)
                        },
                        beforeUpdate: function() {
                            this.__patch__(this._vnode, this.kept, !1, !0), this._vnode = this.kept
                        },
                        updated: function() {
                            var t = this.prevChildren,
                                e = this.moveClass || (this.name || "v") + "-move";
                            if (t.length && this.hasMove(t[0].elm, e)) {
                                t.forEach(Xn), t.forEach(Yn), t.forEach(tr);
                                var n = document.body;
                                n.offsetHeight;
                                t.forEach(function(t) {
                                    if (t.data.moved) {
                                        var n = t.elm,
                                            r = n.style;
                                        jn(n, e), r.transform = r.WebkitTransform = r.transitionDuration = "", n.addEventListener(ii, n._moveCb = function t(r) {
                                            r && !/transform$/.test(r.propertyName) || (n.removeEventListener(ii, t), n._moveCb = null, En(n, e))
                                        })
                                    }
                                })
                            }
                        },
                        methods: {
                            hasMove: function(t, e) {
                                if (!ei) return !1;
                                if (this._hasMove) return this._hasMove;
                                var n = t.cloneNode();
                                t._transitionClasses && t._transitionClasses.forEach(function(t) {
                                    kn(n, t)
                                }), xn(n, e), n.style.display = "none", this.$el.appendChild(n);
                                var r = In(n);
                                return this.$el.removeChild(n), this._hasMove = r.hasTransform
                            }
                        }
                    },
                    wi = {
                        Transition: gi,
                        TransitionGroup: Ci
                    };
                Ce.config.mustUseProp = wo, Ce.config.isReservedTag = Io, Ce.config.isReservedAttr = bo, Ce.config.getTagNamespace = Re, Ce.config.isUnknownElement = Ue, g(Ce.options.directives, yi), g(Ce.options.components, wi), Ce.prototype.__patch__ = gr ? di : C, Ce.prototype.$mount = function(t, e) {
                    return t = t && gr ? Be(t) : void 0, wt(this, t, e)
                }, setTimeout(function() {
                    vr.devtools && Dr && Dr.emit("init", Ce)
                }, 0), e.default = Ce
            }.call(e, n(1))
    },
    1: function(t, e) {
        var n;
        n = function() {
            return this
        }();
        try {
            n = n || Function("return this")() || (0, eval)("this")
        } catch (t) {
            "object" == typeof window && (n = window)
        }
        t.exports = n
    },
    13: function(t, e, n) {
        t.exports = n(0)
    }
});
webpackJsonp([0], [, , function(t, e, i) {
    "use strict";
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), i(3).a.$mount("#app")
}, function(t, e, i) {
    "use strict";
    i.d(e, "a", function() {
        return h
    });
    var r = i(0),
        s = i(4),
        o = i(8),
        n = i.n(o),
        a = i(9),
        l = i.n(a),
        c = i(11),
        p = i.n(c),
        u = Object.assign || function(t) {
            for (var e = 1; e < arguments.length; e++) {
                var i = arguments[e];
                for (var r in i) Object.prototype.hasOwnProperty.call(i, r) && (t[r] = i[r])
            }
            return t
        };
    r.default.use(p.a), r.default.use(l.a);
    var h = new r.default(u({
        data: {
            dietChoice: 1,
            dOps: [{
                text: "Estándar",
                id: 1
            }, {
                text: "Ganancias Limpias",
                id: 2
            }, {
                text: "Keto",
                id: 3
            }],
            selected: 1,
            options: [{
                text: "Metrico (kg, cm)",
                id: 1
            }, {
                text: "Imperial (lb, in)",
                id: 2
            }],
            MisActive: !0,
            FisActive: !1,
            genderID: 5,
            genders: [{
                text: "Hombre",
                id: 5
            }, {
                text: "Mujer",
                id: -160
            }],
            bfID: 0,
            bf: [{
                text: "<10%",
                id: .5
            }, {
                text: "11-19%",
                id: 0
            }, {
                text: "20-24%",
                id: -.5
            }, {
                text: "25-29%",
                id: -1.5
            }, {
                text: "30-34%",
                id: -2.5
            }],
            bfIDf: 0,
            bff: [{
                text: "<18%",
                id: .5
            }, {
                text: "19-27%",
                id: 0
            }, {
                text: "28-32%",
                id: -.5
            }, {
                text: "33-37%",
                id: -1.5
            }, {
                text: "38-42%",
                id: -2.5
            }],
            mmassID: 0,
            mmass: [{
                text: "Estandar",
                id: 0
            }, {
                text: "Muscular",
                id: .5
            }, {
                text: "Muy Muscular",
                id: 1
            }],
            alevelID: 1.2,
            alevel: [{
                text: "Sedentario",
                id: 1.2
            }, {
                text: "Ligero activo",
                id: 1.375
            }, {
                text: "Moderado Activo",
                id: 1.55
            }, {
                text: "Muy Activo",
                id: 1.725
            }, {
                text: "Extremadamente Activo",
                id: 1.9
            }],
            goalID: -20,
            goals: [{
                text: "Perder Peso (–20%)",
                id: -20
            }, {
                text: "Perder Peso Lentamente (–10%)",
                id: -10
            }, {
                text: "Mantener Peso (0%)",
                id: 0
            }, {
                text: "Subir de Peso Lentamente (+10%)",
                id: 10
            }, {
                text: "Subir de Peso (+20%)",
                id: 20
            }],
            LGgoalID: -500,
            LGgoals: [{
                text: "Perder Peso (–500 cal)",
                id: -500
            }, {
                text: "Mantener Peso",
                id: 0
            }, {
                text: "Subir de peso (+500 cal)",
                id: 500
            }],
            LGgoalIDf: -350,
            LGgoalsf: [{
                text: "Perder Peso (–350 cal)",
                id: -350
            }, {
                text: "Mantener Peso",
                id: 0
            }, {
                text: "Subir de Peso (+350 cal)",
                id: 350
            }],
            proID: 1,
            plevel: [{
                text: "1g por libra (Estándar)",
                id: 1
            }, {
                text: "0.82g por libra (Aceptable)",
                id: .82
            }, {
                text: "1.5g por libra (Muere Hambre)",
                id: 1.5
            }],
            weight: 60,
            weightKG: 60,
            weightLB: 135,
            height: 175,
            heightcm: 175,
            heightin: 68.9,
            heightID: 0,
            age: 20,
            ageID: 0,
            steps: 5e3,
            stepsID: 0,
            calp: -20,
            carbG: 20,
            fatP: 50,
            sOptions: {
                height: 6,
                dotSize: 16,
                tooltipDir: "right",
                tooltip: "hover",
                processStyle: {
                    backgroundColor: "#45B39D"
                },
                bgStyle: {
                    backgroundColor: "#F39C12"
                },
                tooltipStyle: {
                    backgroundColor: "#45B39D",
                    borderColor: "#45B39D"
                }
            },
            proP: 1,
            sOptions2: {
                height: 6,
                dotSize: 16,
                tooltipDir: "right",
                tooltip: "hover",
                min: .6,
                max: 1.6,
                interval: .1,
                processStyle: {
                    backgroundColor: "#2ECC71"
                },
                bgStyle: {
                    backgroundColor: "rgba(0,0,0,.1)",
                    boxShadow: "inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)"
                },
                tooltipStyle: {
                    backgroundColor: "#2ECC71",
                    borderColor: "#2ECC71",
                    color: "rgba(0,0,0,.84)"
                }
            },
            LGproP: 50,
            sOptions3: {
                height: 6,
                dotSize: 16,
                tooltipDir: "right",
                tooltip: "hover",
                min: 30,
                max: 80,
                interval: 1,
                processStyle: {
                    backgroundColor: "#2ECC71"
                },
                bgStyle: {
                    backgroundColor: "rgba(0,0,0,.1)",
                    boxShadow: "inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)"
                },
                tooltipStyle: {
                    backgroundColor: "#2ECC71",
                    borderColor: "#2ECC71",
                    color: "rgba(0,0,0,.84)"
                }
            },
            sOptions4: {
                height: 6,
                dotSize: 16,
                tooltipDir: "right",
                tooltip: "hover",
                min: 0,
                max: 25e3,
                interval: 500,
                processStyle: {
                    backgroundColor: "#5DADE2"
                },
                bgStyle: {
                    backgroundColor: "rgba(0,0,0,.1)",
                    boxShadow: "inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)"
                },
                tooltipStyle: {
                    backgroundColor: "#5DADE2",
                    borderColor: "#5DADE2",
                    color: "rgba(0,0,0,.84)"
                }
            }
        },
        computed: {
            thingToCopy: function() {
                var t = "\n\nCalorías|Proteína|Grasas|Carbohidratos\n|:-:|:-:|:-:|:-:|\n",
                    e = "\n\nEstimado ";
                return 2 === this.dietChoice ? "Tu TDEE es igual a " + this.tdee + t + this.calories + "|" + this.protein + "|" + this.fat + "|" + this.carbs + "|" + e + this.lostweight + " " + this.lborkg + " por semana" : "Tu BMR es igual a " + this.bmr + "\n\nTu TDEE es igual a " + this.tdee + t + this.calories + "|" + this.protein + "|" + this.fat + "|" + this.carbs + "|" + e + this.lostweight + " " + this.lborkg + " por semana"
            },
            bmr: function() {
                return 1 === this.selected ? Math.round(10 * this.weightKG + 6.25 * this.heightcm - 5 * this.age + this.genderID) : Math.round(this.weightLB / 2.20462 * 10 + 6.25 * this.heightin / .393701 - 5 * this.age + this.genderID)
            },
            tdee: function() {
                return 2 === this.dietChoice ? (this.age > 45 ? this.ageID = -.5 : this.age < 25 ? this.ageID = .5 : this.ageID = 0, this.steps < 6e3 ? this.stepsID = 0 : this.steps < 7500 ? this.stepsID = .5 : this.stepsID = .5 + .5 * Math.ceil((this.steps - 7499) / 1250), this.MisActive ? 1 === this.selected ? (this.heightcm > 185 ? this.heightID = 1 : this.heightcm < 167 ? this.heightID = -1 : this.heightID = 0, Math.round(this.weightKG * (28 + this.ageID + this.heightID + this.stepsID + this.mmassID + this.bfID))) : (this.heightin > 73 ? this.heightID = 1 : this.heightin < 65 ? this.heightID = -1 : this.heightID = 0, Math.round(this.weightLB / 2.205 * (28 + this.ageID + this.heightID + this.stepsID + this.mmassID + this.bfID))) : 1 === this.selected ? (this.heightcm > 170 ? this.heightID = 1 : this.heightcm < 153 ? this.heightID = -1 : this.heightID = 0, Math.round(this.weightKG * (26 + this.ageID + this.heightID + this.stepsID + this.mmassID + this.bfIDf))) : (this.heightin > 67 ? this.heightID = 1 : this.heightin < 60 ? this.heightID = -1 : this.heightID = 0, Math.round(this.weightLB / 2.205 * (26 + this.ageID + this.heightID + this.stepsID + this.mmassID + this.bfIDf)))) : Math.round(this.bmr * this.alevelID)
            },
            calories: function() {
                return 2 === this.dietChoice ? this.MisActive ? Math.round(this.tdee + this.LGgoalID) : Math.round(this.tdee + this.LGgoalIDf) : Math.round(this.tdee * (1 + this.calp / 100))
            },
            lostweight: function() {
                return 2 === this.dietChoice ? this.MisActive ? 1 === this.selected && this.LGgoalID <= 0 ? "-" + Math.abs(this.precise(7 * (this.tdee - this.calories) / 3500 / 2.20462, 2)) : 1 === this.selected && this.LGgoalID > 0 ? "+" + Math.abs(this.precise(7 * (this.tdee - this.calories) / 3500 / 2.20462, 2)) : 1 !== this.selected && this.LGgoalID <= 0 ? "-" + Math.abs(this.precise(7 * (this.tdee - this.calories) / 3500, 2)) : "+" + Math.abs(this.precise(7 * (this.tdee - this.calories) / 3500, 2)) : 1 === this.selected && this.LGgoalIDf <= 0 ? "-" + Math.abs(this.precise(7 * (this.tdee - this.calories) / 3500 / 2.20462, 2)) : 1 === this.selected && this.LGgoalIDf > 0 ? "+" + Math.abs(this.precise(7 * (this.tdee - this.calories) / 3500 / 2.20462, 2)) : 1 !== this.selected && this.LGgoalIDf <= 0 ? "-" + Math.abs(this.precise(7 * (this.tdee - this.calories) / 3500, 2)) : "+" + Math.abs(this.precise(7 * (this.tdee - this.calories) / 3500, 2)) : 1 === this.selected && this.calp <= 0 ? "-" + Math.abs(this.precise(7 * (this.tdee - this.calories) / 3500 / 2.20462, 2)) : 1 === this.selected && this.calp > 0 ? "+" + Math.abs(this.precise(7 * (this.tdee - this.calories) / 3500 / 2.20462, 2)) : 1 !== this.selected && this.calp <= 0 ? "-" + Math.abs(this.precise(7 * (this.tdee - this.calories) / 3500, 2)) : "+" + Math.abs(this.precise(7 * (this.tdee - this.calories) / 3500, 2))
            },
            protein: function() {
                return 1 === this.dietChoice ? 1 === this.selected ? Math.round(2.20462 * this.weight * this.proID) : Math.round(this.weight * this.proID) : 3 === this.dietChoice ? 1 === this.selected ? Math.round(2.20462 * this.weight * this.proP) : Math.round(this.weight * this.proP) : Math.round(this.LGproP * this.calories / 400)
            },
            fat: function() {
                return 3 === this.dietChoice ? Math.round((this.calories - 4 * this.protein - 4 * this.carbs) / 9) : Math.round((this.calories - 4 * this.protein) * this.fatP / 900)
            },
            carbs: function() {
                return 3 === this.dietChoice ? Math.round(this.carbG) : Math.round((this.calories - 4 * this.protein) * (100 - this.fatP) / 400)
            },
            lborkg: function() {
                return 1 === this.selected ? "kg" : "lb"
            }
        },
        watch: {
            selected: function(t, e) {
                1 === e ? (this.weight = this.precise(2.20462 * this.weight, 1), this.weightLB = 2.20462 * this.weightKG, this.height = this.precise(.393701 * this.height, 1), this.heightin = .393701 * this.heightcm) : (this.weight = this.precise(this.weight / 2.20462, 1), this.weightKG = this.weightLB / 2.20462, this.height = this.precise(this.height / .393701, 1), this.heightcm = this.heightin / .393701)
            },
            weight: function(t, e) {
                switch (t) {
                    case this.precise(2.20462 * e, 1):
                    case this.precise(e / 2.20462, 1):
                        break;
                    default:
                        1 === this.selected ? this.weightKG = t : this.weightLB = t
                }
            },
            height: function(t, e) {
                switch (t) {
                    case this.precise(.393701 * e, 1):
                    case this.precise(e / .393701, 1):
                        break;
                    default:
                        1 === this.selected ? this.heightcm = t : this.heightin = t
                }
            },
            goalID: function(t, e) {
                this.calp = t
            }
        },
        methods: {
            precise: function(t, e) {
                var i = function(t, e, i) {
                    i && (e = -e);
                    var r = ("" + t).split("e");
                    return +(r[0] + "e" + (r[1] ? +r[1] + e : e))
                };
                return i(Math.round(i(t, e, !1)), e, !0)
            },
            mClick: function() {
                this.MisActive = !0, this.FisActive = !1
            },
            fClick: function() {
                this.MisActive = !1, this.FisActive = !0
            }
        },
        components: {
            vueSlider: n.a,
            popper: p.a
        },
        mounted: function() {
            $('[data-toggle="tooltip"]').tooltip(), $('[data-toggle="tooltip-f"]').tooltip({
                trigger: "focus"
            })
        },
        created: function() {
            "?leangains" === window.location.search ? this.dietChoice = 2 : "?keto" === window.location.search && (this.dietChoice = 3)
        }
    }, s.a))
}, function(t, e, i) {
    "use strict";
    var r = i(6),
        s = i(7),
        o = i(5),
        n = o(r.a, s.a, null, null, null);
    e.a = n.exports
}, function(t, e) {
    t.exports = function(t, e, i, r, s) {
        var o, n = t = t || {},
            a = typeof t.default;
        "object" !== a && "function" !== a || (o = t, n = t.default);
        var l = "function" == typeof n ? n.options : n;
        e && (l.render = e.render, l.staticRenderFns = e.staticRenderFns), r && (l._scopeId = r);
        var c;
        if (s ? (c = function(t) {
                t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, t || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), i && i.call(this, t), t && t._registeredComponents && t._registeredComponents.add(s)
            }, l._ssrRegister = c) : i && (c = i), c) {
            var p = l.functional,
                u = p ? l.render : l.beforeCreate;
            p ? l.render = function(t, e) {
                return c.call(e), u(t, e)
            } : l.beforeCreate = u ? [].concat(u, c) : [c]
        }
        return {
            esModule: o,
            exports: n,
            options: l
        }
    }
}, function(t, e, i) {
    "use strict";
    e.a = {}
}, function(t, e, i) {
    "use strict";
    var r = function() {
            var t = this,
                e = t.$createElement,
                i = t._self._c || e;
            return i("div", [i("div", {
                staticClass: "row",
                attrs: {
                    id: "toprow"
                }
            }, [i("div", {
                staticClass: "col"
            }, [i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "diet-t"
                }
            }, [i("h3", {
                staticClass: "app-h3"
            }, [t._v("Dieta"), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n                Click for more info\n              ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1)]), t._v(" "), i("select", {
                directives: [{
                    name: "model",
                    rawName: "v-model",
                    value: t.dietChoice,
                    expression: "dietChoice"
                }],
                staticClass: "form-control",
                attrs: {
                    id: "diet-t"
                },
                on: {
                    change: function(e) {
                        var i = Array.prototype.filter.call(e.target.options, function(t) {
                            return t.selected
                        }).map(function(t) {
                            return "_value" in t ? t._value : t.value
                        });
                        t.dietChoice = e.target.multiple ? i : i[0]
                    }
                }
            }, t._l(t.dOps, function(e) {
                return i("option", {
                    domProps: {
                        value: e.id
                    }
                }, [t._v("\n            " + t._s(e.text) + "\n          ")])
            }))])]), t._v(" "), i("div", {
                staticClass: "col"
            }, [i("div", {
                staticClass: "form-group"
            }, [t._m(0), t._v(" "), i("select", {
                directives: [{
                    name: "model",
                    rawName: "v-model",
                    value: t.selected,
                    expression: "selected"
                }],
                staticClass: "form-control",
                attrs: {
                    id: "Unidades"
                },
                on: {
                    change: function(e) {
                        var i = Array.prototype.filter.call(e.target.options, function(t) {
                            return t.selected
                        }).map(function(t) {
                            return "_value" in t ? t._value : t.value
                        });
                        t.selected = e.target.multiple ? i : i[0]
                    }
                }
            }, t._l(t.options, function(e) {
                return i("option", {
                    domProps: {
                        value: e.id
                    }
                }, [t._v("\n            " + t._s(e.text) + "\n          ")])
            }))])])]), t._v(" "), 1 === t.dietChoice ? i("div", {
                staticClass: "row",
                attrs: {
                    id: "toprow2"
                }
            }, [i("div", {
                staticClass: "col-md-3 col-sm-12"
            }, [i("h3", {
                staticClass: "app-h3"
            }, [t._v("Estadísticas\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Click for more info\n          ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "age-d"
                }
            }, [t._v("Edad:")]), t._v(" "), i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.age,
                    expression: "age",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "age-d",
                    name: "age-d"
                },
                domProps: {
                    value: t.age
                },
                on: {
                    change: function(e) {
                        t.age = e.target.value
                    }
                }
            })]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "weight"
                }
            }, [t._v("Peso:")]), t._v(" "), i("div", {
                staticClass: "input-group"
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.weight,
                    expression: "weight",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "weight",
                    name: "weight"
                },
                domProps: {
                    value: t.weight
                },
                on: {
                    change: function(e) {
                        t.weight = e.target.value
                    }
                }
            }), t._v(" "), i("div", {
                staticClass: "input-group-append"
            }, [i("div", {
                directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: 1 === t.selected,
                    expression: "selected === 1"
                }],
                staticClass: "input-group-text"
            }, [t._v("kg")]), t._v(" "), i("div", {
                directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: 2 === t.selected,
                    expression: "selected === 2"
                }],
                staticClass: "input-group-text"
            }, [t._v("lb")])])])]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "height-d"
                }
            }, [t._v("Altura:")]), t._v(" "), i("div", {
                staticClass: "input-group"
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.height,
                    expression: "height",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "height-d",
                    name: "height-d"
                },
                domProps: {
                    value: t.height
                },
                on: {
                    change: function(e) {
                        t.height = e.target.value
                    }
                }
            }), t._v(" "), i("div", {
                staticClass: "input-group-append"
            }, [i("div", {
                directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: 1 === t.selected,
                    expression: "selected === 1"
                }],
                staticClass: "input-group-text"
            }, [t._v("cm")]), t._v(" "), i("div", {
                directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: 2 === t.selected,
                    expression: "selected === 2"
                }],
                staticClass: "input-group-text"
            }, [t._v("in")])])])]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", [t._v("Genero:")]), t._v(" "), i("div", {
                staticClass: "btn-group btn-group-toggle d-flex justify-content-center"
            }, [i("label", {
                staticClass: "btn btn-info",
                class: {
                    active: t.MisActive
                },
                attrs: {
                    id: "Hombre"
                }
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.number",
                    value: t.genderID,
                    expression: "genderID",
                    modifiers: {
                        number: !0
                    }
                }],
                attrs: {
                    type: "radio",
                    name: "s-options",
                    autocomplete: "on",
                    value: "5"
                },
                domProps: {
                    checked: t._q(t.genderID, t._n("5"))
                },
                on: {
                    change: t.mClick,
                    __c: function(e) {
                        t.genderID = t._n("5")
                    }
                }
            }), t._v(" Hombre\n          ")]), t._v(" "), i("label", {
                staticClass: "btn btn-info",
                class: {
                    active: t.FisActive
                },
                attrs: {
                    id: "Mujer"
                }
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.number",
                    value: t.genderID,
                    expression: "genderID",
                    modifiers: {
                        number: !0
                    }
                }],
                attrs: {
                    type: "radio",
                    name: "s-options",
                    autocomplete: "off",
                    value: "-160"
                },
                domProps: {
                    checked: t._q(t.genderID, t._n("-160"))
                },
                on: {
                    change: t.fClick,
                    __c: function(e) {
                        t.genderID = t._n("-160")
                    }
                }
            }), t._v(" Mujer\n          ")])])])]), t._v(" "), i("div", {
                staticClass: "col-md-4 col-sm-12"
            }, [i("h3", {
                staticClass: "app-h3"
            }, [t._v("Modificadores")]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "alevel"
                }
            }, [t._v("Nivel de Actividad:\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Click for more info\n            ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("select", {
                directives: [{
                    name: "model",
                    rawName: "v-model",
                    value: t.alevelID,
                    expression: "alevelID"
                }],
                staticClass: "form-control",
                attrs: {
                    id: "alevel"
                },
                on: {
                    change: function(e) {
                        var i = Array.prototype.filter.call(e.target.options, function(t) {
                            return t.selected
                        }).map(function(t) {
                            return "_value" in t ? t._value : t.value
                        });
                        t.alevelID = e.target.multiple ? i : i[0]
                    }
                }
            }, t._l(t.alevel, function(e) {
                return i("option", {
                    domProps: {
                        value: e.id
                    }
                }, [t._v("\n            " + t._s(e.text) + "\n          ")])
            }))]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "goal-d"
                }
            }, [t._v("Meta:\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Click for more info\n            ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("select", {
                directives: [{
                    name: "model",
                    rawName: "v-model",
                    value: t.goalID,
                    expression: "goalID"
                }],
                staticClass: "form-control",
                attrs: {
                    id: "goal-d"
                },
                on: {
                    change: function(e) {
                        var i = Array.prototype.filter.call(e.target.options, function(t) {
                            return t.selected
                        }).map(function(t) {
                            return "_value" in t ? t._value : t.value
                        });
                        t.goalID = e.target.multiple ? i : i[0]
                    }
                }
            }, t._l(t.goals, function(e) {
                return i("option", {
                    domProps: {
                        value: e.id
                    }
                }, [t._v("\n            " + t._s(e.text) + "\n          ")])
            }))]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "cal"
                }
            }, [t._v("Déficit Calórico/ Surplus:")]), t._v(" "), i("div", {
                staticClass: "input-group"
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.calp,
                    expression: "calp",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "cal",
                    name: "cal"
                },
                domProps: {
                    value: t.calp
                },
                on: {
                    change: function(e) {
                        t.calp = e.target.value
                    }
                }
            }), t._v(" "), t._m(1)])]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "pro"
                }
            }, [t._v("Cuanta Proteína?\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Click for more info\n            ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("select", {
                directives: [{
                    name: "model",
                    rawName: "v-model",
                    value: t.proID,
                    expression: "proID"
                }],
                staticClass: "form-control",
                attrs: {
                    id: "pro"
                },
                on: {
                    change: function(e) {
                        var i = Array.prototype.filter.call(e.target.options, function(t) {
                            return t.selected
                        }).map(function(t) {
                            return "_value" in t ? t._value : t.value
                        });
                        t.proID = e.target.multiple ? i : i[0]
                    }
                }
            }, t._l(t.plevel, function(e) {
                return i("option", {
                    domProps: {
                        value: e.id
                    }
                }, [t._v("\n            " + t._s(e.text) + "\n          ")])
            }))]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "fatP"
                }
            }, [t._v("Grasas/Carbohidratos:\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Click for more info\n            ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("br"), t._v(" "), i("vue-slider", t._b({
                model: {
                    value: t.fatP,
                    callback: function(e) {
                        t.fatP = e
                    },
                    expression: "fatP"
                }
            }, "vue-slider", t.sOptions, !1)), t._v(" "), i("div", {
                staticClass: "input-group"
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.fatP,
                    expression: "fatP",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "fatP"
                },
                domProps: {
                    value: t.fatP
                },
                on: {
                    change: function(e) {
                        t.fatP = e.target.value
                    }
                }
            }), t._v(" "), t._m(2)])], 1)]), t._v(" "), i("div", {
                staticClass: "col-md-5 col-sm-12"
            }, [i("h3", {
                staticClass: "app-h3",
                staticStyle: {
                    display: "inline"
                }
            }, [t._v("Resultados")]), t._v(" "), i("span", {
                attrs: {
                    "data-toggle": "tooltip",
                    "data-placement": "right",
                    title: "Click to Copy (reddit-style markdown)"
                }
            }, [i("button", {
                directives: [{
                    name: "clipboard",
                    rawName: "v-clipboard:copy",
                    value: t.thingToCopy,
                    expression: "thingToCopy",
                    arg: "copy"
                }],
                staticClass: "btn btn-sm btn-outline-secondary",
                attrs: {
                    id: "copyB",
                    type: "button",
                    "data-toggle": "tooltip-f",
                    "data-placement": "top",
                    title: "Copied!"
                }
            }, [i("svg", {
                staticStyle: {
                    "-ms-transform": "rotate(360deg)",
                    "-webkit-transform": "rotate(360deg)",
                    transform: "rotate(360deg)"
                },
                attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    "aria-hidden": "true",
                    width: "14",
                    height: "16",
                    preserveAspectRatio: "xMidYMid meet",
                    viewBox: "0 0 14 16"
                }
            }, [i("path", {
                attrs: {
                    "fill-rule": "evenodd",
                    d: "M2 13h4v1H2v-1zm5-6H2v1h5V7zm2 3V8l-3 3 3 3v-2h5v-2H9zM4.5 9H2v1h2.5V9zM2 12h2.5v-1H2v1zm9 1h1v2c-.02.28-.11.52-.3.7-.19.18-.42.28-.7.3H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h3c0-1.11.89-2 2-2 1.11 0 2 .89 2 2h3c.55 0 1 .45 1 1v5h-1V6H1v9h10v-2zM2 5h8c0-.55-.45-1-1-1H8c-.55 0-1-.45-1-1s-.45-1-1-1-1 .45-1 1-.45 1-1 1H3c-.55 0-1 .45-1 1z",
                    fill: "black"
                }
            })])])]), t._v(" "), i("h4", {
                staticClass: "app-h4",
                attrs: {
                    id: "bmr-h"
                }
            }, [t._v("Tu\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "bottom"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Tasa Metabólica Basal\n          ")]), t._v(" "), i("b", {
                slot: "reference"
            }, [t._v("BMR")])]), t._v("\n        es "), i("b", [t._v(t._s(t.bmr))]), t._v(" cal\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Click for more info\n          ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("h4", {
                staticClass: "app-h4",
                attrs: {
                    id: "tdee-h"
                }
            }, [t._v("Tu\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "bottom"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Gasto Total de Energía Diaria\n          ")]), t._v(" "), i("b", {
                slot: "reference"
            }, [t._v("TDEE")])]), t._v("\n        es "), i("b", [t._v(" " + t._s(t.tdee) + " ")]), t._v(" cal\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Click for more info\n          ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("h4", {
                staticClass: "app-h4"
            }, [t._v("Calorías Diarias y Macros\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Click for more info\n          ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("table", {
                staticClass: "table",
                attrs: {
                    id: "cal-table"
                }
            }, [t._m(3), t._v(" "), i("tbody", [i("tr", {
                attrs: {
                    id: "tbl-r2"
                }
            }, [i("td", {
                attrs: {
                    id: "caltab-r"
                }
            }, [t._v(t._s(t.calories))]), t._v(" "), i("td", {
                attrs: {
                    id: "protab-r"
                }
            }, [t._v(t._s(t.protein))]), t._v(" "), i("td", {
                attrs: {
                    id: "fattab-r"
                }
            }, [t._v(t._s(t.fat))]), t._v(" "), i("td", {
                attrs: {
                    id: "cartab-r"
                }
            }, [t._v(t._s(t.carbs))])])])]), t._v(" "), i("h4", {
                attrs: {
                    id: "lw-heading"
                }
            }, [t._v("Estimado " + t._s(t.lostweight) + " " + t._s(t.lborkg) + " por semana\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "bottom"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Click for more info\n          ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("section", {
                staticClass: "sh-app",
                attrs: {
                    id: "sh-app2"
                }
            }, [i("p", [t._v("")]), t._v(" "), i("a", {
                attrs: {
                    "aria-label": "Share on Twitter",
                    rel: "noopener nofollow",
                    href: "",
                    target: "_blank",
                    title: "Share on Twitter"
                }
            }, [i("svg", {
                staticClass: "icon twit",
                attrs: {
                    viewBox: "0 0 951 1024"
                }
            }, [i("path", {
                staticClass: "path1",
                attrs: {
                    d: ""
                }
            })])]), t._v(" "), i("a", {
                attrs: {
                    "aria-label": "Share on Facebook",
                    rel: "noopener nofollow",
                    href: "",
                    target: "_blank",
                    title: "Share on Facebook"
                }
            }, [i("svg", {
                staticClass: "icon",
                attrs: {
                    id: "face",
                    viewBox: "0 0 585 1024"
                }
            }, [i("path", {
                staticClass: "path1",
                attrs: {
                    d: ""
                }
            })])])])])]) : 2 === t.dietChoice ? i("div", {
                staticClass: "row",
                attrs: {
                    id: "toprow2"
                }
            }, [i("div", {
                staticClass: "col-md-3 col-sm-12"
            }, [i("h3", {
                staticClass: "app-h3"
            }, [t._v("Estadísticas")]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "age-d"
                }
            }, [t._v("Edad:\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Click for more info\n            ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.age,
                    expression: "age",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "age-d",
                    name: "age-d"
                },
                domProps: {
                    value: t.age
                },
                on: {
                    change: function(e) {
                        t.age = e.target.value
                    }
                }
            })]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "weight"
                }
            }, [t._v("Peso:\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Click for more info\n            ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("div", {
                staticClass: "input-group"
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.weight,
                    expression: "weight",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "weight",
                    name: "weight"
                },
                domProps: {
                    value: t.weight
                },
                on: {
                    change: function(e) {
                        t.weight = e.target.value
                    }
                }
            }), t._v(" "), i("div", {
                staticClass: "input-group-append"
            }, [i("div", {
                directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: 1 === t.selected,
                    expression: "selected === 1"
                }],
                staticClass: "input-group-text"
            }, [t._v("kg")]), t._v(" "), i("div", {
                directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: 2 === t.selected,
                    expression: "selected === 2"
                }],
                staticClass: "input-group-text"
            }, [t._v("lb")])])])]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "height-d"
                }
            }, [t._v("Altura:\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Click for more info\n            ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("div", {
                staticClass: "input-group"
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.height,
                    expression: "height",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "height-d",
                    name: "height-d"
                },
                domProps: {
                    value: t.height
                },
                on: {
                    change: function(e) {
                        t.height = e.target.value
                    }
                }
            }), t._v(" "), i("div", {
                staticClass: "input-group-append"
            }, [i("div", {
                directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: 1 === t.selected,
                    expression: "selected === 1"
                }],
                staticClass: "input-group-text"
            }, [t._v("cm")]), t._v(" "), i("div", {
                directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: 2 === t.selected,
                    expression: "selected === 2"
                }],
                staticClass: "input-group-text"
            }, [t._v("in")])])])]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "gender"
                }
            }, [t._v("Genero:")]), t._v(" "), i("div", {
                staticClass: "btn-group btn-group-toggle d-flex justify-content-center"
            }, [i("label", {
                staticClass: "btn btn-info",
                class: {
                    active: t.MisActive
                },
                attrs: {
                    id: "Hombre"
                }
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.number",
                    value: t.genderID,
                    expression: "genderID",
                    modifiers: {
                        number: !0
                    }
                }],
                attrs: {
                    type: "radio",
                    name: "l-options",
                    autocomplete: "on",
                    value: "5"
                },
                domProps: {
                    checked: t._q(t.genderID, t._n("5"))
                },
                on: {
                    change: t.mClick,
                    __c: function(e) {
                        t.genderID = t._n("5")
                    }
                }
            }), t._v(" Hombre\n          ")]), t._v(" "), i("label", {
                staticClass: "btn btn-info",
                class: {
                    active: t.FisActive
                },
                attrs: {
                    id: "Mujer"
                }
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.number",
                    value: t.genderID,
                    expression: "genderID",
                    modifiers: {
                        number: !0
                    }
                }],
                attrs: {
                    type: "radio",
                    name: "l-options",
                    autocomplete: "off",
                    value: "-160"
                },
                domProps: {
                    checked: t._q(t.genderID, t._n("-160"))
                },
                on: {
                    change: t.fClick,
                    __c: function(e) {
                        t.genderID = t._n("-160")
                    }
                }
            }), t._v(" Mujer\n          ")])])]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "bf"
                }
            }, [t._v("Grasa Corporal:\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Click for more info\n            ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), t.MisActive ? i("select", {
                directives: [{
                    name: "model",
                    rawName: "v-model",
                    value: t.bfID,
                    expression: "bfID"
                }],
                staticClass: "form-control",
                attrs: {
                    id: "bf"
                },
                on: {
                    change: function(e) {
                        var i = Array.prototype.filter.call(e.target.options, function(t) {
                            return t.selected
                        }).map(function(t) {
                            return "_value" in t ? t._value : t.value
                        });
                        t.bfID = e.target.multiple ? i : i[0]
                    }
                }
            }, t._l(t.bf, function(e) {
                return i("option", {
                    domProps: {
                        value: e.id
                    }
                }, [t._v("\n            " + t._s(e.text) + "\n          ")])
            })) : i("select", {
                directives: [{
                    name: "model",
                    rawName: "v-model",
                    value: t.bfIDf,
                    expression: "bfIDf"
                }],
                staticClass: "form-control",
                attrs: {
                    id: "bf"
                },
                on: {
                    change: function(e) {
                        var i = Array.prototype.filter.call(e.target.options, function(t) {
                            return t.selected
                        }).map(function(t) {
                            return "_value" in t ? t._value : t.value
                        });
                        t.bfIDf = e.target.multiple ? i : i[0]
                    }
                }
            }, t._l(t.bff, function(e) {
                return i("option", {
                    domProps: {
                        value: e.id
                    }
                }, [t._v("\n            " + t._s(e.text) + "\n          ")])
            })), t._v(" "), i("div", {
                staticClass: "calc-info"
            }, [t._v("(test this with\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right",
                        modifiers: {
                            offset: {
                                offset: "0,10px"
                            }
                        }
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Links to Amazon\n            ")]), t._v(" "), i("a", {
                attrs: {
                    rel: "nofollow",
                    target: "_blank",
                    href: "https://geni.us/body-fat"
                },
                slot: "reference"
            }, [t._v("calipers")])]), t._v(")\n        ")], 1)]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "mmass"
                }
            }, [t._v("Masa Muscular:\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Click for more info\n            ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("select", {
                directives: [{
                    name: "model",
                    rawName: "v-model",
                    value: t.mmassID,
                    expression: "mmassID"
                }],
                staticClass: "form-control",
                attrs: {
                    id: "mmass"
                },
                on: {
                    change: function(e) {
                        var i = Array.prototype.filter.call(e.target.options, function(t) {
                            return t.selected
                        }).map(function(t) {
                            return "_value" in t ? t._value : t.value
                        });
                        t.mmassID = e.target.multiple ? i : i[0]
                    }
                }
            }, t._l(t.mmass, function(e) {
                return i("option", {
                    domProps: {
                        value: e.id
                    }
                }, [t._v("\n            " + t._s(e.text) + "\n          ")])
            }))])]), t._v(" "), i("div", {
                staticClass: "col-md-4 col-sm-12"
            }, [i("h3", {
                staticClass: "app-h3"
            }, [t._v("Modificadores")]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "goal-lg-d"
                }
            }, [t._v("Meta:\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Click for more info\n            ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), t.MisActive ? i("select", {
                directives: [{
                    name: "model",
                    rawName: "v-model",
                    value: t.LGgoalID,
                    expression: "LGgoalID"
                }],
                staticClass: "form-control",
                attrs: {
                    id: "goal-lg-d"
                },
                on: {
                    change: function(e) {
                        var i = Array.prototype.filter.call(e.target.options, function(t) {
                            return t.selected
                        }).map(function(t) {
                            return "_value" in t ? t._value : t.value
                        });
                        t.LGgoalID = e.target.multiple ? i : i[0]
                    }
                }
            }, t._l(t.LGgoals, function(e) {
                return i("option", {
                    domProps: {
                        value: e.id
                    }
                }, [t._v("\n            " + t._s(e.text) + "\n          ")])
            })) : i("select", {
                directives: [{
                    name: "model",
                    rawName: "v-model",
                    value: t.LGgoalIDf,
                    expression: "LGgoalIDf"
                }],
                staticClass: "form-control",
                attrs: {
                    id: "goal-lg-d"
                },
                on: {
                    change: function(e) {
                        var i = Array.prototype.filter.call(e.target.options, function(t) {
                            return t.selected
                        }).map(function(t) {
                            return "_value" in t ? t._value : t.value
                        });
                        t.LGgoalIDf = e.target.multiple ? i : i[0]
                    }
                }
            }, t._l(t.LGgoalsf, function(e) {
                return i("option", {
                    domProps: {
                        value: e.id
                    }
                }, [t._v("\n            " + t._s(e.text) + "\n          ")])
            }))]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "steps-d"
                }
            }, [t._v("Steps:\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Click for more info\n            ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("br"), t._v(" "), i("vue-slider", t._b({
                model: {
                    value: t.steps,
                    callback: function(e) {
                        t.steps = e
                    },
                    expression: "steps"
                }
            }, "vue-slider", t.sOptions4, !1)), t._v(" "), i("div", {
                staticClass: "input-group"
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.steps,
                    expression: "steps",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "steps-d"
                },
                domProps: {
                    value: t.steps
                },
                on: {
                    change: function(e) {
                        t.steps = e.target.value
                    }
                }
            }), t._v(" "), t._m(4)])], 1), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "proP"
                }
            }, [t._v("Cuanta Proteína?\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Click for more info\n            ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("br"), t._v(" "), i("vue-slider", t._b({
                model: {
                    value: t.LGproP,
                    callback: function(e) {
                        t.LGproP = e
                    },
                    expression: "LGproP"
                }
            }, "vue-slider", t.sOptions3, !1)), t._v(" "), i("div", {
                staticClass: "input-group"
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.LGproP,
                    expression: "LGproP",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "proP"
                },
                domProps: {
                    value: t.LGproP
                },
                on: {
                    change: function(e) {
                        t.LGproP = e.target.value
                    }
                }
            }), t._v(" "), t._m(5)])], 1), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "fatP"
                }
            }, [t._v("Grasas/Carbohidratos:\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Click for more info\n            ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("br"), t._v(" "), i("vue-slider", t._b({
                model: {
                    value: t.fatP,
                    callback: function(e) {
                        t.fatP = e
                    },
                    expression: "fatP"
                }
            }, "vue-slider", t.sOptions, !1)), t._v(" "), i("div", {
                staticClass: "input-group"
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.fatP,
                    expression: "fatP",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "fatP"
                },
                domProps: {
                    value: t.fatP
                },
                on: {
                    change: function(e) {
                        t.fatP = e.target.value
                    }
                }
            }), t._v(" "), t._m(6)])], 1)]), t._v(" "), i("div", {
                staticClass: "col-md-5 col-sm-12"
            }, [i("h3", {
                staticClass: "app-h3",
                staticStyle: {
                    display: "inline"
                }
            }, [t._v("Resultados")]), t._v(" "), i("span", {
                attrs: {
                    "data-toggle": "tooltip",
                    "data-placement": "right",
                    title: "Click to Copy (reddit-style markdown)"
                }
            }, [i("button", {
                directives: [{
                    name: "clipboard",
                    rawName: "v-clipboard:copy",
                    value: t.thingToCopy,
                    expression: "thingToCopy",
                    arg: "copy"
                }],
                staticClass: "btn btn-sm btn-outline-secondary",
                attrs: {
                    id: "copyB",
                    type: "button",
                    "data-toggle": "tooltip-f",
                    "data-placement": "top",
                    title: "Copied!"
                }
            }, [i("svg", {
                staticStyle: {
                    "-ms-transform": "rotate(360deg)",
                    "-webkit-transform": "rotate(360deg)",
                    transform: "rotate(360deg)"
                },
                attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    "aria-hidden": "true",
                    width: "14",
                    height: "16",
                    preserveAspectRatio: "xMidYMid meet",
                    viewBox: "0 0 14 16"
                }
            }, [i("path", {
                attrs: {
                    "fill-rule": "evenodd",
                    d: "M2 13h4v1H2v-1zm5-6H2v1h5V7zm2 3V8l-3 3 3 3v-2h5v-2H9zM4.5 9H2v1h2.5V9zM2 12h2.5v-1H2v1zm9 1h1v2c-.02.28-.11.52-.3.7-.19.18-.42.28-.7.3H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h3c0-1.11.89-2 2-2 1.11 0 2 .89 2 2h3c.55 0 1 .45 1 1v5h-1V6H1v9h10v-2zM2 5h8c0-.55-.45-1-1-1H8c-.55 0-1-.45-1-1s-.45-1-1-1-1 .45-1 1-.45 1-1 1H3c-.55 0-1 .45-1 1z",
                    fill: "black"
                }
            })])])]), t._v(" "), i("h4", {
                staticClass: "app-h4",
                attrs: {
                    id: "tdee-lg"
                }
            }, [t._v("Tu\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "bottom"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Gasto total de Energía Diaria\n          ")]), t._v(" "), i("b", {
                slot: "reference"
            }, [t._v("TDEE")])]), t._v("\n        is "), i("b", [t._v(" " + t._s(t.tdee) + " ")]), t._v(" cal\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Click for more info\n          ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("br", {
                attrs: {
                    id: "calc-break"
                }
            }), t._v(" "), i("h4", {
                staticClass: "app-h4",
                attrs: {
                    id: "lg-macros"
                }
            }, [t._v("Calorías Diarias y Macros\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Click for more info\n          ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("table", {
                staticClass: "table",
                attrs: {
                    id: "cal-table"
                }
            }, [t._m(7), t._v(" "), i("tbody", [i("tr", {
                attrs: {
                    id: "tbl-r2"
                }
            }, [i("td", {
                attrs: {
                    id: "caltab-r"
                }
            }, [t._v(t._s(t.calories))]), t._v(" "), i("td", {
                attrs: {
                    id: "protab-r"
                }
            }, [t._v(t._s(t.protein))]), t._v(" "), i("td", {
                attrs: {
                    id: "fattab-r"
                }
            }, [t._v(t._s(t.fat))]), t._v(" "), i("td", {
                attrs: {
                    id: "cartab-r"
                }
            }, [t._v(t._s(t.carbs))])])])]), t._v(" "), i("h4", {
                attrs: {
                    id: "lw-heading-lg"
                }
            }, [t._v("Estimado " + t._s(t.lostweight) + " " + t._s(t.lborkg) + " por semana\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "bottom"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Click for more info\n          ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("section", {
                staticClass: "sh-app",
                attrs: {
                    id: "sh-app2"
                }
            }, [i("p", [t._v("")]), t._v(" "), i("a", {
                attrs: {
                    "aria-label": "Share on Twitter",
                    rel: "noopener nofollow",
                    href: "",
                    target: "_blank",
                    title: "Share on Twitter"
                }
            }, [i("svg", {
                staticClass: "icon twit",
                attrs: {
                    viewBox: "0 0 951 1024"
                }
            }, [i("path", {
                staticClass: "path1",
                attrs: {
                    d: ""
                }
            })])]), t._v(" "), i("a", {
                attrs: {
                    "aria-label": "Share on Facebook",
                    rel: "noopener nofollow",
                    href: "",
                    target: "_blank",
                    title: "Share on Facebook"
                }
            }, [i("svg", {
                staticClass: "icon",
                attrs: {
                    id: "face",
                    viewBox: "0 0 585 1024"
                }
            }, [i("path", {
                staticClass: "path1",
                attrs: {
                    d: ""
                }
            })])])])])]) : i("div", {
                staticClass: "row",
                attrs: {
                    id: "toprow2"
                }
            }, [i("div", {
                staticClass: "col-md-3 col-sm-12"
            }, [i("h3", {
                staticClass: "app-h3"
            }, [t._v("Estadísticas\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Click for more info\n          ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "age-d"
                }
            }, [t._v("Edad:")]), t._v(" "), i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.age,
                    expression: "age",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "age-d",
                    name: "age-d"
                },
                domProps: {
                    value: t.age
                },
                on: {
                    change: function(e) {
                        t.age = e.target.value
                    }
                }
            })]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "weight"
                }
            }, [t._v("Peso:")]), t._v(" "), i("div", {
                staticClass: "input-group"
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.weight,
                    expression: "weight",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "weight",
                    name: "weight"
                },
                domProps: {
                    value: t.weight
                },
                on: {
                    change: function(e) {
                        t.weight = e.target.value
                    }
                }
            }), t._v(" "), i("div", {
                staticClass: "input-group-append"
            }, [i("div", {
                directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: 1 === t.selected,
                    expression: "selected === 1"
                }],
                staticClass: "input-group-text"
            }, [t._v("kg")]), t._v(" "), i("div", {
                directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: 2 === t.selected,
                    expression: "selected === 2"
                }],
                staticClass: "input-group-text"
            }, [t._v("lb")])])])]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "height-d"
                }
            }, [t._v("Altura:")]), t._v(" "), i("div", {
                staticClass: "input-group"
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.height,
                    expression: "height",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "height-d",
                    name: "height-d"
                },
                domProps: {
                    value: t.height
                },
                on: {
                    change: function(e) {
                        t.height = e.target.value
                    }
                }
            }), t._v(" "), i("div", {
                staticClass: "input-group-append"
            }, [i("div", {
                directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: 1 === t.selected,
                    expression: "selected === 1"
                }],
                staticClass: "input-group-text"
            }, [t._v("cm")]), t._v(" "), i("div", {
                directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: 2 === t.selected,
                    expression: "selected === 2"
                }],
                staticClass: "input-group-text"
            }, [t._v("in")])])])]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "gender"
                }
            }, [t._v("Genero:")]), t._v(" "), i("div", {
                staticClass: "btn-group btn-group-toggle d-flex justify-content-center"
            }, [i("label", {
                staticClass: "btn btn-info",
                class: {
                    active: t.MisActive
                },
                attrs: {
                    id: "Hombre"
                }
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.number",
                    value: t.genderID,
                    expression: "genderID",
                    modifiers: {
                        number: !0
                    }
                }],
                attrs: {
                    type: "radio",
                    name: "k-options",
                    autocomplete: "on",
                    value: "5"
                },
                domProps: {
                    checked: t._q(t.genderID, t._n("5"))
                },
                on: {
                    change: t.mClick,
                    __c: function(e) {
                        t.genderID = t._n("5")
                    }
                }
            }), t._v(" Hombre\n          ")]), t._v(" "), i("label", {
                staticClass: "btn btn-info",
                class: {
                    active: t.FisActive
                },
                attrs: {
                    id: "Mujer"
                }
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.number",
                    value: t.genderID,
                    expression: "genderID",
                    modifiers: {
                        number: !0
                    }
                }],
                attrs: {
                    type: "radio",
                    name: "k-options",
                    autocomplete: "off",
                    value: "-160"
                },
                domProps: {
                    checked: t._q(t.genderID, t._n("-160"))
                },
                on: {
                    change: t.fClick,
                    __c: function(e) {
                        t.genderID = t._n("-160")
                    }
                }
            }), t._v(" Mujer\n          ")])])])]), t._v(" "), i("div", {
                staticClass: "col-md-4 col-sm-12"
            }, [i("h3", {
                staticClass: "app-h3"
            }, [t._v("Modificadores")]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "alevel"
                }
            }, [t._v("Nivel de Actividad:\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Click for more info\n            ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("select", {
                directives: [{
                    name: "model",
                    rawName: "v-model",
                    value: t.alevelID,
                    expression: "alevelID"
                }],
                staticClass: "form-control",
                attrs: {
                    id: "alevel"
                },
                on: {
                    change: function(e) {
                        var i = Array.prototype.filter.call(e.target.options, function(t) {
                            return t.selected
                        }).map(function(t) {
                            return "_value" in t ? t._value : t.value
                        });
                        t.alevelID = e.target.multiple ? i : i[0]
                    }
                }
            }, t._l(t.alevel, function(e) {
                return i("option", {
                    domProps: {
                        value: e.id
                    }
                }, [t._v("\n            " + t._s(e.text) + "\n          ")])
            }))]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "goal-d"
                }
            }, [t._v("Meta:\n          "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n              Click for more info\n            ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("select", {
                directives: [{
                    name: "model",
                    rawName: "v-model",
                    value: t.goalID,
                    expression: "goalID"
                }],
                staticClass: "form-control",
                attrs: {
                    id: "goal-d"
                },
                on: {
                    change: function(e) {
                        var i = Array.prototype.filter.call(e.target.options, function(t) {
                            return t.selected
                        }).map(function(t) {
                            return "_value" in t ? t._value : t.value
                        });
                        t.goalID = e.target.multiple ? i : i[0]
                    }
                }
            }, t._l(t.goals, function(e) {
                return i("option", {
                    domProps: {
                        value: e.id
                    }
                }, [t._v("\n            " + t._s(e.text) + "\n          ")])
            }))]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "cal"
                }
            }, [t._v("Déficit Calórico/ Surplus:")]), t._v(" "), i("div", {
                staticClass: "input-group"
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.calp,
                    expression: "calp",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "cal",
                    name: "cal"
                },
                domProps: {
                    value: t.calp
                },
                on: {
                    change: function(e) {
                        t.calp = e.target.value
                    }
                }
            }), t._v(" "), t._m(8)])]), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "proP"
                }
            }, [t._v("Cuanta Proteína?")]), t._v(" "), i("br"), t._v(" "), i("vue-slider", t._b({
                model: {
                    value: t.proP,
                    callback: function(e) {
                        t.proP = e
                    },
                    expression: "proP"
                }
            }, "vue-slider", t.sOptions2, !1)), t._v(" "), i("div", {
                staticClass: "input-group"
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.proP,
                    expression: "proP",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "proP"
                },
                domProps: {
                    value: t.proP
                },
                on: {
                    change: function(e) {
                        t.proP = e.target.value
                    }
                }
            }), t._v(" "), t._m(9)])], 1), t._v(" "), i("div", {
                staticClass: "form-group"
            }, [i("label", {
                attrs: {
                    for: "carbG"
                }
            }, [t._v("Carb Limit:")]), t._v(" "), i("div", {
                staticClass: "input-group"
            }, [i("input", {
                directives: [{
                    name: "model",
                    rawName: "v-model.lazy",
                    value: t.carbG,
                    expression: "carbG",
                    modifiers: {
                        lazy: !0
                    }
                }],
                staticClass: "form-control",
                attrs: {
                    type: "number",
                    id: "carbG"
                },
                domProps: {
                    value: t.carbG
                },
                on: {
                    change: function(e) {
                        t.carbG = e.target.value
                    }
                }
            }), t._v(" "), t._m(10)])])]), t._v(" "), i("div", {
                staticClass: "col-md-5 col-sm-12"
            }, [i("h3", {
                staticClass: "app-h3",
                staticStyle: {
                    display: "inline"
                }
            }, [t._v("Resultados")]), t._v(" "), i("span", {
                attrs: {
                    "data-toggle": "tooltip",
                    "data-placement": "right",
                    title: "Click to Copy (reddit-style markdown)"
                }
            }, [i("button", {
                directives: [{
                    name: "clipboard",
                    rawName: "v-clipboard:copy",
                    value: t.thingToCopy,
                    expression: "thingToCopy",
                    arg: "copy"
                }],
                staticClass: "btn btn-sm btn-outline-secondary",
                attrs: {
                    id: "copyB",
                    type: "button",
                    "data-toggle": "tooltip-f",
                    "data-placement": "top",
                    title: "Copied!"
                }
            }, [i("svg", {
                staticStyle: {
                    "-ms-transform": "rotate(360deg)",
                    "-webkit-transform": "rotate(360deg)",
                    transform: "rotate(360deg)"
                },
                attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    "aria-hidden": "true",
                    width: "14",
                    height: "16",
                    preserveAspectRatio: "xMidYMid meet",
                    viewBox: "0 0 14 16"
                }
            }, [i("path", {
                attrs: {
                    "fill-rule": "evenodd",
                    d: "M2 13h4v1H2v-1zm5-6H2v1h5V7zm2 3V8l-3 3 3 3v-2h5v-2H9zM4.5 9H2v1h2.5V9zM2 12h2.5v-1H2v1zm9 1h1v2c-.02.28-.11.52-.3.7-.19.18-.42.28-.7.3H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h3c0-1.11.89-2 2-2 1.11 0 2 .89 2 2h3c.55 0 1 .45 1 1v5h-1V6H1v9h10v-2zM2 5h8c0-.55-.45-1-1-1H8c-.55 0-1-.45-1-1s-.45-1-1-1-1 .45-1 1-.45 1-1 1H3c-.55 0-1 .45-1 1z",
                    fill: "black"
                }
            })])])]), t._v(" "), i("h4", {
                staticClass: "app-h4",
                attrs: {
                    id: "bmr-h"
                }
            }, [t._v("Tu\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "bottom"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Tasa Metabólica Basal\n          ")]), t._v(" "), i("b", {
                slot: "reference"
            }, [t._v("BMR")])]), t._v("\n        es "), i("b", [t._v(t._s(t.bmr))]), t._v(" cal\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Click for more info\n          ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("h4", {
                staticClass: "app-h4",
                attrs: {
                    id: "tdee-h"
                }
            }, [t._v("Tu\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "bottom"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Gasto Total de Energía Diaria\n          ")]), t._v(" "), i("b", {
                slot: "reference"
            }, [t._v("TDEE")])]), t._v("\n        es "), i("b", [t._v(" " + t._s(t.tdee) + " ")]), t._v(" cal\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Click for more info\n          ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("h4", {
                staticClass: "app-h4"
            }, [t._v("Calorías Diarias y Macros\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "right"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Click for more info\n          ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("table", {
                staticClass: "table",
                attrs: {
                    id: "cal-table"
                }
            }, [t._m(11), t._v(" "), i("tbody", [i("tr", {
                attrs: {
                    id: "tbl-r2"
                }
            }, [i("td", {
                attrs: {
                    id: "caltab-r"
                }
            }, [t._v(t._s(t.calories))]), t._v(" "), i("td", {
                attrs: {
                    id: "protab-r"
                }
            }, [t._v(t._s(t.protein))]), t._v(" "), i("td", {
                attrs: {
                    id: "fattab-r"
                }
            }, [t._v(t._s(t.fat))]), t._v(" "), i("td", {
                attrs: {
                    id: "cartab-r"
                }
            }, [t._v(t._s(t.carbs))])])])]), t._v(" "), i("h4", {
                attrs: {
                    id: "lw-heading"
                }
            }, [t._v("Estimado " + t._s(t.lostweight) + " " + t._s(t.lborkg) + " por semana\n        "), i("popper", {
                attrs: {
                    trigger: "hover",
                    options: {
                        placement: "bottom"
                    }
                }
            }, [i("div", {
                staticClass: "popper"
            }, [t._v("\n            Click for more info\n          ")]), t._v(" "), i("a", {
                attrs: {
                    href: ""
                },
                slot: "reference"
            }, [i("img", {
                staticClass: "info",
                attrs: {
                    src: ""
                }
            })])])], 1), t._v(" "), i("section", {
                staticClass: "sh-app",
                attrs: {
                    id: "sh-app2"
                }
            }, [i("p", [t._v("")]), t._v(" "), i("a", {
                attrs: {
                    "aria-label": "Share on Twitter",
                    rel: "noopener nofollow",
                    href: "",
                    target: "_blank",
                    title: "Share on Twitter"
                }
            }, [i("svg", {
                staticClass: "icon twit",
                attrs: {
                    viewBox: "0 0 951 1024"
                }
            }, [i("path", {
                staticClass: "path1",
                attrs: {
                    d: ""
                }
            })])]), t._v(" "), i("a", {
                attrs: {
                    "aria-label": "Share on Facebook",
                    rel: "noopener nofollow",
                    href: "",
                    target: "_blank",
                    title: "Share on Facebook"
                }
            }, [i("svg", {
                staticClass: "icon",
                attrs: {
                    id: "face",
                    viewBox: "0 0 585 1024"
                }
            }, [i("path", {
                staticClass: "path1",
                attrs: {
                    d: ""
                }
            })])])])])])])
        },
        s = [function() {
            var t = this,
                e = t.$createElement,
                i = t._self._c || e;
            return i("label", {
                attrs: {
                    for: "Unidades"
                }
            }, [i("h3", {
                staticClass: "app-h3"
            }, [t._v("Unidades")])])
        }, function() {
            var t = this,
                e = t.$createElement,
                i = t._self._c || e;
            return i("div", {
                staticClass: "input-group-append"
            }, [i("div", {
                staticClass: "input-group-text input-group-std"
            }, [t._v("%")])])
        }, function() {
            var t = this,
                e = t.$createElement,
                i = t._self._c || e;
            return i("div", {
                staticClass: "input-group-append"
            }, [i("div", {
                staticClass: "input-group-text input-group-std"
            }, [t._v("% Grasas")])])
        }, function() {
            var t = this,
                e = t.$createElement,
                i = t._self._c || e;
            return i("thead", [i("tr", {
                attrs: {
                    id: "tbl-r"
                }
            }, [i("th", {
                staticStyle: {
                    width: "28%"
                },
                attrs: {
                    scope: "col",
                    id: "caltab"
                }
            }, [t._v("Calorías")]), t._v(" "), i("th", {
                staticStyle: {
                    width: "24%"
                },
                attrs: {
                    scope: "col",
                    id: "protab"
                }
            }, [t._v("Proteína")]), t._v(" "), i("th", {
                staticStyle: {
                    width: "24%"
                },
                attrs: {
                    scope: "col",
                    id: "fattab"
                }
            }, [t._v("Grasa")]), t._v(" "), i("th", {
                staticStyle: {
                    width: "24%"
                },
                attrs: {
                    scope: "col",
                    id: "cartab"
                }
            }, [t._v("Carbos")])])])
        }, function() {
            var t = this,
                e = t.$createElement,
                i = t._self._c || e;
            return i("div", {
                staticClass: "input-group-append"
            }, [i("div", {
                staticClass: "input-group-text input-group-lg"
            }, [t._v("per day")])])
        }, function() {
            var t = this,
                e = t.$createElement,
                i = t._self._c || e;
            return i("div", {
                staticClass: "input-group-append"
            }, [i("div", {
                staticClass: "input-group-text input-group-lg"
            }, [t._v("% proteína")])])
        }, function() {
            var t = this,
                e = t.$createElement,
                i = t._self._c || e;
            return i("div", {
                staticClass: "input-group-append"
            }, [i("div", {
                staticClass: "input-group-text input-group-lg"
            }, [t._v("% Grasas")])])
        }, function() {
            var t = this,
                e = t.$createElement,
                i = t._self._c || e;
            return i("thead", [i("tr", {
                attrs: {
                    id: "tbl-r"
                }
            }, [i("th", {
                staticStyle: {
                    width: "28%"
                },
                attrs: {
                    scope: "col",
                    id: "caltab"
                }
            }, [t._v("Calorías")]), t._v(" "), i("th", {
                staticStyle: {
                    width: "24%"
                },
                attrs: {
                    scope: "col",
                    id: "protab"
                }
            }, [t._v("Proteína")]), t._v(" "), i("th", {
                staticStyle: {
                    width: "24%"
                },
                attrs: {
                    scope: "col",
                    id: "fattab"
                }
            }, [t._v("Grasa")]), t._v(" "), i("th", {
                staticStyle: {
                    width: "24%"
                },
                attrs: {
                    scope: "col",
                    id: "cartab"
                }
            }, [t._v("Carbos")])])])
        }, function() {
            var t = this,
                e = t.$createElement,
                i = t._self._c || e;
            return i("div", {
                staticClass: "input-group-append"
            }, [i("div", {
                staticClass: "input-group-text"
            }, [t._v("%")])])
        }, function() {
            var t = this,
                e = t.$createElement,
                i = t._self._c || e;
            return i("div", {
                staticClass: "input-group-append"
            }, [i("div", {
                staticClass: "input-group-text input-group-keto"
            }, [t._v("g per pound")])])
        }, function() {
            var t = this,
                e = t.$createElement,
                i = t._self._c || e;
            return i("div", {
                staticClass: "input-group-append"
            }, [i("div", {
                staticClass: "input-group-text input-group-keto"
            }, [t._v("g of carbos")])])
        }, function() {
            var t = this,
                e = t.$createElement,
                i = t._self._c || e;
            return i("thead", [i("tr", {
                attrs: {
                    id: "tbl-r"
                }
            }, [i("th", {
                staticStyle: {
                    width: "28%"
                },
                attrs: {
                    scope: "col",
                    id: "caltab"
                }
            }, [t._v("Calorías")]), t._v(" "), i("th", {
                staticStyle: {
                    width: "24%"
                },
                attrs: {
                    scope: "col",
                    id: "protab"
                }
            }, [t._v("Proteína")]), t._v(" "), i("th", {
                staticStyle: {
                    width: "24%"
                },
                attrs: {
                    scope: "col",
                    id: "fattab"
                }
            }, [t._v("Grasa")]), t._v(" "), i("th", {
                staticStyle: {
                    width: "24%"
                },
                attrs: {
                    scope: "col",
                    id: "cartab"
                }
            }, [t._v("Carbos")])])])
        }],
        o = {
            render: r,
            staticRenderFns: s
        };
    e.a = o
}, function(t, e, i) {
    ! function(e, i) {
        t.exports = i()
    }(0, function() {
        return function(t) {
            function e(r) {
                if (i[r]) return i[r].exports;
                var s = i[r] = {
                    i: r,
                    l: !1,
                    exports: {}
                };
                return t[r].call(s.exports, s, s.exports, e), s.l = !0, s.exports
            }
            var i = {};
            return e.m = t, e.c = i, e.i = function(t) {
                return t
            }, e.d = function(t, i, r) {
                e.o(t, i) || Object.defineProperty(t, i, {
                    configurable: !1,
                    enumerable: !0,
                    get: r
                })
            }, e.n = function(t) {
                var i = t && t.__esModule ? function() {
                    return t.default
                } : function() {
                    return t
                };
                return e.d(i, "a", i), i
            }, e.o = function(t, e) {
                return Object.prototype.hasOwnProperty.call(t, e)
            }, e.p = "", e(e.s = 2)
        }([function(t, e, i) {
            i(7);
            var r = i(5)(i(1), i(6), null, null);
            t.exports = r.exports
        }, function(t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var r = function() {
                var t = "undefined" != typeof window ? window.devicePixelRatio || 1 : 1;
                return function(e) {
                    return Math.round(e * t) / t
                }
            }();
            e.default = {
                name: "VueSliderComponent",
                props: {
                    width: {
                        type: [Number, String],
                        default: "auto"
                    },
                    height: {
                        type: [Number, String],
                        default: 6
                    },
                    data: {
                        type: Array,
                        default: null
                    },
                    dotSize: {
                        type: Number,
                        default: 16
                    },
                    dotWidth: {
                        type: Number,
                        required: !1
                    },
                    dotHeight: {
                        type: Number,
                        required: !1
                    },
                    min: {
                        type: Number,
                        default: 0
                    },
                    max: {
                        type: Number,
                        default: 100
                    },
                    interval: {
                        type: Number,
                        default: 1
                    },
                    show: {
                        type: Boolean,
                        default: !0
                    },
                    disabled: {
                        type: Boolean,
                        default: !1
                    },
                    piecewise: {
                        type: Boolean,
                        default: !1
                    },
                    tooltip: {
                        type: [String, Boolean],
                        default: "always"
                    },
                    eventType: {
                        type: String,
                        default: "auto"
                    },
                    direction: {
                        type: String,
                        default: "horizontal"
                    },
                    reverse: {
                        type: Boolean,
                        default: !1
                    },
                    lazy: {
                        type: Boolean,
                        default: !1
                    },
                    clickable: {
                        type: Boolean,
                        default: !0
                    },
                    speed: {
                        type: Number,
                        default: .5
                    },
                    realTime: {
                        type: Boolean,
                        default: !1
                    },
                    stopPropagation: {
                        type: Boolean,
                        default: !1
                    },
                    value: {
                        type: [String, Number, Array, Object],
                        default: 0
                    },
                    piecewiseLabel: {
                        type: Boolean,
                        default: !1
                    },
                    debug: {
                        type: Boolean,
                        default: !0
                    },
                    fixed: {
                        type: Boolean,
                        default: !1
                    },
                    processDragable: {
                        type: Boolean,
                        default: !1
                    },
                    useKeyboard: {
                        type: Boolean,
                        default: !1
                    },
                    actionsKeyboard: {
                        type: Array,
                        default: function() {
                            return [function(t) {
                                return t - 1
                            }, function(t) {
                                return t + 1
                            }]
                        }
                    },
                    sliderStyle: [Array, Object, Function],
                    focusStyle: [Array, Object, Function],
                    tooltipDir: [Array, String],
                    formatter: [String, Function],
                    piecewiseStyle: Object,
                    piecewiseActiveStyle: Object,
                    processStyle: Object,
                    bgStyle: Object,
                    tooltipStyle: [Array, Object, Function],
                    labelStyle: Object,
                    labelActiveStyle: Object
                },
                data: function() {
                    return {
                        flag: !1,
                        keydownFlag: null,
                        focusFlag: !1,
                        processFlag: !1,
                        processSign: null,
                        size: 0,
                        fixedValue: 0,
                        focusSlider: 0,
                        currentValue: 0,
                        currentSlider: 0,
                        isComponentExists: !0
                    }
                },
                computed: {
                    dotWidthVal: function() {
                        return "number" == typeof this.dotWidth ? this.dotWidth : this.dotSize
                    },
                    dotHeightVal: function() {
                        return "number" == typeof this.dotHeight ? this.dotHeight : this.dotSize
                    },
                    flowDirection: function() {
                        return "vue-slider-" + this.direction + (this.reverse ? "-reverse" : "")
                    },
                    tooltipDirection: function() {
                        var t = this.tooltipDir || ("vertical" === this.direction ? "left" : "top");
                        return Array.isArray(t) ? this.isRange ? t : t[1] : this.isRange ? [t, t] : t
                    },
                    tooltipStatus: function() {
                        return "hover" === this.tooltip && this.flag ? "vue-slider-always" : this.tooltip ? "vue-slider-" + this.tooltip : ""
                    },
                    tooltipClass: function() {
                        return ["vue-slider-tooltip-" + this.tooltipDirection, "vue-slider-tooltip"]
                    },
                    isDisabled: function() {
                        return "none" === this.eventType || this.disabled
                    },
                    disabledClass: function() {
                        return this.disabled ? "vue-slider-disabled" : ""
                    },
                    stateClass: function() {
                        return {
                            "vue-slider-state-process-drag": this.processFlag,
                            "vue-slider-state-drag": this.flag && !this.processFlag && !this.keydownFlag,
                            "vue-slider-state-focus": this.focusFlag
                        }
                    },
                    isRange: function() {
                        return Array.isArray(this.value)
                    },
                    slider: function() {
                        return this.isRange ? [this.$refs.dot0, this.$refs.dot1] : this.$refs.dot
                    },
                    minimum: function() {
                        return this.data ? 0 : this.min
                    },
                    val: {
                        get: function() {
                            return this.data ? this.isRange ? [this.data[this.currentValue[0]], this.data[this.currentValue[1]]] : this.data[this.currentValue] : this.currentValue
                        },
                        set: function(t) {
                            if (this.data)
                                if (this.isRange) {
                                    var e = this.data.indexOf(t[0]),
                                        i = this.data.indexOf(t[1]);
                                    e > -1 && i > -1 && (this.currentValue = [e, i])
                                } else {
                                    var r = this.data.indexOf(t);
                                    r > -1 && (this.currentValue = r)
                                }
                            else this.currentValue = t
                        }
                    },
                    currentIndex: function() {
                        return this.isRange ? this.data ? this.currentValue : [this.getIndexByValue(this.currentValue[0]), this.getIndexByValue(this.currentValue[1])] : this.getIndexByValue(this.currentValue)
                    },
                    indexRange: function() {
                        return this.isRange ? this.currentIndex : [0, this.currentIndex]
                    },
                    maximum: function() {
                        return this.data ? this.data.length - 1 : this.max
                    },
                    multiple: function() {
                        var t = ("" + this.interval).split(".")[1];
                        return t ? Math.pow(10, t.length) : 1
                    },
                    spacing: function() {
                        return this.data ? 1 : this.interval
                    },
                    total: function() {
                        return this.data ? this.data.length - 1 : (Math.floor((this.maximum - this.minimum) * this.multiple) % (this.interval * this.multiple) != 0 && this.printError("Prop[interval] is illegal, Please make sure that the interval can be divisible"), (this.maximum - this.minimum) / this.interval)
                    },
                    gap: function() {
                        return this.size / this.total
                    },
                    position: function() {
                        return this.isRange ? [(this.currentValue[0] - this.minimum) / this.spacing * this.gap, (this.currentValue[1] - this.minimum) / this.spacing * this.gap] : (this.currentValue - this.minimum) / this.spacing * this.gap
                    },
                    limit: function() {
                        return this.isRange ? this.fixed ? [
                            [0, (this.maximum - this.fixedValue * this.spacing) / this.spacing * this.gap],
                            [(this.minimum + this.fixedValue * this.spacing) / this.spacing * this.gap, this.size]
                        ] : [
                            [0, this.position[1]],
                            [this.position[0], this.size]
                        ] : [0, this.size]
                    },
                    valueLimit: function() {
                        return this.isRange ? this.fixed ? [
                            [this.minimum, this.maximum - this.fixedValue * this.spacing],
                            [this.minimum + this.fixedValue * this.spacing, this.maximum]
                        ] : [
                            [this.minimum, this.currentValue[1]],
                            [this.currentValue[0], this.maximum]
                        ] : [this.minimum, this.maximum]
                    },
                    idleSlider: function() {
                        return 0 === this.currentSlider ? 1 : 0
                    },
                    wrapStyles: function() {
                        return "vertical" === this.direction ? {
                            height: "number" == typeof this.height ? this.height + "px" : this.height,
                            padding: this.dotHeightVal / 2 + "px " + this.dotWidthVal / 2 + "px"
                        } : {
                            width: "number" == typeof this.width ? this.width + "px" : this.width,
                            padding: this.dotHeightVal / 2 + "px " + this.dotWidthVal / 2 + "px"
                        }
                    },
                    sliderStyles: function() {
                        return Array.isArray(this.sliderStyle) ? this.isRange ? this.sliderStyle : this.sliderStyle[1] : "function" == typeof this.sliderStyle ? this.sliderStyle(this.val, this.currentIndex) : this.isRange ? [this.sliderStyle, this.sliderStyle] : this.sliderStyle
                    },
                    focusStyles: function() {
                        return Array.isArray(this.focusStyle) ? this.isRange ? this.focusStyle : this.focusStyle[1] : "function" == typeof this.focusStyle ? this.focusStyle(this.val, this.currentIndex) : this.isRange ? [this.focusStyle, this.focusStyle] : this.focusStyle
                    },
                    tooltipStyles: function() {
                        return Array.isArray(this.tooltipStyle) ? this.isRange ? this.tooltipStyle : this.tooltipStyle[1] : "function" == typeof this.tooltipStyle ? this.tooltipStyle(this.val, this.currentIndex) : this.isRange ? [this.tooltipStyle, this.tooltipStyle] : this.tooltipStyle
                    },
                    elemStyles: function() {
                        return "vertical" === this.direction ? {
                            width: this.width + "px",
                            height: "100%"
                        } : {
                            height: this.height + "px"
                        }
                    },
                    dotStyles: function() {
                        return "vertical" === this.direction ? {
                            width: this.dotWidthVal + "px",
                            height: this.dotHeightVal + "px",
                            left: -(this.dotWidthVal - this.width) / 2 + "px"
                        } : {
                            width: this.dotWidthVal + "px",
                            height: this.dotHeightVal + "px",
                            top: -(this.dotHeightVal - this.height) / 2 + "px"
                        }
                    },
                    piecewiseDotStyle: function() {
                        return "vertical" === this.direction ? {
                            width: this.width + "px",
                            height: this.width + "px"
                        } : {
                            width: this.height + "px",
                            height: this.height + "px"
                        }
                    },
                    piecewiseDotWrap: function() {
                        if (!this.piecewise && !this.piecewiseLabel) return !1;
                        for (var t = [], e = 0; e <= this.total; e++) {
                            var i = "vertical" === this.direction ? {
                                    bottom: this.gap * e - this.width / 2 + "px",
                                    left: 0
                                } : {
                                    left: this.gap * e - this.height / 2 + "px",
                                    top: 0
                                },
                                r = this.reverse ? this.total - e : e,
                                s = this.data ? this.data[r] : this.spacing * r + this.min;
                            t.push({
                                style: i,
                                label: this.formatter ? this.formatting(s) : s,
                                inRange: r >= this.indexRange[0] && r <= this.indexRange[1]
                            })
                        }
                        return t
                    }
                },
                watch: {
                    value: function(t) {
                        this.flag || this.setValue(t, !0)
                    },
                    max: function(t) {
                        if (t < this.min) return this.printError("The maximum value can not be less than the minimum value.");
                        var e = this.limitValue(this.val);
                        this.setValue(e), this.refresh()
                    },
                    min: function(t) {
                        if (t > this.max) return this.printError("The minimum value can not be greater than the maximum value.");
                        var e = this.limitValue(this.val);
                        this.setValue(e), this.refresh()
                    },
                    show: function(t) {
                        var e = this;
                        t && !this.size && this.$nextTick(function() {
                            e.refresh()
                        })
                    },
                    fixed: function() {
                        this.computedFixedValue()
                    }
                },
                methods: {
                    bindEvents: function() {
                        document.addEventListener("touchmove", this.moving, {
                            passive: !1
                        }), document.addEventListener("touchend", this.moveEnd, {
                            passive: !1
                        }), document.addEventListener("mousedown", this.blurSlider), document.addEventListener("mousemove", this.moving), document.addEventListener("mouseup", this.moveEnd), document.addEventListener("mouseleave", this.moveEnd), document.addEventListener("keydown", this.handleKeydown), document.addEventListener("keyup", this.handleKeyup), window.addEventListener("resize", this.refresh)
                    },
                    unbindEvents: function() {
                        document.removeEventListener("touchmove", this.moving), document.removeEventListener("touchend", this.moveEnd), document.removeEventListener("mousedown", this.blurSlider), document.removeEventListener("mousemove", this.moving), document.removeEventListener("mouseup", this.moveEnd), document.removeEventListener("mouseleave", this.moveEnd), document.removeEventListener("keydown", this.handleKeydown), document.removeEventListener("keyup", this.handleKeyup), window.removeEventListener("resize", this.refresh)
                    },
                    handleKeydown: function(t) {
                        if (!this.useKeyboard || !this.focusFlag) return !1;
                        switch (t.keyCode) {
                            case 37:
                            case 40:
                                t.preventDefault(), this.keydownFlag = !0, this.flag = !0, this.changeFocusSlider(this.actionsKeyboard[0]);
                                break;
                            case 38:
                            case 39:
                                t.preventDefault(), this.keydownFlag = !0, this.flag = !0, this.changeFocusSlider(this.actionsKeyboard[1])
                        }
                    },
                    handleKeyup: function() {
                        this.keydownFlag && (this.keydownFlag = !1, this.flag = !1)
                    },
                    changeFocusSlider: function(t) {
                        var e = this;
                        if (this.isRange) {
                            var i = this.currentIndex.map(function(i, r) {
                                if (r === e.focusSlider || e.fixed) {
                                    var s = t(i),
                                        o = e.fixed ? e.valueLimit[r] : [e.minimum, e.maximum];
                                    if (s <= o[1] && s >= o[0]) return s
                                }
                                return i
                            });
                            i[0] > i[1] && (this.focusSlider = 0 === this.focusSlider ? 1 : 0, i = i.reverse()), this.setIndex(i)
                        } else this.setIndex(t(this.currentIndex))
                    },
                    blurSlider: function(t) {
                        var e = this.isRange ? this.$refs["dot" + this.focusSlider] : this.$refs.dot;
                        if (!e || e === t.target) return !1;
                        this.focusFlag = !1
                    },
                    formatting: function(t) {
                        return "string" == typeof this.formatter ? this.formatter.replace(/\{value\}/, t) : this.formatter(t)
                    },
                    getPos: function(t) {
                        return this.realTime && this.getStaticData(), "vertical" === this.direction ? this.reverse ? t.pageY - this.offset : this.size - (t.pageY - this.offset) : this.reverse ? this.size - (t.clientX - this.offset) : t.clientX - this.offset
                    },
                    processClick: function(t) {
                        this.fixed && t.stopPropagation()
                    },
                    wrapClick: function(t) {
                        if (this.isDisabled || !this.clickable || this.processFlag) return !1;
                        var e = this.getPos(t);
                        this.isRange && (this.currentSlider = e > (this.position[1] - this.position[0]) / 2 + this.position[0] ? 1 : 0), this.setValueOnPos(e)
                    },
                    moveStart: function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                            i = arguments[2];
                        if (this.isDisabled) return !1;
                        if (this.stopPropagation && t.stopPropagation(), this.isRange && (this.currentSlider = e, i)) {
                            if (!this.processDragable) return !1;
                            this.processFlag = !0, this.processSign = {
                                pos: this.position,
                                start: this.getPos(t.targetTouches && t.targetTouches[0] ? t.targetTouches[0] : t)
                            }
                        }!i && this.useKeyboard && (this.focusFlag = !0, this.focusSlider = e), this.flag = !0, this.$emit("drag-start", this)
                    },
                    moving: function(t) {
                        if (this.stopPropagation && t.stopPropagation(), !this.flag) return !1;
                        t.preventDefault(), t.targetTouches && t.targetTouches[0] && (t = t.targetTouches[0]), this.processFlag ? (this.currentSlider = 0, this.setValueOnPos(this.processSign.pos[0] + this.getPos(t) - this.processSign.start, !0), this.currentSlider = 1, this.setValueOnPos(this.processSign.pos[1] + this.getPos(t) - this.processSign.start, !0)) : this.setValueOnPos(this.getPos(t), !0)
                    },
                    moveEnd: function(t) {
                        var e = this;
                        if (this.stopPropagation && t.stopPropagation(), !this.flag) return !1;
                        this.$emit("drag-end", this), this.lazy && this.isDiff(this.val, this.value) && this.syncValue(), this.flag = !1, window.setTimeout(function() {
                            e.processFlag = !1
                        }, 0), this.setPosition()
                    },
                    setValueOnPos: function(t, e) {
                        var i = this.isRange ? this.limit[this.currentSlider] : this.limit,
                            r = this.isRange ? this.valueLimit[this.currentSlider] : this.valueLimit;
                        if (t >= i[0] && t <= i[1]) {
                            this.setTransform(t);
                            var s = this.getValueByIndex(Math.round(t / this.gap));
                            this.setCurrentValue(s, e), this.isRange && this.fixed && (this.setTransform(t + this.fixedValue * this.gap * (0 === this.currentSlider ? 1 : -1), !0), this.setCurrentValue(s + this.fixedValue * this.spacing * (0 === this.currentSlider ? 1 : -1), e, !0))
                        } else t < i[0] ? (this.setTransform(i[0]), this.setCurrentValue(r[0]), this.isRange && this.fixed ? (this.setTransform(this.limit[this.idleSlider][0], !0), this.setCurrentValue(this.valueLimit[this.idleSlider][0], e, !0)) : this.fixed || 1 !== this.currentSlider || (this.focusSlider = 0, this.currentSlider = 0)) : (this.setTransform(i[1]), this.setCurrentValue(r[1]), this.isRange && this.fixed ? (this.setTransform(this.limit[this.idleSlider][1], !0), this.setCurrentValue(this.valueLimit[this.idleSlider][1], e, !0)) : this.fixed || 0 !== this.currentSlider || (this.focusSlider = 1, this.currentSlider = 1))
                    },
                    isDiff: function(t, e) {
                        return Object.prototype.toString.call(t) !== Object.prototype.toString.call(e) || (Array.isArray(t) && t.length === e.length ? t.some(function(t, i) {
                            return t !== e[i]
                        }) : t !== e)
                    },
                    setCurrentValue: function(t, e, i) {
                        var r = i ? this.idleSlider : this.currentSlider;
                        if (t < this.minimum || t > this.maximum) return !1;
                        this.isRange ? this.isDiff(this.currentValue[r], t) && (this.currentValue.splice(r, 1, t), this.lazy && this.flag || this.syncValue()) : this.isDiff(this.currentValue, t) && (this.currentValue = t, this.lazy && this.flag || this.syncValue()), e || this.setPosition()
                    },
                    getValueByIndex: function(t) {
                        return (this.spacing * this.multiple * t + this.minimum * this.multiple) / this.multiple
                    },
                    getIndexByValue: function(t) {
                        return (t - this.minimum) * this.multiple / (this.spacing * this.multiple)
                    },
                    setIndex: function(t) {
                        if (Array.isArray(t) && this.isRange) {
                            var e = void 0;
                            e = this.data ? [this.data[t[0]], this.data[t[1]]] : [this.getValueByIndex(t[0]), this.getValueByIndex(t[1])], this.setValue(e)
                        } else t = this.getValueByIndex(t), this.isRange && (this.currentSlider = t > (this.currentValue[1] - this.currentValue[0]) / 2 + this.currentValue[0] ? 1 : 0), this.setCurrentValue(t)
                    },
                    setValue: function(t, e, i) {
                        var r = this;
                        if (this.isDiff(this.val, t)) {
                            var s = this.limitValue(t);
                            this.val = this.isRange ? s.concat() : s, this.computedFixedValue(), this.syncValue(e)
                        }
                        this.$nextTick(function() {
                            return r.setPosition(i)
                        })
                    },
                    computedFixedValue: function() {
                        if (!this.fixed) return this.fixedValue = 0, !1;
                        this.fixedValue = this.currentIndex[1] - this.currentIndex[0]
                    },
                    setPosition: function(t) {
                        this.flag || this.setTransitionTime(void 0 === t ? this.speed : t), this.isRange ? (this.setTransform(this.position[0], 1 === this.currentSlider), this.setTransform(this.position[1], 0 === this.currentSlider)) : this.setTransform(this.position), this.flag || this.setTransitionTime(0)
                    },
                    setTransform: function(t, e) {
                        var i = e ? this.idleSlider : this.currentSlider,
                            s = r(("vertical" === this.direction ? this.dotHeightVal / 2 - t : t - this.dotWidthVal / 2) * (this.reverse ? -1 : 1)),
                            o = "vertical" === this.direction ? "translateY(" + s + "px)" : "translateX(" + s + "px)",
                            n = this.fixed ? this.fixedValue * this.gap + "px" : (0 === i ? this.position[1] - t : t - this.position[0]) + "px",
                            a = this.fixed ? (0 === i ? t : t - this.fixedValue * this.gap) + "px" : (0 === i ? t : this.position[0]) + "px";
                        this.isRange ? (this.slider[i].style.transform = o, this.slider[i].style.WebkitTransform = o, this.slider[i].style.msTransform = o, "vertical" === this.direction ? (this.$refs.process.style.height = n, this.$refs.process.style[this.reverse ? "top" : "bottom"] = a) : (this.$refs.process.style.width = n, this.$refs.process.style[this.reverse ? "right" : "left"] = a)) : (this.slider.style.transform = o, this.slider.style.WebkitTransform = o, this.slider.style.msTransform = o, "vertical" === this.direction ? (this.$refs.process.style.height = t + "px", this.$refs.process.style[this.reverse ? "top" : "bottom"] = 0) : (this.$refs.process.style.width = t + "px", this.$refs.process.style[this.reverse ? "right" : "left"] = 0))
                    },
                    setTransitionTime: function(t) {
                        if (t || this.$refs.process.offsetWidth, this.isRange) {
                            for (var e = 0; e < this.slider.length; e++) this.slider[e].style.transitionDuration = t + "s", this.slider[e].style.WebkitTransitionDuration = t + "s";
                            this.$refs.process.style.transitionDuration = t + "s", this.$refs.process.style.WebkitTransitionDuration = t + "s"
                        } else this.slider.style.transitionDuration = t + "s", this.slider.style.WebkitTransitionDuration = t + "s", this.$refs.process.style.transitionDuration = t + "s", this.$refs.process.style.WebkitTransitionDuration = t + "s"
                    },
                    limitValue: function(t) {
                        var e = this;
                        if (this.data) return t;
                        var i = function(i) {
                            return i < e.min ? (e.printError("The value of the slider is " + t + ", the minimum value is " + e.min + ", the value of this slider can not be less than the minimum value"), e.min) : i > e.max ? (e.printError("The value of the slider is " + t + ", the maximum value is " + e.max + ", the value of this slider can not be greater than the maximum value"), e.max) : i
                        };
                        return this.isRange ? t.map(function(t) {
                            return i(t)
                        }) : i(t)
                    },
                    syncValue: function(t) {
                        var e = this.isRange ? this.val.concat() : this.val;
                        this.$emit("input", e), t || this.$emit("callback", e)
                    },
                    getValue: function() {
                        return this.val
                    },
                    getIndex: function() {
                        return this.currentIndex
                    },
                    getStaticData: function() {
                        this.$refs.elem && (this.size = "vertical" === this.direction ? this.$refs.elem.offsetHeight : this.$refs.elem.offsetWidth, this.offset = "vertical" === this.direction ? this.$refs.elem.getBoundingClientRect().top + window.pageYOffset || document.documentElement.scrollTop : this.$refs.elem.getBoundingClientRect().left)
                    },
                    refresh: function() {
                        this.$refs.elem && (this.getStaticData(), this.computedFixedValue(), this.setPosition())
                    },
                    printError: function(t) {
                        this.debug && console.error("[VueSlider error]: " + t)
                    }
                },
                mounted: function() {
                    var t = this;
                    if (this.isComponentExists = !0, "undefined" == typeof window || "undefined" == typeof document) return this.printError("window or document is undefined, can not be initialization.");
                    this.$nextTick(function() {
                        t.isComponentExists && (t.getStaticData(), t.setValue(t.limitValue(t.value), !0, 0), t.bindEvents())
                    })
                },
                beforeDestroy: function() {
                    this.isComponentExists = !1, this.unbindEvents()
                }
            }
        }, function(t, e, i) {
            "use strict";
            var r = i(0);
            t.exports = r
        }, function(t, e, i) {
            e = t.exports = i(4)(), e.push([t.i, '.vue-slider-component{position:relative;box-sizing:border-box;-ms-user-select:none;user-select:none;-webkit-user-select:none;-moz-user-select:none;-o-user-select:none}.vue-slider-component.vue-slider-disabled{opacity:.5;cursor:not-allowed}.vue-slider-component.vue-slider-has-label{margin-bottom:15px}.vue-slider-component.vue-slider-disabled .vue-slider-dot{cursor:not-allowed}.vue-slider-component .vue-slider{position:relative;display:block;border-radius:15px;background-color:#ccc}.vue-slider-component .vue-slider:after{content:"";position:absolute;left:0;top:0;width:100%;height:100%;z-index:2}.vue-slider-component .vue-slider-process{position:absolute;border-radius:15px;background-color:#3498db;transition:all 0s;z-index:1}.vue-slider-component .vue-slider-process.vue-slider-process-dragable{cursor:pointer;z-index:3}.vue-slider-component.vue-slider-horizontal .vue-slider-process{width:0;height:100%;top:0;left:0;will-change:width}.vue-slider-component.vue-slider-vertical .vue-slider-process{width:100%;height:0;bottom:0;left:0;will-change:height}.vue-slider-component.vue-slider-horizontal-reverse .vue-slider-process{width:0;height:100%;top:0;right:0}.vue-slider-component.vue-slider-vertical-reverse .vue-slider-process{width:100%;height:0;top:0;left:0}.vue-slider-component .vue-slider-dot{position:absolute;border-radius:50%;background-color:#fff;box-shadow:.5px .5px 2px 1px rgba(0,0,0,.32);transition:all 0s;will-change:transform;cursor:pointer;z-index:4}.vue-slider-component .vue-slider-dot.vue-slider-dot-focus{box-shadow:0 0 2px 1px #3498db}.vue-slider-component.vue-slider-horizontal .vue-slider-dot{left:0}.vue-slider-component.vue-slider-vertical .vue-slider-dot{bottom:0}.vue-slider-component.vue-slider-horizontal-reverse .vue-slider-dot{right:0}.vue-slider-component.vue-slider-vertical-reverse .vue-slider-dot{top:0}.vue-slider-component .vue-slider-tooltip-wrap{display:none;position:absolute;z-index:9}.vue-slider-component .vue-slider-tooltip{display:block;font-size:14px;white-space:nowrap;padding:2px 5px;min-width:20px;text-align:center;color:#fff;border-radius:5px;border:1px solid #3498db;background-color:#3498db}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-top{top:-9px;left:50%;-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-bottom{bottom:-9px;left:50%;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-left{top:50%;left:-9px;-webkit-transform:translate(-100%,-50%);transform:translate(-100%,-50%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-right{top:50%;right:-9px;-webkit-transform:translate(100%,-50%);transform:translate(100%,-50%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-top .vue-slider-tooltip:before{content:"";position:absolute;bottom:-10px;left:50%;width:0;height:0;border:5px solid transparent;border:6px solid transparent\\0;border-top-color:inherit;-webkit-transform:translate(-50%);transform:translate(-50%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-bottom .vue-slider-tooltip:before{content:"";position:absolute;top:-10px;left:50%;width:0;height:0;border:5px solid transparent;border:6px solid transparent\\0;border-bottom-color:inherit;-webkit-transform:translate(-50%);transform:translate(-50%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-left .vue-slider-tooltip:before{content:"";position:absolute;top:50%;right:-10px;width:0;height:0;border:5px solid transparent;border:6px solid transparent\\0;border-left-color:inherit;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-right .vue-slider-tooltip:before{content:"";position:absolute;top:50%;left:-10px;width:0;height:0;border:5px solid transparent;border:6px solid transparent\\0;border-right-color:inherit;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.vue-slider-component .vue-slider-dot.vue-slider-hover:hover .vue-slider-tooltip-wrap{display:block}.vue-slider-component .vue-slider-dot.vue-slider-always .vue-slider-tooltip-wrap{display:block!important}.vue-slider-component .vue-slider-piecewise{position:absolute;width:100%;padding:0;margin:0;left:0;top:0;height:100%;list-style:none}.vue-slider-component .vue-slider-piecewise-item{position:absolute;width:8px;height:8px}.vue-slider-component .vue-slider-piecewise-dot{position:absolute;left:50%;top:50%;width:100%;height:100%;display:inline-block;background-color:rgba(0,0,0,.16);border-radius:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:2;transition:all .3s}.vue-slider-component .vue-slider-piecewise-item:first-child .vue-slider-piecewise-dot,.vue-slider-component .vue-slider-piecewise-item:last-child .vue-slider-piecewise-dot{visibility:hidden}.vue-slider-component.vue-slider-horizontal-reverse .vue-slider-piecewise-label,.vue-slider-component.vue-slider-horizontal .vue-slider-piecewise-label{position:absolute;display:inline-block;top:100%;left:50%;white-space:nowrap;font-size:12px;color:#333;-webkit-transform:translate(-50%,8px);transform:translate(-50%,8px);visibility:visible}.vue-slider-component.vue-slider-vertical-reverse .vue-slider-piecewise-label,.vue-slider-component.vue-slider-vertical .vue-slider-piecewise-label{position:absolute;display:inline-block;top:50%;left:100%;white-space:nowrap;font-size:12px;color:#333;-webkit-transform:translate(8px,-50%);transform:translate(8px,-50%);visibility:visible}.vue-slider-component .vue-slider-sr-only{clip:rect(1px,1px,1px,1px);height:1px;width:1px;overflow:hidden;position:absolute!important}', ""])
        }, function(t, e) {
            t.exports = function() {
                var t = [];
                return t.toString = function() {
                    for (var t = [], e = 0; e < this.length; e++) {
                        var i = this[e];
                        i[2] ? t.push("@media " + i[2] + "{" + i[1] + "}") : t.push(i[1])
                    }
                    return t.join("")
                }, t.i = function(e, i) {
                    "string" == typeof e && (e = [
                        [null, e, ""]
                    ]);
                    for (var r = {}, s = 0; s < this.length; s++) {
                        var o = this[s][0];
                        "number" == typeof o && (r[o] = !0)
                    }
                    for (s = 0; s < e.length; s++) {
                        var n = e[s];
                        "number" == typeof n[0] && r[n[0]] || (i && !n[2] ? n[2] = i : i && (n[2] = "(" + n[2] + ") and (" + i + ")"), t.push(n))
                    }
                }, t
            }
        }, function(t, e) {
            t.exports = function(t, e, i, r) {
                var s, o = t = t || {},
                    n = typeof t.default;
                "object" !== n && "function" !== n || (s = t, o = t.default);
                var a = "function" == typeof o ? o.options : o;
                if (e && (a.render = e.render, a.staticRenderFns = e.staticRenderFns), i && (a._scopeId = i), r) {
                    var l = Object.create(a.computed || null);
                    Object.keys(r).forEach(function(t) {
                        var e = r[t];
                        l[t] = function() {
                            return e
                        }
                    }), a.computed = l
                }
                return {
                    esModule: s,
                    exports: o,
                    options: a
                }
            }
        }, function(t, e) {
            t.exports = {
                render: function() {
                    var t = this,
                        e = t.$createElement,
                        i = t._self._c || e;
                    return i("div", {
                        directives: [{
                            name: "show",
                            rawName: "v-show",
                            value: t.show,
                            expression: "show"
                        }],
                        ref: "wrap",
                        class: ["vue-slider-component", t.flowDirection, t.disabledClass, t.stateClass, {
                            "vue-slider-has-label": t.piecewiseLabel
                        }],
                        style: t.wrapStyles,
                        on: {
                            click: t.wrapClick
                        }
                    }, [i("div", {
                        ref: "elem",
                        staticClass: "vue-slider",
                        style: [t.elemStyles, t.bgStyle],
                        attrs: {
                            "aria-hidden": "true"
                        }
                    }, [t.isRange ? [i("div", {
                        ref: "dot0",
                        class: [t.tooltipStatus, "vue-slider-dot", {
                            "vue-slider-dot-focus": t.focusFlag && 0 === t.focusSlider
                        }],
                        style: [t.dotStyles, t.sliderStyles[0], t.focusFlag && 0 === t.focusSlider ? t.focusStyles[0] : null],
                        on: {
                            mousedown: function(e) {
                                t.moveStart(e, 0)
                            },
                            touchstart: function(e) {
                                t.moveStart(e, 0)
                            }
                        }
                    }, [i("span", {
                        class: ["vue-slider-tooltip-" + t.tooltipDirection[0], "vue-slider-tooltip-wrap"]
                    }, [t._t("tooltip", [i("span", {
                        staticClass: "vue-slider-tooltip",
                        style: t.tooltipStyles[0]
                    }, [t._v(t._s(t.formatter ? t.formatting(t.val[0]) : t.val[0]))])], {
                        value: t.val[0],
                        index: 0
                    })], 2)]), t._v(" "), i("div", {
                        ref: "dot1",
                        class: [t.tooltipStatus, "vue-slider-dot", {
                            "vue-slider-dot-focus": t.focusFlag && 1 === t.focusSlider
                        }],
                        style: [t.dotStyles, t.sliderStyles[1], t.focusFlag && 1 === t.focusSlider ? t.focusStyles[1] : null],
                        on: {
                            mousedown: function(e) {
                                t.moveStart(e, 1)
                            },
                            touchstart: function(e) {
                                t.moveStart(e, 1)
                            }
                        }
                    }, [i("span", {
                        class: ["vue-slider-tooltip-" + t.tooltipDirection[1], "vue-slider-tooltip-wrap"]
                    }, [t._t("tooltip", [i("span", {
                        staticClass: "vue-slider-tooltip",
                        style: t.tooltipStyles[1]
                    }, [t._v(t._s(t.formatter ? t.formatting(t.val[1]) : t.val[1]))])], {
                        value: t.val[1],
                        index: 1
                    })], 2)])] : [i("div", {
                        ref: "dot",
                        class: [t.tooltipStatus, "vue-slider-dot", {
                            "vue-slider-dot-focus": t.focusFlag && 0 === t.focusSlider
                        }],
                        style: [t.dotStyles, t.sliderStyles, t.focusFlag && 0 === t.focusSlider ? t.focusStyles : null],
                        on: {
                            mousedown: t.moveStart,
                            touchstart: t.moveStart
                        }
                    }, [i("span", {
                        class: ["vue-slider-tooltip-" + t.tooltipDirection, "vue-slider-tooltip-wrap"]
                    }, [t._t("tooltip", [i("span", {
                        staticClass: "vue-slider-tooltip",
                        style: t.tooltipStyles
                    }, [t._v(t._s(t.formatter ? t.formatting(t.val) : t.val))])], {
                        value: t.val
                    })], 2)])], t._v(" "), i("ul", {
                        staticClass: "vue-slider-piecewise"
                    }, t._l(t.piecewiseDotWrap, function(e, r) {
                        return i("li", {
                            key: r,
                            staticClass: "vue-slider-piecewise-item",
                            style: [t.piecewiseDotStyle, e.style]
                        }, [t._t("piecewise", [t.piecewise ? i("span", {
                            staticClass: "vue-slider-piecewise-dot",
                            style: [t.piecewiseStyle, e.inRange ? t.piecewiseActiveStyle : null]
                        }) : t._e()], {
                            label: e.label,
                            index: r,
                            first: 0 === r,
                            last: r === t.piecewiseDotWrap.length - 1,
                            active: e.inRange
                        }), t._v(" "), t._t("label", [t.piecewiseLabel ? i("span", {
                            staticClass: "vue-slider-piecewise-label",
                            style: [t.labelStyle, e.inRange ? t.labelActiveStyle : null]
                        }, [t._v("\n            " + t._s(e.label) + "\n          ")]) : t._e()], {
                            label: e.label,
                            index: r,
                            first: 0 === r,
                            last: r === t.piecewiseDotWrap.length - 1,
                            active: e.inRange
                        })], 2)
                    })), t._v(" "), i("div", {
                        ref: "process",
                        class: ["vue-slider-process", {
                            "vue-slider-process-dragable": t.isRange && t.processDragable
                        }],
                        style: t.processStyle,
                        on: {
                            click: t.processClick,
                            mousedown: function(e) {
                                t.moveStart(e, 0, !0)
                            },
                            touchstart: function(e) {
                                t.moveStart(e, 0, !0)
                            }
                        }
                    })], 2), t._v(" "), t.isRange || t.data ? t._e() : i("input", {
                        directives: [{
                            name: "model",
                            rawName: "v-model",
                            value: t.val,
                            expression: "val"
                        }],
                        staticClass: "vue-slider-sr-only",
                        attrs: {
                            type: "range",
                            min: t.min,
                            max: t.max
                        },
                        domProps: {
                            value: t.val
                        },
                        on: {
                            __r: function(e) {
                                t.val = e.target.value
                            }
                        }
                    })])
                },
                staticRenderFns: []
            }
        }, function(t, e, i) {
            var r = i(3);
            "string" == typeof r && (r = [
                [t.i, r, ""]
            ]), r.locals && (t.exports = r.locals), i(8)("743d98f5", r, !0)
        }, function(t, e, i) {
            function r(t) {
                for (var e = 0; e < t.length; e++) {
                    var i = t[e],
                        r = p[i.id];
                    if (r) {
                        r.refs++;
                        for (var s = 0; s < r.parts.length; s++) r.parts[s](i.parts[s]);
                        for (; s < i.parts.length; s++) r.parts.push(o(i.parts[s]));
                        r.parts.length > i.parts.length && (r.parts.length = i.parts.length)
                    } else {
                        for (var n = [], s = 0; s < i.parts.length; s++) n.push(o(i.parts[s]));
                        p[i.id] = {
                            id: i.id,
                            refs: 1,
                            parts: n
                        }
                    }
                }
            }

            function s() {
                var t = document.createElement("style");
                return t.type = "text/css", u.appendChild(t), t
            }

            function o(t) {
                var e, i, r = document.querySelector('style[data-vue-ssr-id~="' + t.id + '"]');
                if (r) {
                    if (f) return v;
                    r.parentNode.removeChild(r)
                }
                if (m) {
                    var o = d++;
                    r = h || (h = s()), e = n.bind(null, r, o, !1), i = n.bind(null, r, o, !0)
                } else r = s(), e = a.bind(null, r), i = function() {
                    r.parentNode.removeChild(r)
                };
                return e(t),
                    function(r) {
                        if (r) {
                            if (r.css === t.css && r.media === t.media && r.sourceMap === t.sourceMap) return;
                            e(t = r)
                        } else i()
                    }
            }

            function n(t, e, i, r) {
                var s = i ? "" : r.css;
                if (t.styleSheet) t.styleSheet.cssText = g(e, s);
                else {
                    var o = document.createTextNode(s),
                        n = t.childNodes;
                    n[e] && t.removeChild(n[e]), n.length ? t.insertBefore(o, n[e]) : t.appendChild(o)
                }
            }

            function a(t, e) {
                var i = e.css,
                    r = e.media,
                    s = e.sourceMap;
                if (r && t.setAttribute("media", r), s && (i += "\n/*# sourceURL=" + s.sources[0] + " */", i += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(s)))) + " */"), t.styleSheet) t.styleSheet.cssText = i;
                else {
                    for (; t.firstChild;) t.removeChild(t.firstChild);
                    t.appendChild(document.createTextNode(i))
                }
            }
            var l = "undefined" != typeof document;
            if ("undefined" != typeof DEBUG && DEBUG && !l) throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");
            var c = i(9),
                p = {},
                u = l && (document.head || document.getElementsByTagName("head")[0]),
                h = null,
                d = 0,
                f = !1,
                v = function() {},
                m = "undefined" != typeof navigator && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());
            t.exports = function(t, e, i) {
                f = i;
                var s = c(t, e);
                return r(s),
                    function(e) {
                        for (var i = [], o = 0; o < s.length; o++) {
                            var n = s[o],
                                a = p[n.id];
                            a.refs--, i.push(a)
                        }
                        e ? (s = c(t, e), r(s)) : s = [];
                        for (var o = 0; o < i.length; o++) {
                            var a = i[o];
                            if (0 === a.refs) {
                                for (var l = 0; l < a.parts.length; l++) a.parts[l]();
                                delete p[a.id]
                            }
                        }
                    }
            };
            var g = function() {
                var t = [];
                return function(e, i) {
                    return t[e] = i, t.filter(Boolean).join("\n")
                }
            }()
        }, function(t, e) {
            t.exports = function(t, e) {
                for (var i = [], r = {}, s = 0; s < e.length; s++) {
                    var o = e[s],
                        n = o[0],
                        a = o[1],
                        l = o[2],
                        c = o[3],
                        p = {
                            id: t + ":" + s,
                            css: a,
                            media: l,
                            sourceMap: c
                        };
                    r[n] ? r[n].parts.push(p) : i.push(r[n] = {
                        id: n,
                        parts: [p]
                    })
                }
                return i
            }
        }])
    })
}, function(t, e, i) {
    var r = i(10),
        s = {
            autoSetContainer: !1
        },
        o = {
            install: function(t) {
                t.prototype.$clipboardConfig = s, t.prototype.$copyText = function(t, e) {
                    return new Promise(function(i, s) {
                        var o = document.createElement("button"),
                            n = new r(o, {
                                text: function() {
                                    return t
                                },
                                action: function() {
                                    return "copy"
                                },
                                container: "object" == typeof e ? e : document.body
                            });
                        n.on("success", function(t) {
                            n.destroy(), i(t)
                        }), n.on("error", function(t) {
                            n.destroy(), s(t)
                        }), o.click()
                    })
                }, t.directive("clipboard", {
                    bind: function(t, e, i) {
                        if ("success" === e.arg) t._v_clipboard_success = e.value;
                        else if ("error" === e.arg) t._v_clipboard_error = e.value;
                        else {
                            var o = new r(t, {
                                text: function() {
                                    return e.value
                                },
                                action: function() {
                                    return "cut" === e.arg ? "cut" : "copy"
                                },
                                container: s.autoSetContainer ? t : void 0
                            });
                            o.on("success", function(e) {
                                var i = t._v_clipboard_success;
                                i && i(e)
                            }), o.on("error", function(e) {
                                var i = t._v_clipboard_error;
                                i && i(e)
                            }), t._v_clipboard = o
                        }
                    },
                    update: function(t, e) {
                        "success" === e.arg ? t._v_clipboard_success = e.value : "error" === e.arg ? t._v_clipboard_error = e.value : (t._v_clipboard.text = function() {
                            return e.value
                        }, t._v_clipboard.action = function() {
                            return "cut" === e.arg ? "cut" : "copy"
                        })
                    },
                    unbind: function(t, e) {
                        "success" === e.arg ? delete t._v_clipboard_success : "error" === e.arg ? delete t._v_clipboard_error : (t._v_clipboard.destroy(), delete t._v_clipboard)
                    }
                })
            },
            config: o
        };
    t.exports = o
}, function(t, e, i) {
    /*!
     * clipboard.js v2.0.1
     * https://zenorocha.github.io/clipboard.js
     * 
     * Licensed MIT © Zeno Rocha
     */
    ! function(e, i) {
        t.exports = i()
    }(0, function() {
        return function(t) {
            function e(r) {
                if (i[r]) return i[r].exports;
                var s = i[r] = {
                    i: r,
                    l: !1,
                    exports: {}
                };
                return t[r].call(s.exports, s, s.exports, e), s.l = !0, s.exports
            }
            var i = {};
            return e.m = t, e.c = i, e.i = function(t) {
                return t
            }, e.d = function(t, i, r) {
                e.o(t, i) || Object.defineProperty(t, i, {
                    configurable: !1,
                    enumerable: !0,
                    get: r
                })
            }, e.n = function(t) {
                var i = t && t.__esModule ? function() {
                    return t.default
                } : function() {
                    return t
                };
                return e.d(i, "a", i), i
            }, e.o = function(t, e) {
                return Object.prototype.hasOwnProperty.call(t, e)
            }, e.p = "", e(e.s = 3)
        }([function(t, e, i) {
            var r, s, o;
            ! function(n, a) {
                s = [t, i(7)], r = a, void 0 !== (o = "function" == typeof r ? r.apply(e, s) : r) && (t.exports = o)
            }(0, function(t, e) {
                "use strict";

                function i(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
                }
                var r = function(t) {
                        return t && t.__esModule ? t : {
                            default: t
                        }
                    }(e),
                    s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                        return typeof t
                    } : function(t) {
                        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                    },
                    o = function() {
                        function t(t, e) {
                            for (var i = 0; i < e.length; i++) {
                                var r = e[i];
                                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r)
                            }
                        }
                        return function(e, i, r) {
                            return i && t(e.prototype, i), r && t(e, r), e
                        }
                    }(),
                    n = function() {
                        function t(e) {
                            i(this, t), this.resolveOptions(e), this.initSelection()
                        }
                        return o(t, [{
                            key: "resolveOptions",
                            value: function() {
                                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                this.action = t.action, this.container = t.container, this.emitter = t.emitter, this.target = t.target, this.text = t.text, this.trigger = t.trigger, this.selectedText = ""
                            }
                        }, {
                            key: "initSelection",
                            value: function() {
                                this.text ? this.selectFake() : this.target && this.selectTarget()
                            }
                        }, {
                            key: "selectFake",
                            value: function() {
                                var t = this,
                                    e = "rtl" == document.documentElement.getAttribute("dir");
                                this.removeFake(), this.fakeHandlerCallback = function() {
                                    return t.removeFake()
                                }, this.fakeHandler = this.container.addEventListener("click", this.fakeHandlerCallback) || !0, this.fakeElem = document.createElement("textarea"), this.fakeElem.style.fontSize = "12pt", this.fakeElem.style.border = "0", this.fakeElem.style.padding = "0", this.fakeElem.style.margin = "0", this.fakeElem.style.position = "absolute", this.fakeElem.style[e ? "right" : "left"] = "-9999px";
                                var i = window.pageYOffset || document.documentElement.scrollTop;
                                this.fakeElem.style.top = i + "px", this.fakeElem.setAttribute("readonly", ""), this.fakeElem.value = this.text, this.container.appendChild(this.fakeElem), this.selectedText = (0, r.default)(this.fakeElem), this.copyText()
                            }
                        }, {
                            key: "removeFake",
                            value: function() {
                                this.fakeHandler && (this.container.removeEventListener("click", this.fakeHandlerCallback), this.fakeHandler = null, this.fakeHandlerCallback = null), this.fakeElem && (this.container.removeChild(this.fakeElem), this.fakeElem = null)
                            }
                        }, {
                            key: "selectTarget",
                            value: function() {
                                this.selectedText = (0, r.default)(this.target), this.copyText()
                            }
                        }, {
                            key: "copyText",
                            value: function() {
                                var t = void 0;
                                try {
                                    t = document.execCommand(this.action)
                                } catch (e) {
                                    t = !1
                                }
                                this.handleResult(t)
                            }
                        }, {
                            key: "handleResult",
                            value: function(t) {
                                this.emitter.emit(t ? "success" : "error", {
                                    action: this.action,
                                    text: this.selectedText,
                                    trigger: this.trigger,
                                    clearSelection: this.clearSelection.bind(this)
                                })
                            }
                        }, {
                            key: "clearSelection",
                            value: function() {
                                this.trigger && this.trigger.focus(), window.getSelection().removeAllRanges()
                            }
                        }, {
                            key: "destroy",
                            value: function() {
                                this.removeFake()
                            }
                        }, {
                            key: "action",
                            set: function() {
                                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "copy";
                                if (this._action = t, "copy" !== this._action && "cut" !== this._action) throw new Error('Invalid "action" value, use either "copy" or "cut"')
                            },
                            get: function() {
                                return this._action
                            }
                        }, {
                            key: "target",
                            set: function(t) {
                                if (void 0 !== t) {
                                    if (!t || "object" !== (void 0 === t ? "undefined" : s(t)) || 1 !== t.nodeType) throw new Error('Invalid "target" value, use a valid Element');
                                    if ("copy" === this.action && t.hasAttribute("disabled")) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                                    if ("cut" === this.action && (t.hasAttribute("readonly") || t.hasAttribute("disabled"))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                                    this._target = t
                                }
                            },
                            get: function() {
                                return this._target
                            }
                        }]), t
                    }();
                t.exports = n
            })
        }, function(t, e, i) {
            function r(t, e, i) {
                if (!t && !e && !i) throw new Error("Missing required arguments");
                if (!a.string(e)) throw new TypeError("Second argument must be a String");
                if (!a.fn(i)) throw new TypeError("Third argument must be a Function");
                if (a.node(t)) return s(t, e, i);
                if (a.nodeList(t)) return o(t, e, i);
                if (a.string(t)) return n(t, e, i);
                throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList")
            }

            function s(t, e, i) {
                return t.addEventListener(e, i), {
                    destroy: function() {
                        t.removeEventListener(e, i)
                    }
                }
            }

            function o(t, e, i) {
                return Array.prototype.forEach.call(t, function(t) {
                    t.addEventListener(e, i)
                }), {
                    destroy: function() {
                        Array.prototype.forEach.call(t, function(t) {
                            t.removeEventListener(e, i)
                        })
                    }
                }
            }

            function n(t, e, i) {
                return l(document.body, t, e, i)
            }
            var a = i(6),
                l = i(5);
            t.exports = r
        }, function(t, e) {
            function i() {}
            i.prototype = {
                on: function(t, e, i) {
                    var r = this.e || (this.e = {});
                    return (r[t] || (r[t] = [])).push({
                        fn: e,
                        ctx: i
                    }), this
                },
                once: function(t, e, i) {
                    function r() {
                        s.off(t, r), e.apply(i, arguments)
                    }
                    var s = this;
                    return r._ = e, this.on(t, r, i)
                },
                emit: function(t) {
                    var e = [].slice.call(arguments, 1),
                        i = ((this.e || (this.e = {}))[t] || []).slice(),
                        r = 0,
                        s = i.length;
                    for (r; r < s; r++) i[r].fn.apply(i[r].ctx, e);
                    return this
                },
                off: function(t, e) {
                    var i = this.e || (this.e = {}),
                        r = i[t],
                        s = [];
                    if (r && e)
                        for (var o = 0, n = r.length; o < n; o++) r[o].fn !== e && r[o].fn._ !== e && s.push(r[o]);
                    return s.length ? i[t] = s : delete i[t], this
                }
            }, t.exports = i
        }, function(t, e, i) {
            var r, s, o;
            ! function(n, a) {
                s = [t, i(0), i(2), i(1)], r = a, void 0 !== (o = "function" == typeof r ? r.apply(e, s) : r) && (t.exports = o)
            }(0, function(t, e, i, r) {
                "use strict";

                function s(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    }
                }

                function o(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
                }

                function n(t, e) {
                    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return !e || "object" != typeof e && "function" != typeof e ? t : e
                }

                function a(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e)
                }

                function l(t, e) {
                    var i = "data-clipboard-" + t;
                    if (e.hasAttribute(i)) return e.getAttribute(i)
                }
                var c = s(e),
                    p = s(i),
                    u = s(r),
                    h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                        return typeof t
                    } : function(t) {
                        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                    },
                    d = function() {
                        function t(t, e) {
                            for (var i = 0; i < e.length; i++) {
                                var r = e[i];
                                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r)
                            }
                        }
                        return function(e, i, r) {
                            return i && t(e.prototype, i), r && t(e, r), e
                        }
                    }(),
                    f = function(t) {
                        function e(t, i) {
                            o(this, e);
                            var r = n(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
                            return r.resolveOptions(i), r.listenClick(t), r
                        }
                        return a(e, t), d(e, [{
                            key: "resolveOptions",
                            value: function() {
                                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                this.action = "function" == typeof t.action ? t.action : this.defaultAction, this.target = "function" == typeof t.target ? t.target : this.defaultTarget, this.text = "function" == typeof t.text ? t.text : this.defaultText, this.container = "object" === h(t.container) ? t.container : document.body
                            }
                        }, {
                            key: "listenClick",
                            value: function(t) {
                                var e = this;
                                this.listener = (0, u.default)(t, "click", function(t) {
                                    return e.onClick(t)
                                })
                            }
                        }, {
                            key: "onClick",
                            value: function(t) {
                                var e = t.delegateTarget || t.currentTarget;
                                this.clipboardAction && (this.clipboardAction = null), this.clipboardAction = new c.default({
                                    action: this.action(e),
                                    target: this.target(e),
                                    text: this.text(e),
                                    container: this.container,
                                    trigger: e,
                                    emitter: this
                                })
                            }
                        }, {
                            key: "defaultAction",
                            value: function(t) {
                                return l("action", t)
                            }
                        }, {
                            key: "defaultTarget",
                            value: function(t) {
                                var e = l("target", t);
                                if (e) return document.querySelector(e)
                            }
                        }, {
                            key: "defaultText",
                            value: function(t) {
                                return l("text", t)
                            }
                        }, {
                            key: "destroy",
                            value: function() {
                                this.listener.destroy(), this.clipboardAction && (this.clipboardAction.destroy(), this.clipboardAction = null)
                            }
                        }], [{
                            key: "isSupported",
                            value: function() {
                                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ["copy", "cut"],
                                    e = "string" == typeof t ? [t] : t,
                                    i = !!document.queryCommandSupported;
                                return e.forEach(function(t) {
                                    i = i && !!document.queryCommandSupported(t)
                                }), i
                            }
                        }]), e
                    }(p.default);
                t.exports = f
            })
        }, function(t, e) {
            function i(t, e) {
                for (; t && t.nodeType !== r;) {
                    if ("function" == typeof t.matches && t.matches(e)) return t;
                    t = t.parentNode
                }
            }
            var r = 9;
            if ("undefined" != typeof Element && !Element.prototype.matches) {
                var s = Element.prototype;
                s.matches = s.matchesSelector || s.mozMatchesSelector || s.msMatchesSelector || s.oMatchesSelector || s.webkitMatchesSelector
            }
            t.exports = i
        }, function(t, e, i) {
            function r(t, e, i, r, s) {
                var n = o.apply(this, arguments);
                return t.addEventListener(i, n, s), {
                    destroy: function() {
                        t.removeEventListener(i, n, s)
                    }
                }
            }

            function s(t, e, i, s, o) {
                return "function" == typeof t.addEventListener ? r.apply(null, arguments) : "function" == typeof i ? r.bind(null, document).apply(null, arguments) : ("string" == typeof t && (t = document.querySelectorAll(t)), Array.prototype.map.call(t, function(t) {
                    return r(t, e, i, s, o)
                }))
            }

            function o(t, e, i, r) {
                return function(i) {
                    i.delegateTarget = n(i.target, e), i.delegateTarget && r.call(t, i)
                }
            }
            var n = i(4);
            t.exports = s
        }, function(t, e) {
            e.node = function(t) {
                return void 0 !== t && t instanceof HTMLElement && 1 === t.nodeType
            }, e.nodeList = function(t) {
                var i = Object.prototype.toString.call(t);
                return void 0 !== t && ("[object NodeList]" === i || "[object HTMLCollection]" === i) && "length" in t && (0 === t.length || e.node(t[0]))
            }, e.string = function(t) {
                return "string" == typeof t || t instanceof String
            }, e.fn = function(t) {
                return "[object Function]" === Object.prototype.toString.call(t)
            }
        }, function(t, e) {
            function i(t) {
                var e;
                if ("SELECT" === t.nodeName) t.focus(), e = t.value;
                else if ("INPUT" === t.nodeName || "TEXTAREA" === t.nodeName) {
                    var i = t.hasAttribute("readonly");
                    i || t.setAttribute("readonly", ""), t.select(), t.setSelectionRange(0, t.value.length), i || t.removeAttribute("readonly"), e = t.value
                } else {
                    t.hasAttribute("contenteditable") && t.focus();
                    var r = window.getSelection(),
                        s = document.createRange();
                    s.selectNodeContents(t), r.removeAllRanges(), r.addRange(s), e = r.toString()
                }
                return e
            }
            t.exports = i
        }])
    })
}, function(t, e, i) {
    ! function(e, r) {
        t.exports = r(i(12))
    }(0, function(t) {
        "use strict";

        function e(t, e, i) {
            t && e && i && (document.addEventListener ? t.addEventListener(e, i, !1) : t.attachEvent("on" + e, i))
        }

        function i(t, e, i) {
            t && e && (document.removeEventListener ? t.removeEventListener(e, i, !1) : t.detachEvent("on" + e, i))
        }
        t = t && t.hasOwnProperty("default") ? t.default : t;
        var r = Object.assign || function(t) {
            for (var e = 1; e < arguments.length; e++) {
                var i = arguments[e];
                for (var r in i) Object.prototype.hasOwnProperty.call(i, r) && (t[r] = i[r])
            }
            return t
        };
        return {
            render: function() {
                var t = this,
                    e = t.$createElement,
                    i = t._self._c || e;
                return i("span", [i("transition", {
                    attrs: {
                        name: t.transition,
                        "enter-active-class": t.enterActiveClass,
                        "leave-active-class": t.leaveActiveClass
                    },
                    on: {
                        "after-leave": t.doDestroy
                    }
                }, [i("span", {
                    directives: [{
                        name: "show",
                        rawName: "v-show",
                        value: !t.disabled && t.showPopper,
                        expression: "!disabled && showPopper"
                    }],
                    ref: "popper"
                }, [t._t("default", [t._v(t._s(t.content))])], 2)]), t._v(" "), t._t("reference")], 2)
            },
            staticRenderFns: [],
            props: {
                trigger: {
                    type: String,
                    default: "hover",
                    validator: function(t) {
                        return ["click", "hover"].indexOf(t) > -1
                    }
                },
                delayOnMouseOut: {
                    type: Number,
                    default: 10
                },
                disabled: {
                    type: Boolean,
                    default: !1
                },
                content: String,
                enterActiveClass: String,
                leaveActiveClass: String,
                boundariesSelector: String,
                reference: {},
                forceShow: {
                    type: Boolean,
                    default: !1
                },
                appendToBody: {
                    type: Boolean,
                    default: !1
                },
                visibleArrow: {
                    type: Boolean,
                    default: !0
                },
                transition: {
                    type: String,
                    default: ""
                },
                options: {
                    type: Object,
                    default: function() {
                        return {}
                    }
                }
            },
            data: function() {
                return {
                    referenceElm: null,
                    popperJS: null,
                    showPopper: !1,
                    currentPlacement: "",
                    popperOptions: {
                        placement: "bottom",
                        gpuAcceleration: !1
                    }
                }
            },
            watch: {
                showPopper: function(t) {
                    t ? (this.$emit("show"), this.updatePopper()) : this.$emit("hide")
                },
                forceShow: {
                    handler: function(t) {
                        this[t ? "doShow" : "doClose"]()
                    },
                    immediate: !0
                }
            },
            created: function() {
                this.appendedArrow = !1, this.appendedToBody = !1, this.popperOptions = r(this.popperOptions, this.options)
            },
            mounted: function() {
                switch (this.referenceElm = this.reference || this.$slots.reference[0].elm, this.popper = this.$slots.default[0].elm, this.trigger) {
                    case "click":
                        e(this.referenceElm, "click", this.doToggle), e(document, "click", this.handleDocumentClick);
                        break;
                    case "hover":
                        e(this.referenceElm, "mouseover", this.onMouseOver), e(this.popper, "mouseover", this.onMouseOver), e(this.referenceElm, "mouseout", this.onMouseOut), e(this.popper, "mouseout", this.onMouseOut)
                }
            },
            methods: {
                doToggle: function() {
                    this.forceShow || (this.showPopper = !this.showPopper)
                },
                doShow: function() {
                    this.showPopper = !0
                },
                doClose: function() {
                    this.showPopper = !1
                },
                doDestroy: function() {
                    this.showPopper || (this.popperJS && (this.popperJS.destroy(), this.popperJS = null), this.appendedToBody && (this.appendedToBody = !1, document.body.removeChild(this.popper.parentElement)))
                },
                createPopper: function() {
                    var e = this;
                    this.$nextTick(function() {
                        if (e.visibleArrow && e.appendArrow(e.popper), e.appendToBody && !e.appendedToBody && (e.appendedToBody = !0, document.body.appendChild(e.popper.parentElement)), e.popperJS && e.popperJS.destroy && e.popperJS.destroy(), e.boundariesSelector) {
                            var i = document.querySelector(e.boundariesSelector);
                            i && (e.popperOptions.modifiers = r({}, e.popperOptions.modifiers), e.popperOptions.modifiers.preventOverflow = r({}, e.popperOptions.modifiers.preventOverflow), e.popperOptions.modifiers.preventOverflow.boundariesElement = i)
                        }
                        e.popperOptions.onCreate = function() {
                            e.$emit("created", e), e.$nextTick(e.updatePopper)
                        }, e.popperJS = new t(e.referenceElm, e.popper, e.popperOptions)
                    })
                },
                destroyPopper: function() {
                    i(this.referenceElm, "click", this.doToggle), i(this.referenceElm, "mouseup", this.doClose), i(this.referenceElm, "mousedown", this.doShow), i(this.referenceElm, "focus", this.doShow), i(this.referenceElm, "blur", this.doClose), i(this.referenceElm, "mouseout", this.onMouseOut), i(this.referenceElm, "mouseover", this.onMouseOver), i(document, "click", this.handleDocumentClick), this.showPopper = !1, this.doDestroy()
                },
                appendArrow: function(t) {
                    if (!this.appendedArrow) {
                        this.appendedArrow = !0;
                        var e = document.createElement("div");
                        e.setAttribute("x-arrow", ""), e.className = "popper__arrow", t.appendChild(e)
                    }
                },
                updatePopper: function() {
                    this.popperJS ? this.popperJS.scheduleUpdate() : this.createPopper()
                },
                onMouseOver: function() {
                    this.showPopper = !0, clearTimeout(this._timer)
                },
                onMouseOut: function() {
                    var t = this;
                    this._timer = setTimeout(function() {
                        t.showPopper = !1
                    }, this.delayOnMouseOut)
                },
                handleDocumentClick: function(t) {
                    this.$el && this.referenceElm && !this.elementContains(this.$el, t.target) && !this.elementContains(this.referenceElm, t.target) && this.popper && !this.elementContains(this.popper, t.target) && (this.$emit("documentClick"), this.forceShow || (this.showPopper = !1))
                },
                elementContains: function(t, e) {
                    return "function" == typeof t.contains && t.contains(e)
                }
            },
            destroyed: function() {
                this.destroyPopper()
            }
        }
    })
}, function(t, e, i) {
    "use strict";
    Object.defineProperty(e, "__esModule", {
            value: !0
        }),
        function(t) {
            function i(t) {
                var e = !1;
                return function() {
                    e || (e = !0, window.Promise.resolve().then(function() {
                        e = !1, t()
                    }))
                }
            }

            function r(t) {
                var e = !1;
                return function() {
                    e || (e = !0, setTimeout(function() {
                        e = !1, t()
                    }, ut))
                }
            }

            function s(t) {
                var e = {};
                return t && "[object Function]" === e.toString.call(t)
            }

            function o(t, e) {
                if (1 !== t.nodeType) return [];
                var i = getComputedStyle(t, null);
                return e ? i[e] : i
            }

            function n(t) {
                return "HTML" === t.nodeName ? t : t.parentNode || t.host
            }

            function a(t) {
                if (!t) return document.body;
                switch (t.nodeName) {
                    case "HTML":
                    case "BODY":
                        return t.ownerDocument.body;
                    case "#document":
                        return t.body
                }
                var e = o(t),
                    i = e.overflow,
                    r = e.overflowX;
                return /(auto|scroll|overlay)/.test(i + e.overflowY + r) ? t : a(n(t))
            }

            function l(t) {
                return 11 === t ? vt : 10 === t ? mt : vt || mt
            }

            function c(t) {
                if (!t) return document.documentElement;
                for (var e = l(10) ? document.body : null, i = t.offsetParent; i === e && t.nextElementSibling;) i = (t = t.nextElementSibling).offsetParent;
                var r = i && i.nodeName;
                return r && "BODY" !== r && "HTML" !== r ? -1 !== ["TD", "TABLE"].indexOf(i.nodeName) && "static" === o(i, "position") ? c(i) : i : t ? t.ownerDocument.documentElement : document.documentElement
            }

            function p(t) {
                var e = t.nodeName;
                return "BODY" !== e && ("HTML" === e || c(t.firstElementChild) === t)
            }

            function u(t) {
                return null !== t.parentNode ? u(t.parentNode) : t
            }

            function h(t, e) {
                if (!(t && t.nodeType && e && e.nodeType)) return document.documentElement;
                var i = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING,
                    r = i ? t : e,
                    s = i ? e : t,
                    o = document.createRange();
                o.setStart(r, 0), o.setEnd(s, 0);
                var n = o.commonAncestorContainer;
                if (t !== n && e !== n || r.contains(s)) return p(n) ? n : c(n);
                var a = u(t);
                return a.host ? h(a.host, e) : h(t, u(e).host)
            }

            function d(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top",
                    i = "top" === e ? "scrollTop" : "scrollLeft",
                    r = t.nodeName;
                if ("BODY" === r || "HTML" === r) {
                    var s = t.ownerDocument.documentElement;
                    return (t.ownerDocument.scrollingElement || s)[i]
                }
                return t[i]
            }

            function f(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                    r = d(e, "top"),
                    s = d(e, "left"),
                    o = i ? -1 : 1;
                return t.top += r * o, t.bottom += r * o, t.left += s * o, t.right += s * o, t
            }

            function v(t, e) {
                var i = "x" === e ? "Left" : "Top",
                    r = "Left" === i ? "Right" : "Bottom";
                return parseFloat(t["border" + i + "Width"], 10) + parseFloat(t["border" + r + "Width"], 10)
            }

            function m(t, e, i, r) {
                return Math.max(e["offset" + t], e["scroll" + t], i["client" + t], i["offset" + t], i["scroll" + t], l(10) ? i["offset" + t] + r["margin" + ("Height" === t ? "Top" : "Left")] + r["margin" + ("Height" === t ? "Bottom" : "Right")] : 0)
            }

            function g() {
                var t = document.body,
                    e = document.documentElement,
                    i = l(10) && getComputedStyle(e);
                return {
                    height: m("Height", t, e, i),
                    width: m("Width", t, e, i)
                }
            }

            function b(t) {
                return yt({}, t, {
                    right: t.left + t.width,
                    bottom: t.top + t.height
                })
            }

            function w(t) {
                var e = {};
                try {
                    if (l(10)) {
                        e = t.getBoundingClientRect();
                        var i = d(t, "top"),
                            r = d(t, "left");
                        e.top += i, e.left += r, e.bottom += i, e.right += r
                    } else e = t.getBoundingClientRect()
                } catch (t) {}
                var s = {
                        left: e.left,
                        top: e.top,
                        width: e.right - e.left,
                        height: e.bottom - e.top
                    },
                    n = "HTML" === t.nodeName ? g() : {},
                    a = n.width || t.clientWidth || s.right - s.left,
                    c = n.height || t.clientHeight || s.bottom - s.top,
                    p = t.offsetWidth - a,
                    u = t.offsetHeight - c;
                if (p || u) {
                    var h = o(t);
                    p -= v(h, "x"), u -= v(h, "y"), s.width -= p, s.height -= u
                }
                return b(s)
            }

            function y(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                    r = l(10),
                    s = "HTML" === e.nodeName,
                    n = w(t),
                    c = w(e),
                    p = a(t),
                    u = o(e),
                    h = parseFloat(u.borderTopWidth, 10),
                    d = parseFloat(u.borderLeftWidth, 10);
                i && "HTML" === e.nodeName && (c.top = Math.max(c.top, 0), c.left = Math.max(c.left, 0));
                var v = b({
                    top: n.top - c.top - h,
                    left: n.left - c.left - d,
                    width: n.width,
                    height: n.height
                });
                if (v.marginTop = 0, v.marginLeft = 0, !r && s) {
                    var m = parseFloat(u.marginTop, 10),
                        g = parseFloat(u.marginLeft, 10);
                    v.top -= h - m, v.bottom -= h - m, v.left -= d - g, v.right -= d - g, v.marginTop = m, v.marginLeft = g
                }
                return (r && !i ? e.contains(p) : e === p && "BODY" !== p.nodeName) && (v = f(v, e)), v
            }

            function _(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                    i = t.ownerDocument.documentElement,
                    r = y(t, i),
                    s = Math.max(i.clientWidth, window.innerWidth || 0),
                    o = Math.max(i.clientHeight, window.innerHeight || 0),
                    n = e ? 0 : d(i),
                    a = e ? 0 : d(i, "left");
                return b({
                    top: n - r.top + r.marginTop,
                    left: a - r.left + r.marginLeft,
                    width: s,
                    height: o
                })
            }

            function x(t) {
                var e = t.nodeName;
                return "BODY" !== e && "HTML" !== e && ("fixed" === o(t, "position") || x(n(t)))
            }

            function C(t) {
                if (!t || !t.parentElement || l()) return document.documentElement;
                for (var e = t.parentElement; e && "none" === o(e, "transform");) e = e.parentElement;
                return e || document.documentElement
            }

            function k(t, e, i, r) {
                var s = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
                    o = {
                        top: 0,
                        left: 0
                    },
                    l = s ? C(t) : h(t, e);
                if ("viewport" === r) o = _(l, s);
                else {
                    var c = void 0;
                    "scrollParent" === r ? (c = a(n(e)), "BODY" === c.nodeName && (c = t.ownerDocument.documentElement)) : c = "window" === r ? t.ownerDocument.documentElement : r;
                    var p = y(c, l, s);
                    if ("HTML" !== c.nodeName || x(l)) o = p;
                    else {
                        var u = g(),
                            d = u.height,
                            f = u.width;
                        o.top += p.top - p.marginTop, o.bottom = d + p.top, o.left += p.left - p.marginLeft, o.right = f + p.left
                    }
                }
                return o.left += i, o.top += i, o.right -= i, o.bottom -= i, o
            }

            function S(t) {
                return t.width * t.height
            }

            function E(t, e, i, r, s) {
                var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
                if (-1 === t.indexOf("auto")) return t;
                var n = k(i, r, o, s),
                    a = {
                        top: {
                            width: n.width,
                            height: e.top - n.top
                        },
                        right: {
                            width: n.right - e.right,
                            height: n.height
                        },
                        bottom: {
                            width: n.width,
                            height: n.bottom - e.bottom
                        },
                        left: {
                            width: e.left - n.left,
                            height: n.height
                        }
                    },
                    l = Object.keys(a).map(function(t) {
                        return yt({
                            key: t
                        }, a[t], {
                            area: S(a[t])
                        })
                    }).sort(function(t, e) {
                        return e.area - t.area
                    }),
                    c = l.filter(function(t) {
                        var e = t.width,
                            r = t.height;
                        return e >= i.clientWidth && r >= i.clientHeight
                    }),
                    p = c.length > 0 ? c[0].key : l[0].key,
                    u = t.split("-")[1];
                return p + (u ? "-" + u : "")
            }

            function D(t, e, i) {
                var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                return y(i, r ? C(e) : h(e, i), r)
            }

            function P(t) {
                var e = getComputedStyle(t),
                    i = parseFloat(e.marginTop) + parseFloat(e.marginBottom),
                    r = parseFloat(e.marginLeft) + parseFloat(e.marginRight);
                return {
                    width: t.offsetWidth + r,
                    height: t.offsetHeight + i
                }
            }

            function I(t) {
                var e = {
                    left: "right",
                    right: "left",
                    bottom: "top",
                    top: "bottom"
                };
                return t.replace(/left|right|bottom|top/g, function(t) {
                    return e[t]
                })
            }

            function M(t, e, i) {
                i = i.split("-")[0];
                var r = P(t),
                    s = {
                        width: r.width,
                        height: r.height
                    },
                    o = -1 !== ["right", "left"].indexOf(i),
                    n = o ? "top" : "left",
                    a = o ? "left" : "top",
                    l = o ? "height" : "width",
                    c = o ? "width" : "height";
                return s[n] = e[n] + e[l] / 2 - r[l] / 2, s[a] = i === a ? e[a] - r[c] : e[I(a)], s
            }

            function T(t, e) {
                return Array.prototype.find ? t.find(e) : t.filter(e)[0]
            }

            function O(t, e, i) {
                if (Array.prototype.findIndex) return t.findIndex(function(t) {
                    return t[e] === i
                });
                var r = T(t, function(t) {
                    return t[e] === i
                });
                return t.indexOf(r)
            }

            function L(t, e, i) {
                return (void 0 === i ? t : t.slice(0, O(t, "name", i))).forEach(function(t) {
                    t.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
                    var i = t.function || t.fn;
                    t.enabled && s(i) && (e.offsets.popper = b(e.offsets.popper), e.offsets.reference = b(e.offsets.reference), e = i(e, t))
                }), e
            }

            function A() {
                if (!this.state.isDestroyed) {
                    var t = {
                        instance: this,
                        styles: {},
                        arrowStyles: {},
                        attributes: {},
                        flipped: !1,
                        offsets: {}
                    };
                    t.offsets.reference = D(this.state, this.popper, this.reference, this.options.positionFixed), t.placement = E(this.options.placement, t.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), t.originalPlacement = t.placement, t.positionFixed = this.options.positionFixed, t.offsets.popper = M(this.popper, t.offsets.reference, t.placement), t.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", t = L(this.modifiers, t), this.state.isCreated ? this.options.onUpdate(t) : (this.state.isCreated = !0, this.options.onCreate(t))
                }
            }

            function V(t, e) {
                return t.some(function(t) {
                    var i = t.name;
                    return t.enabled && i === e
                })
            }

            function N(t) {
                for (var e = [!1, "ms", "Webkit", "Moz", "O"], i = t.charAt(0).toUpperCase() + t.slice(1), r = 0; r < e.length; r++) {
                    var s = e[r],
                        o = s ? "" + s + i : t;
                    if (void 0 !== document.body.style[o]) return o
                }
                return null
            }

            function z() {
                return this.state.isDestroyed = !0, V(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[N("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this
            }

            function F(t) {
                var e = t.ownerDocument;
                return e ? e.defaultView : window
            }

            function R(t, e, i, r) {
                var s = "BODY" === t.nodeName,
                    o = s ? t.ownerDocument.defaultView : t;
                o.addEventListener(e, i, {
                    passive: !0
                }), s || R(a(o.parentNode), e, i, r), r.push(o)
            }

            function B(t, e, i, r) {
                i.updateBound = r, F(t).addEventListener("resize", i.updateBound, {
                    passive: !0
                });
                var s = a(t);
                return R(s, "scroll", i.updateBound, i.scrollParents), i.scrollElement = s, i.eventsEnabled = !0, i
            }

            function H() {
                this.state.eventsEnabled || (this.state = B(this.reference, this.options, this.state, this.scheduleUpdate))
            }

            function $(t, e) {
                return F(t).removeEventListener("resize", e.updateBound), e.scrollParents.forEach(function(t) {
                    t.removeEventListener("scroll", e.updateBound)
                }), e.updateBound = null, e.scrollParents = [], e.scrollElement = null, e.eventsEnabled = !1, e
            }

            function j() {
                this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = $(this.reference, this.state))
            }

            function W(t) {
                return "" !== t && !isNaN(parseFloat(t)) && isFinite(t)
            }

            function G(t, e) {
                Object.keys(e).forEach(function(i) {
                    var r = ""; - 1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(i) && W(e[i]) && (r = "px"), t.style[i] = e[i] + r
                })
            }

            function q(t, e) {
                Object.keys(e).forEach(function(i) {
                    !1 !== e[i] ? t.setAttribute(i, e[i]) : t.removeAttribute(i)
                })
            }

            function Y(t) {
                return G(t.instance.popper, t.styles), q(t.instance.popper, t.attributes), t.arrowElement && Object.keys(t.arrowStyles).length && G(t.arrowElement, t.arrowStyles), t
            }

            function U(t, e, i, r, s) {
                var o = D(s, e, t, i.positionFixed),
                    n = E(i.placement, o, e, t, i.modifiers.flip.boundariesElement, i.modifiers.flip.padding);
                return e.setAttribute("x-placement", n), G(e, {
                    position: i.positionFixed ? "fixed" : "absolute"
                }), i
            }

            function K(t, e) {
                var i = e.x,
                    r = e.y,
                    s = t.offsets.popper,
                    o = T(t.instance.modifiers, function(t) {
                        return "applyStyle" === t.name
                    }).gpuAcceleration;
                void 0 !== o && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                var n = void 0 !== o ? o : e.gpuAcceleration,
                    a = c(t.instance.popper),
                    l = w(a),
                    p = {
                        position: s.position
                    },
                    u = {
                        left: Math.floor(s.left),
                        top: Math.round(s.top),
                        bottom: Math.round(s.bottom),
                        right: Math.floor(s.right)
                    },
                    h = "bottom" === i ? "top" : "bottom",
                    d = "right" === r ? "left" : "right",
                    f = N("transform"),
                    v = void 0,
                    m = void 0;
                if (m = "bottom" === h ? -l.height + u.bottom : u.top, v = "right" === d ? -l.width + u.right : u.left, n && f) p[f] = "translate3d(" + v + "px, " + m + "px, 0)", p[h] = 0, p[d] = 0, p.willChange = "transform";
                else {
                    var g = "bottom" === h ? -1 : 1,
                        b = "right" === d ? -1 : 1;
                    p[h] = m * g, p[d] = v * b, p.willChange = h + ", " + d
                }
                var y = {
                    "x-placement": t.placement
                };
                return t.attributes = yt({}, y, t.attributes), t.styles = yt({}, p, t.styles), t.arrowStyles = yt({}, t.offsets.arrow, t.arrowStyles), t
            }

            function J(t, e, i) {
                var r = T(t, function(t) {
                        return t.name === e
                    }),
                    s = !!r && t.some(function(t) {
                        return t.name === i && t.enabled && t.order < r.order
                    });
                if (!s) {
                    var o = "`" + e + "`",
                        n = "`" + i + "`";
                    console.warn(n + " modifier is required by " + o + " modifier in order to work, be sure to include it before " + o + "!")
                }
                return s
            }

            function X(t, e) {
                var i;
                if (!J(t.instance.modifiers, "arrow", "keepTogether")) return t;
                var r = e.element;
                if ("string" == typeof r) {
                    if (!(r = t.instance.popper.querySelector(r))) return t
                } else if (!t.instance.popper.contains(r)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), t;
                var s = t.placement.split("-")[0],
                    n = t.offsets,
                    a = n.popper,
                    l = n.reference,
                    c = -1 !== ["left", "right"].indexOf(s),
                    p = c ? "height" : "width",
                    u = c ? "Top" : "Left",
                    h = u.toLowerCase(),
                    d = c ? "left" : "top",
                    f = c ? "bottom" : "right",
                    v = P(r)[p];
                l[f] - v < a[h] && (t.offsets.popper[h] -= a[h] - (l[f] - v)), l[h] + v > a[f] && (t.offsets.popper[h] += l[h] + v - a[f]), t.offsets.popper = b(t.offsets.popper);
                var m = l[h] + l[p] / 2 - v / 2,
                    g = o(t.instance.popper),
                    w = parseFloat(g["margin" + u], 10),
                    y = parseFloat(g["border" + u + "Width"], 10),
                    _ = m - t.offsets.popper[h] - w - y;
                return _ = Math.max(Math.min(a[p] - v, _), 0), t.arrowElement = r, t.offsets.arrow = (i = {}, wt(i, h, Math.round(_)), wt(i, d, ""), i), t
            }

            function Q(t) {
                return "end" === t ? "start" : "start" === t ? "end" : t
            }

            function Z(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                    i = xt.indexOf(t),
                    r = xt.slice(i + 1).concat(xt.slice(0, i));
                return e ? r.reverse() : r
            }

            function tt(t, e) {
                if (V(t.instance.modifiers, "inner")) return t;
                if (t.flipped && t.placement === t.originalPlacement) return t;
                var i = k(t.instance.popper, t.instance.reference, e.padding, e.boundariesElement, t.positionFixed),
                    r = t.placement.split("-")[0],
                    s = I(r),
                    o = t.placement.split("-")[1] || "",
                    n = [];
                switch (e.behavior) {
                    case Ct.FLIP:
                        n = [r, s];
                        break;
                    case Ct.CLOCKWISE:
                        n = Z(r);
                        break;
                    case Ct.COUNTERCLOCKWISE:
                        n = Z(r, !0);
                        break;
                    default:
                        n = e.behavior
                }
                return n.forEach(function(a, l) {
                    if (r !== a || n.length === l + 1) return t;
                    r = t.placement.split("-")[0], s = I(r);
                    var c = t.offsets.popper,
                        p = t.offsets.reference,
                        u = Math.floor,
                        h = "left" === r && u(c.right) > u(p.left) || "right" === r && u(c.left) < u(p.right) || "top" === r && u(c.bottom) > u(p.top) || "bottom" === r && u(c.top) < u(p.bottom),
                        d = u(c.left) < u(i.left),
                        f = u(c.right) > u(i.right),
                        v = u(c.top) < u(i.top),
                        m = u(c.bottom) > u(i.bottom),
                        g = "left" === r && d || "right" === r && f || "top" === r && v || "bottom" === r && m,
                        b = -1 !== ["top", "bottom"].indexOf(r),
                        w = !!e.flipVariations && (b && "start" === o && d || b && "end" === o && f || !b && "start" === o && v || !b && "end" === o && m);
                    (h || g || w) && (t.flipped = !0, (h || g) && (r = n[l + 1]), w && (o = Q(o)), t.placement = r + (o ? "-" + o : ""), t.offsets.popper = yt({}, t.offsets.popper, M(t.instance.popper, t.offsets.reference, t.placement)), t = L(t.instance.modifiers, t, "flip"))
                }), t
            }

            function et(t) {
                var e = t.offsets,
                    i = e.popper,
                    r = e.reference,
                    s = t.placement.split("-")[0],
                    o = Math.floor,
                    n = -1 !== ["top", "bottom"].indexOf(s),
                    a = n ? "right" : "bottom",
                    l = n ? "left" : "top",
                    c = n ? "width" : "height";
                return i[a] < o(r[l]) && (t.offsets.popper[l] = o(r[l]) - i[c]), i[l] > o(r[a]) && (t.offsets.popper[l] = o(r[a])), t
            }

            function it(t, e, i, r) {
                var s = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
                    o = +s[1],
                    n = s[2];
                if (!o) return t;
                if (0 === n.indexOf("%")) {
                    var a = void 0;
                    switch (n) {
                        case "%p":
                            a = i;
                            break;
                        case "%":
                        case "%r":
                        default:
                            a = r
                    }
                    return b(a)[e] / 100 * o
                }
                if ("vh" === n || "vw" === n) {
                    return ("vh" === n ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * o
                }
                return o
            }

            function rt(t, e, i, r) {
                var s = [0, 0],
                    o = -1 !== ["right", "left"].indexOf(r),
                    n = t.split(/(\+|\-)/).map(function(t) {
                        return t.trim()
                    }),
                    a = n.indexOf(T(n, function(t) {
                        return -1 !== t.search(/,|\s/)
                    }));
                n[a] && -1 === n[a].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
                var l = /\s*,\s*|\s+/,
                    c = -1 !== a ? [n.slice(0, a).concat([n[a].split(l)[0]]), [n[a].split(l)[1]].concat(n.slice(a + 1))] : [n];
                return c = c.map(function(t, r) {
                    var s = (1 === r ? !o : o) ? "height" : "width",
                        n = !1;
                    return t.reduce(function(t, e) {
                        return "" === t[t.length - 1] && -1 !== ["+", "-"].indexOf(e) ? (t[t.length - 1] = e, n = !0, t) : n ? (t[t.length - 1] += e, n = !1, t) : t.concat(e)
                    }, []).map(function(t) {
                        return it(t, s, e, i)
                    })
                }), c.forEach(function(t, e) {
                    t.forEach(function(i, r) {
                        W(i) && (s[e] += i * ("-" === t[r - 1] ? -1 : 1))
                    })
                }), s
            }

            function st(t, e) {
                var i = e.offset,
                    r = t.placement,
                    s = t.offsets,
                    o = s.popper,
                    n = s.reference,
                    a = r.split("-")[0],
                    l = void 0;
                return l = W(+i) ? [+i, 0] : rt(i, o, n, a), "left" === a ? (o.top += l[0], o.left -= l[1]) : "right" === a ? (o.top += l[0], o.left += l[1]) : "top" === a ? (o.left += l[0], o.top -= l[1]) : "bottom" === a && (o.left += l[0], o.top += l[1]), t.popper = o, t
            }

            function ot(t, e) {
                var i = e.boundariesElement || c(t.instance.popper);
                t.instance.reference === i && (i = c(i));
                var r = N("transform"),
                    s = t.instance.popper.style,
                    o = s.top,
                    n = s.left,
                    a = s[r];
                s.top = "", s.left = "", s[r] = "";
                var l = k(t.instance.popper, t.instance.reference, e.padding, i, t.positionFixed);
                s.top = o, s.left = n, s[r] = a, e.boundaries = l;
                var p = e.priority,
                    u = t.offsets.popper,
                    h = {
                        primary: function(t) {
                            var i = u[t];
                            return u[t] < l[t] && !e.escapeWithReference && (i = Math.max(u[t], l[t])), wt({}, t, i)
                        },
                        secondary: function(t) {
                            var i = "right" === t ? "left" : "top",
                                r = u[i];
                            return u[t] > l[t] && !e.escapeWithReference && (r = Math.min(u[i], l[t] - ("right" === t ? u.width : u.height))), wt({}, i, r)
                        }
                    };
                return p.forEach(function(t) {
                    var e = -1 !== ["left", "top"].indexOf(t) ? "primary" : "secondary";
                    u = yt({}, u, h[e](t))
                }), t.offsets.popper = u, t
            }

            function nt(t) {
                var e = t.placement,
                    i = e.split("-")[0],
                    r = e.split("-")[1];
                if (r) {
                    var s = t.offsets,
                        o = s.reference,
                        n = s.popper,
                        a = -1 !== ["bottom", "top"].indexOf(i),
                        l = a ? "left" : "top",
                        c = a ? "width" : "height",
                        p = {
                            start: wt({}, l, o[l]),
                            end: wt({}, l, o[l] + o[c] - n[c])
                        };
                    t.offsets.popper = yt({}, n, p[r])
                }
                return t
            }

            function at(t) {
                if (!J(t.instance.modifiers, "hide", "preventOverflow")) return t;
                var e = t.offsets.reference,
                    i = T(t.instance.modifiers, function(t) {
                        return "preventOverflow" === t.name
                    }).boundaries;
                if (e.bottom < i.top || e.left > i.right || e.top > i.bottom || e.right < i.left) {
                    if (!0 === t.hide) return t;
                    t.hide = !0, t.attributes["x-out-of-boundaries"] = ""
                } else {
                    if (!1 === t.hide) return t;
                    t.hide = !1, t.attributes["x-out-of-boundaries"] = !1
                }
                return t
            }

            function lt(t) {
                var e = t.placement,
                    i = e.split("-")[0],
                    r = t.offsets,
                    s = r.popper,
                    o = r.reference,
                    n = -1 !== ["left", "right"].indexOf(i),
                    a = -1 === ["top", "left"].indexOf(i);
                return s[n ? "left" : "top"] = o[i] - (a ? s[n ? "width" : "height"] : 0), t.placement = I(e), t.offsets.popper = b(s), t
            }
            for (var ct = "undefined" != typeof window && "undefined" != typeof document, pt = ["Edge", "Trident", "Firefox"], ut = 0, ht = 0; ht < pt.length; ht += 1)
                if (ct && navigator.userAgent.indexOf(pt[ht]) >= 0) {
                    ut = 1;
                    break
                } var dt = ct && window.Promise,
                ft = dt ? i : r,
                vt = ct && !(!window.MSInputMethodContext || !document.documentMode),
                mt = ct && /MSIE 10/.test(navigator.userAgent),
                gt = function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
                },
                bt = function() {
                    function t(t, e) {
                        for (var i = 0; i < e.length; i++) {
                            var r = e[i];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r)
                        }
                    }
                    return function(e, i, r) {
                        return i && t(e.prototype, i), r && t(e, r), e
                    }
                }(),
                wt = function(t, e, i) {
                    return e in t ? Object.defineProperty(t, e, {
                        value: i,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[e] = i, t
                },
                yt = Object.assign || function(t) {
                    for (var e = 1; e < arguments.length; e++) {
                        var i = arguments[e];
                        for (var r in i) Object.prototype.hasOwnProperty.call(i, r) && (t[r] = i[r])
                    }
                    return t
                },
                _t = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"],
                xt = _t.slice(3),
                Ct = {
                    FLIP: "flip",
                    CLOCKWISE: "clockwise",
                    COUNTERCLOCKWISE: "counterclockwise"
                },
                kt = {
                    shift: {
                        order: 100,
                        enabled: !0,
                        fn: nt
                    },
                    offset: {
                        order: 200,
                        enabled: !0,
                        fn: st,
                        offset: 0
                    },
                    preventOverflow: {
                        order: 300,
                        enabled: !0,
                        fn: ot,
                        priority: ["left", "right", "top", "bottom"],
                        padding: 5,
                        boundariesElement: "scrollParent"
                    },
                    keepTogether: {
                        order: 400,
                        enabled: !0,
                        fn: et
                    },
                    arrow: {
                        order: 500,
                        enabled: !0,
                        fn: X,
                        element: "[x-arrow]"
                    },
                    flip: {
                        order: 600,
                        enabled: !0,
                        fn: tt,
                        behavior: "flip",
                        padding: 5,
                        boundariesElement: "viewport"
                    },
                    inner: {
                        order: 700,
                        enabled: !1,
                        fn: lt
                    },
                    hide: {
                        order: 800,
                        enabled: !0,
                        fn: at
                    },
                    computeStyle: {
                        order: 850,
                        enabled: !0,
                        fn: K,
                        gpuAcceleration: !0,
                        x: "bottom",
                        y: "right"
                    },
                    applyStyle: {
                        order: 900,
                        enabled: !0,
                        fn: Y,
                        onLoad: U,
                        gpuAcceleration: void 0
                    }
                },
                St = {
                    placement: "bottom",
                    positionFixed: !1,
                    eventsEnabled: !0,
                    removeOnDestroy: !1,
                    onCreate: function() {},
                    onUpdate: function() {},
                    modifiers: kt
                },
                Et = function() {
                    function t(e, i) {
                        var r = this,
                            o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        gt(this, t), this.scheduleUpdate = function() {
                            return requestAnimationFrame(r.update)
                        }, this.update = ft(this.update.bind(this)), this.options = yt({}, t.Defaults, o), this.state = {
                            isDestroyed: !1,
                            isCreated: !1,
                            scrollParents: []
                        }, this.reference = e && e.jquery ? e[0] : e, this.popper = i && i.jquery ? i[0] : i, this.options.modifiers = {}, Object.keys(yt({}, t.Defaults.modifiers, o.modifiers)).forEach(function(e) {
                            r.options.modifiers[e] = yt({}, t.Defaults.modifiers[e] || {}, o.modifiers ? o.modifiers[e] : {})
                        }), this.modifiers = Object.keys(this.options.modifiers).map(function(t) {
                            return yt({
                                name: t
                            }, r.options.modifiers[t])
                        }).sort(function(t, e) {
                            return t.order - e.order
                        }), this.modifiers.forEach(function(t) {
                            t.enabled && s(t.onLoad) && t.onLoad(r.reference, r.popper, r.options, t, r.state)
                        }), this.update();
                        var n = this.options.eventsEnabled;
                        n && this.enableEventListeners(), this.state.eventsEnabled = n
                    }
                    return bt(t, [{
                        key: "update",
                        value: function() {
                            return A.call(this)
                        }
                    }, {
                        key: "destroy",
                        value: function() {
                            return z.call(this)
                        }
                    }, {
                        key: "enableEventListeners",
                        value: function() {
                            return H.call(this)
                        }
                    }, {
                        key: "disableEventListeners",
                        value: function() {
                            return j.call(this)
                        }
                    }]), t
                }();
            Et.Utils = ("undefined" != typeof window ? window : t).PopperUtils, Et.placements = _t, Et.Defaults = St, e.default = Et
        }.call(e, i(1))
}], [2]);
if ($("#back-to-top").length) {
    var scrollTrigger = 1e3,
        backToTop = function() {
            $(window).scrollTop() > scrollTrigger ? $("#back-to-top").addClass("show") : $("#back-to-top").removeClass("show")
        };

    function scrollToTop(o) {
        scrollHeight = window.scrollY, scrollStep = Math.PI / (o / 15), cosParameter = scrollHeight / 2;
        var l, r = 0,
            c = setInterval(function() {
                0 != window.scrollY ? (r += 1, l = cosParameter - cosParameter * Math.cos(r * scrollStep), window.scrollTo(0, scrollHeight - l)) : clearInterval(c)
            }, 15)
    }
    backToTop(), $(window).on("scroll", function() {
        backToTop()
    })
}